"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  locales_EN: () => locales_EN,
  locales_ES: () => locales_ES
});
module.exports = __toCommonJS(src_exports);

// src/locales/en.ts
var locales_EN = {
  // ACCESSIBLE SECTIONS
  "accessibleSection.DIGITAL_DOSSIER": "Digital Dossier",
  "accessibleSection.CONTACT_INFORMATION": "Contact information",
  "accessibleSection.DECLARED_JURISDICTIONS": "Affidavits",
  "accessibleSection.ASSET_INFORMATION": "Asset information",
  // COMPANY_ACTIVITIES
  "companyActivities.PRODUCER": "Producer",
  "companyActivities.RUNNER": "Runner",
  "companyActivities.CEREAL_MARKET_AT_THE_END": "Cereal market at the end",
  "companyActivities.OPERATOR_WITH_PLANT": "Operator with plant",
  "companyActivities.OPERATOR_WITHOUT_PLANT": "Operator without plant",
  "companyActivities.EXCHANGER": "Exchanger",
  // COMPANY_TYPES
  "companyTypes.PF": "Physical person",
  "companyTypes.SH": "De facto companies",
  "companyTypes.SA": "Company",
  "companyTypes.SRL": "Limited liability company",
  "companyTypes.SAS": "Simplified public limited company",
  "companyTypes.SAU": "Single-member public limited company",
  "companyTypes.COOP": "Cooperative",
  "companyTypes.AS": "Civil associations",
  "companyTypes.FUND": "Foundations",
  "companyTypes.FID": "Trusts",
  "companyTypes.OTHER": "Other",
  // SISA_ACTIVITIES
  "sisaActivities.PRODUCER": "Producer",
  "sisaActivities.BROKER": "Productor",
  "sisaActivities.OPERATOR_WITH_A_PLANT": "Operator with a plant",
  "sisaActivities.OPERATOR_WITHOUT_A_PLANT": "Operator without a plant",
  "sisaActivities.BARTERER": "Barterer",
  "sisaActivities.FUTURES_GRAIN_MARKET": "Barterer",
  // SISA_SCORING
  "sisaScoring.SITUATION_1": "Situation 1",
  "sisaScoring.SITUATION_2": "Situation 2",
  "sisaScoring.SITUATION_3": "Situation 3",
  // RUCA_STATUSES
  "rucaStatus.CURRENT": "Current",
  "rucaStatus.NOT_CURRENT": "Not current",
  // MARITAL_STATUSES
  "maritalStatus.SINGLE": "Single",
  "maritalStatus.MARRIED": "Married",
  "maritalStatus.DIVORCED": "Divorced",
  "maritalStatus.WIDOWED": "Widowed",
  // COMMON
  "common.downloadPdf": "Download PDF",
  "common.seeInBlockchain": "View in Blockchain",
  "common.genericError": "An error occurred. Please try again later.",
  "common.yes": "Yes",
  "common.no": "No",
  "common.reset": "Reset",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.clear": "Clear",
  "common.close": "Close",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.date": "Date",
  "common.loading": "Loading",
  "common.noResults": "No results found",
  "common.error": "Error",
  "common.success": "Success",
  "common.warning": "Warning",
  "common.info": "Information",
  "common.confirm": "Confirm",
  "common.areYouSure": "Are you sure?",
  "common.areYouSureDelete": "Are you sure you want to delete?",
  "common.areYouSureCancel": "Are you sure you want to cancel?",
  "common.areYouSureSave": "Are you sure you want to save?",
  "common.digitalDossiers": "Digital Dossiers",
  "common.cropPledges": "Crop Pledges",
  "common.viewDetail": "View detail",
  "common.digitalDossier": "Digital Dossier",
  "common.companyName": "Company Name",
  "common.socialReason": "Social reason",
  "common.fiscalId": "Fiscal ID",
  "common.table.emptyState": "Adjust search options and filters to find what you are looking for",
  "common.CUIT": "CUIT",
  "common.CUIL": "CUIL",
  "common.DNI": "DNI",
  "common.CUIT/CUIL": "CUIT/CUIL",
  "common.password": "Password",
  "common.email": "Email",
  "common.confirmationCode": "Confirmation code",
  "common.signUpRequests": "Signup requests",
  "common.lastLogin": "Last login",
  "common.logout": "Log Out",
  "common.approve": "Approve",
  "common.reject": "Reject",
  "common.revokeAccess": "Revoke access",
  "common.renewAccessRequest": "Renew access",
  "common.renew": "Renew",
  "common.succesfullyRenewed": "Successfully renewed",
  "common.rejectRequest": "Reject request",
  "common.requestReview": "Request review",
  "common.submitReviewRequest": "Send review request",
  "common.street": "Street",
  "common.number": "Number",
  "common.province": "Province",
  "common.locality": "Locality",
  "common.name": "Name",
  "common.lastName": "Last name",
  "common.phone": "Phone",
  "common.document": "Document",
  "common.documentType": "Document type",
  "common.documentIdentifier": "Document identifier",
  "common.dueDate": "Due date",
  "common.postalCode": "Postal code",
  "common.exchange": "Exchange with which it operates",
  "common.socialType": "Social type",
  "common.mobile": "Mobile",
  "common.position": "Position",
  "common.web": "Web",
  "common.reasonForRejection": "Reason for rejection",
  "common.saveAndApprove": "Save and approve",
  "common.saveChanges": "Save changes",
  "common.approveChanges": "Approve information",
  "common.contactInformation": "Contact information",
  "common.affidavit": "Affidavit",
  "common.affidavits": "Affidavits",
  "common.establishments": "Establishments",
  "common.equityInformation": "Equity information",
  "common.companyGeneralInformation": "Company general information",
  "common.bankData": "Bank data",
  "common.taxData": "Tax data",
  "common.legalRepresentatives": "Legal representatives",
  "common.documentationAndForms": "Documentation and forms",
  "common.companyType": "Type of company",
  "common.mainActivity": "Main activity",
  "common.startDateOfActivity": "Start date of activity",
  "common.endDateOfActivity": "End date of activity",
  "common.startDateOfTerm": "Start date of term",
  "common.endDateOfTerm": "End date of term",
  "common.RUCA": "RUCA",
  "common.IGJ": "IGJ/Reg P\xFAblico de Comercio",
  "common.sisaActivity": "SISA Activity",
  "common.sisaActivity.placeholder": "Select activity",
  "common.sisaScoring": "SISA Scoring",
  "common.signatureSchema": "Signature schema",
  "common.signatureLevel": "Signature level",
  "common.powerByBolsa": "Power by Bolsa",
  "common.amount": "Amount",
  "common.currency": "Currency",
  "common.product": "Product",
  "common.tons": "Tons",
  "common.activity": "Activity",
  "common.toBeCompletedByBolsa": "To be completed by Bolsa",
  "common.toBeUploadedByBolsa": "To be uploaded by Bolsa",
  "common.toBeCompletedByCreditor": "To be completed by creditor",
  "common.requestApproval": "Request approval",
  "common.updateData": "Update data",
  "common.lastUpdate": "last update {{lastUpdate}}",
  "common.selectActivity": "Select activity",
  "common.error.loadingGeneralInformation": "Error loading general company information",
  "common.error.loadingData": "Error loading data",
  "common.fileUpload.disabled": "Press `Update data` to enable file upload",
  "common.requestApproval.toast.success": "Request for approval sent successfully",
  "common.approve.toast.success": "This section has been approved successfully.",
  "common.update.toast.success": "The information was successfully updated",
  "common.expirationDate.label": "Expiration Date",
  "common.expirationDate.placeholder": "Select date",
  "common.documentId.label": "Document Identifier",
  "common.documentId.placeholder": "Enter identifier",
  "common.typeNumber.placeholder": "Type number",
  "common.producers": "Producers",
  "common.stockpiles": "Stockpiles",
  "common.error.greaterOrEqualThanZero": "Value must be equal or greater than 0",
  "common.error.greaterOrEqualThanOne": "Value must be equal or greater than 1",
  "common.error.valueMustBeANumber": "Value must be a number",
  "common.commentsOrObservations": "Comments or observations",
  "common.seeDetails": "See details",
  "common.nationality": "Nationality",
  "common.birthDate": "Birth date",
  "common.maritalStatus": "Marital status",
  "common.user.name": "Name",
  "common.user.lastName": "Last Name",
  "common.user.documentType": "Document type",
  "common.user.document": "Document",
  "common.user.position": "Position",
  "common.user.email": "Email",
  "common.user.mobile": "Mobile",
  "common.user.CUIT/CUIL": "CUIT/CUIL",
  "common.company.name": "Name",
  "common.company.fiscalId": "CUIT",
  "common.company.streetName": "Street",
  "common.company.streetNumber": "Number",
  "common.company.postalCode": "Postal code",
  "common.company.exchange": "Exchange",
  "common.company.companyType": "Social type",
  "common.birthDate.label": "Birthday",
  "common.birthDate.placeholder": "Select date",
  "common.maritalStatus.label": "Marital status",
  "common.maritalStatus.placeholder": "Select marital status",
  "common.nationality.label": "Nationality",
  "common.nationality.placeholder": "Select nationality",
  "common.toast.error.title": "An error occurred",
  "common.toast.error.text": "Please try again later.",
  "common.toast.error.reCaptcha": "Error while getting ReCaptcha token. Please try again later.",
  "common.toast.error.reCaptchaNotAvailable": "ReCaptcha validation not available. Please try again later.",
  "common.toast.error.CROP_PLEDGE_INVALID_CREDITOR_SELECTION.text": "The CUIT entered cannot be assigned as a creditor.",
  "common.toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.text": "The admitted CUIT does not have its digital dossier uploaded and approved",
  "common.toast.error.CROP_PLEDGE_NO_EMAIL.text": "The CUIT entered does not have an associated email",
  "common.toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.text": "The CUIT entered does not have an associated phone number",
  "common.noOptionsMessage": "Your search did not match any results. Please try again.",
  // COMMON TABLES
  "common.table.search.placeholder": "Search by CUIT or company",
  "common.table.statusFilter.allText": "All",
  // COMMON ROUTES
  "common.navigation.route.cropPledge": "Crop pledge",
  // COMMON UPLOAD S3 FILE
  "common.uploadFile.clickHereMessage": "Click here to select a file",
  "common.uploadFile.orDropTheFileMessage": "Or drop the file here",
  "common.uploadFile.tryAgainMessage": "Try again",
  "common.uploadFile.fileInvalidTypeMessage": "Invalid file type",
  "common.uploadFile.fileTooLargeMessage": "File is too large",
  "common.uploadFile.fileTooSmallMessage": "File is too small",
  "common.uploadFile.tooManyFilesMessage": "Too many files",
  "common.uploadFile.uploadError": "Error uploading file. Please try again later.",
  // COMMON MARITAL STATUS
  "common.maritalStatus.SINGLE": "Single",
  "common.maritalStatus.MARRIED": "Married",
  "common.maritalStatus.DIVORCED": "Divorced",
  "common.maritalStatus.WIDOWED": "Widowed",
  // COMMON CROP PLEDGES
  "cropPledge.section.debtorInfo.title.label": "Debtor data",
  "cropPledge.section.debtorInfo.subtitle.label": "Title legal representative ",
  "cropPledge.section.fieldInfo.label": "Field information",
  "cropPledge.section.creditorInfo.label": "Creditor information",
  "cropPledge.section.document.label": "Document",
  "cropPledge.section.cropPledgeInfo.label": "Crop pledge information",
  "cropPledge.section.insuranceInfo.label": "Insurance",
  // PLEDGE SECTION STATUS
  "cropPledge.section.status.PENDING_DEBTOR_LOAD": "Pending data load by debtor",
  "cropPledge.section.status.PENDING_BOLSA_LOAD": "Pending data load by Bolsa",
  "cropPledge.section.status.PENDING_CREDITOR_LOAD": "Pending data load by creditor",
  "cropPledge.section.status.PENDING_BOLSA_APPROVAL": "Pending approval by Bolsa",
  "cropPledge.section.status.PENDING_CREDITOR_APPROVAL": "Pending approval by creditor",
  "cropPledge.section.status.APPROVED": "Aproved",
  // PLEDGE STATUS
  "cropPledge.status.PENDING_DEBTOR_LOAD": "Pending data load by debtor",
  "cropPledge.status.PENDING_BOLSA_LOAD": "Pending data load by Bolsa",
  "cropPledge.status.PENDING_CREDITOR_LOAD": "Pending data load by creditor",
  "cropPledge.status.PENDING_BOLSA_FARM_LOAD": "Pending data load by Bolsa",
  "cropPledge.status.PENDING_DEBTOR_DOCUMENTATION_LOAD": "Pending documentation load by debtor",
  "cropPledge.status.PENDING_BOLSA_APPROVAL": "Pending approval by Bolsa",
  "cropPledge.status.PENDING_CREDITOR_APPROVAL": "Pending approval by creditor",
  "cropPledge.status.PENDING_REGISTRATION": "Pending registration",
  "cropPledge.status.PENDING_REGISTRATION_BLOCKCHAIN": "Registration in progress",
  "cropPledge.status.REJECTED": "Rejected",
  "cropPledge.status.REGISTERED": "Registered",
  "cropPledge.status.PENDING_RELEASE": "Pending release",
  "cropPledge.status.RELEASED": "Released",
  // PLEDGE STATUS SECTIONS
  "cropPledge.statusSection.PENDING_DEBTOR_LOAD": "Pending data load by debtor",
  "cropPledge.statusSection.PENDING_BOLSA_LOAD": "Pending data load by Bolsa",
  "cropPledge.statusSection.PENDING_CREDITOR_LOAD": "Pending data load by creditor",
  "cropPledge.statusSection.PENDING_BOLSA_APPROVAL": "Pending approval by Bolsa",
  "cropPledge.statusSection.PENDING_CREDITOR_APPROVAL": "Pending approval by creditor",
  "cropPledge.statusSection.APPROVED": "Approved",
  // PLEDGE STATUS TOOLTIPS BY ROLE
  "cropPledge.section.disabled.tooltip": "This section will be enabled once the Exchange and the debtor have entered all the required information.",
  // DEBTOR
  "cropPledge.status.DEBTOR.PENDING_DEBTOR_LOAD.tooltip": "You have pending data to load.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_LOAD.tooltip": "The data is pending to be loaded by the Stock Exchange.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_FARM_LOAD.tooltip": "The data is pending to be loaded by the Stock Exchange.",
  "cropPledge.status.DEBTOR.PENDING_CREDITOR_LOAD.tooltip": "The data is pending to be loaded by the creditor.",
  "cropPledge.status.DEBTOR.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "You have pending documentation data to load.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_APPROVAL.tooltip": "The data is pending approval by the Stock Exchange.",
  "cropPledge.status.DEBTOR.PENDING_CREDITOR_APPROVAL.tooltip": "The data is pending approval by the creditor.",
  "cropPledge.status.DEBTOR.PENDING_REGISTRATION.tooltip": "The pledge has already been approved and is pending registration in the pledge registry.",
  "cropPledge.status.DEBTOR.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "The pledge is in the registration process, you will soon see it as registered.",
  "cropPledge.status.DEBTOR.REJECTED.tooltip": "The pledge was rejected by the creditor.",
  "cropPledge.status.DEBTOR.REGISTERED.tooltip": "The pledge is registered in the pledge registry.",
  "cropPledge.status.DEBTOR.PENDING_RELEASE.tooltip": "The creditor marked the pledge as collected and is pending release in the pledge registry.",
  "cropPledge.status.DEBTOR.RELEASED.tooltip": "The pledge was released in the pledge register.",
  // BACKOFFICE
  "cropPledge.status.BACKOFFICE.PENDING_DEBTOR_LOAD.tooltip": "The data is pending to be loaded by the debtor.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_LOAD.tooltip": "You have pending data to load.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_FARM_LOAD.tooltip": "You have pending data to load.",
  "cropPledge.status.BACKOFFICE.PENDING_CREDITOR_LOAD.tooltip": "The data is pending to be loaded by the creditor.",
  "cropPledge.status.BACKOFFICE.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "The documentation data is pending to be loaded by the debtor.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_APPROVAL.tooltip": "You have pending data to approve",
  "cropPledge.status.BACKOFFICE.PENDING_CREDITOR_APPROVAL.tooltip": "The data is pending approval by the creditor.",
  "cropPledge.status.BACKOFFICE.PENDING_REGISTRATION.tooltip": "The pledge is pending your registration in the pledge registry.",
  "cropPledge.status.BACKOFFICE.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "The pledge is in the registration process, you will soon see it as registered.",
  "cropPledge.status.BACKOFFICE.REJECTED.tooltip": "The pledge was rejected by the creditor.",
  "cropPledge.status.BACKOFFICE.REGISTERED.tooltip": "The pledge is registered in the pledge registry.",
  "cropPledge.status.BACKOFFICE.PENDING_RELEASE.tooltip": "The pledge has been marked as collected by the creditor and is pending your release in the pledge registry.",
  "cropPledge.status.BACKOFFICE.RELEASED.tooltip": "The pledge was released in the pledge registry.",
  // CREDITOR
  "cropPledge.status.CREDITOR.PENDING_DEBTOR_LOAD.tooltip": "The data is pending to be uploaded by the debtor.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_LOAD.tooltip": "The data is pending to be uploaded by the Stock Exchange.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_FARM_LOAD.tooltip": "The data is pending to be loaded by the Stock Exchange.",
  "cropPledge.status.CREDITOR.PENDING_CREDITOR_LOAD.tooltip": "You have pending data to upload.",
  "cropPledge.status.CREDITOR.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "The documentation data is pending to be uploaded by the debtor.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_APPROVAL.tooltip": "The data is pending approval by the Exchange.",
  "cropPledge.status.CREDITOR.PENDING_CREDITOR_APPROVAL.tooltip": "You have pending data to approve",
  "cropPledge.status.CREDITOR.PENDING_REGISTRATION.tooltip": "The item has already been approved and is pending registration in the pledge registry.",
  "cropPledge.status.CREDITOR.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "The pledge is in the registration process, you will soon see it as registered.",
  "cropPledge.status.CREDITOR.REJECTED.tooltip": "You rejected this item",
  "cropPledge.status.CREDITOR.REGISTERED.tooltip": "The item is registered in the pledge registry.",
  "cropPledge.status.CREDITOR.PENDING_RELEASE.tooltip": "You marked the item as collected and is pending release in the pledge registry.",
  "cropPledge.status.CREDITOR.RELEASED.tooltip": "The pledge was released in the pledge registry.",
  "cropPledgeDetail.page.title": "Create pledge",
  "cropPledgeDetail.asideNav.fieldData": "Field Data",
  "cropPledgeDetail.asideNav.debtorData": "Debtor Data",
  "cropPledgeDetail.asideNav.creditorData": "Creditor Data",
  "cropPledgeDetail.asideNav.documentation": "Documentation",
  "cropPledgeDetail.asideNav.cropPledgeData": "Pledge Data",
  "cropPledgeDetail.asideNav.insuranceData": "Insurance",
  // NATIONALITY TYPES
  "nationality.ARGENTINE": "Argentine",
  "nationality.AFGHAN": "Afghan",
  "nationality.ALBANIAN": "Albanian",
  "nationality.ALGERIAN": "Algerian",
  "nationality.AMERICAN": "American",
  "nationality.ANDORRAN": "Andorran",
  "nationality.ANGOLAN": "Angolan",
  "nationality.ARMENIAN": "Armenian",
  "nationality.AUSTRALIAN": "Australian",
  "nationality.AUSTRIAN": "Austrian",
  "nationality.AZERBAIJANI": "Azerbaijani",
  "nationality.BAHAMIAN": "Bahamian",
  "nationality.BAHRAINI": "Bahraini",
  "nationality.BANGLADESHI": "Bangladeshi",
  "nationality.BARBADIAN": "Barbadian",
  "nationality.BELARUSIAN": "Belarusian",
  "nationality.BELGIAN": "Belgian",
  "nationality.BELIZEAN": "Belizean",
  "nationality.BENINESE": "Beninese",
  "nationality.BHUTANESE": "Bhutanese",
  "nationality.BOLIVIAN": "Bolivian",
  "nationality.BOSNIAN": "Bosnian",
  "nationality.BRAZILIAN": "Brazilian",
  "nationality.BRITISH": "British",
  "nationality.BRUNEIAN": "Bruneian",
  "nationality.BULGARIAN": "Bulgarian",
  "nationality.BURKINABE": "Burkinabe",
  "nationality.BURMESE": "Burmese",
  "nationality.BURUNDIAN": "Burundian",
  "nationality.CAMBODIAN": "Cambodian",
  "nationality.CAMEROONIAN": "Cameroonian",
  "nationality.CANADIAN": "Canadian",
  "nationality.CAPE_VERDEAN": "Cape Verdean",
  "nationality.CENTRAL_AFRICAN": "Central African",
  "nationality.CHADIAN": "Chadian",
  "nationality.CHILEAN": "Chilean",
  "nationality.CHINESE": "Chinese",
  "nationality.COLOMBIAN": "Colombian",
  "nationality.COMORIAN": "Comorian",
  "nationality.CONGOLESE": "Congolese",
  "nationality.COSTA_RICAN": "Costa Rican",
  "nationality.CROATIAN": "Croatian",
  "nationality.CUBAN": "Cuban",
  "nationality.CYPRIOT": "Cypriot",
  "nationality.CZECH": "Czech",
  "nationality.DANISH": "Danish",
  "nationality.DJIBOUTIAN": "Djiboutian",
  "nationality.DOMINICAN": "Dominican",
  "nationality.DUTCH": "Dutch",
  "nationality.EAST_TIMORESE": "East Timorese",
  "nationality.ECUADOREAN": "Ecuadorean",
  "nationality.EGYPTIAN": "Egyptian",
  "nationality.EMIRATI": "Emirati",
  "nationality.EQUATORIAL_GUINEAN": "Equatorial Guinean",
  "nationality.ERITREAN": "Eritrean",
  "nationality.ESTONIAN": "Estonian",
  "nationality.ETHIOPIAN": "Ethiopian",
  "nationality.FIJIAN": "Fijian",
  "nationality.FILIPINO": "Filipino",
  "nationality.FINNISH": "Finnish",
  "nationality.FRENCH": "French",
  "nationality.GABONESE": "Gabonese",
  "nationality.GAMBIAN": "Gambian",
  "nationality.GEORGIAN": "Georgian",
  "nationality.GERMAN": "German",
  "nationality.GHANAIAN": "Ghanaian",
  "nationality.GREEK": "Greek",
  "nationality.GRENADIAN": "Grenadian",
  "nationality.GUATEMALAN": "Guatemalan",
  "nationality.GUINEAN": "Guinean",
  "nationality.GUINEA_BISSAUAN": "Guinea Bissauan",
  "nationality.GUYANESE": "Guyanese",
  "nationality.HAITIAN": "Haitian",
  "nationality.HONDURAN": "Honduran",
  "nationality.HUNGARIAN": "Hungarian",
  "nationality.ICELANDER": "Icelander",
  "nationality.INDIAN": "Indian",
  "nationality.INDONESIAN": "Indonesian",
  "nationality.IRANIAN": "Iranian",
  "nationality.IRAQI": "Iraqi",
  "nationality.IRISH": "Irish",
  "nationality.ISRAELI": "Israeli",
  "nationality.ITALIAN": "Italian",
  "nationality.IVORIAN": "Ivorian",
  "nationality.JAMAICAN": "Jamaican",
  "nationality.JAPANESE": "Japanese",
  "nationality.JORDANIAN": "Jordanian",
  "nationality.KAZAKH": "Kazakh",
  "nationality.KENYAN": "Kenyan",
  "nationality.KIRIBATI": "Kiribati",
  "nationality.KOREAN": "Korean",
  "nationality.KUWAITI": "Kuwaiti",
  "nationality.KYRGYZ": "Kyrgyz",
  "nationality.LAOTIAN": "Laotian",
  "nationality.LATVIAN": "Latvian",
  "nationality.LEBANESE": "Lebanese",
  "nationality.LESOTHO": "Lesotho",
  "nationality.LIBERIAN": "Liberian",
  "nationality.LIBYAN": "Libyan",
  "nationality.LIECHTENSTEINER": "Liechtensteiner",
  "nationality.LITHUANIAN": "Lithuanian",
  "nationality.LUXEMBOURGISH": "Luxembourgish",
  "nationality.MACEDONIAN": "Macedonian",
  "nationality.MALAGASY": "Malagasy",
  "nationality.MALAWIAN": "Malawian",
  "nationality.MALAYSIAN": "Malaysian",
  "nationality.MALDIVIAN": "Maldivian",
  "nationality.MALIEN": "Malien",
  "nationality.MALTESE": "Maltese",
  "nationality.MARSHALLESE": "Marshallese",
  "nationality.MAURITANIAN": "Mauritanian",
  "nationality.MAURITIAN": "Mauritian",
  "nationality.MEXICAN": "Mexican",
  "nationality.MICRONESIAN": "Micronesian",
  "nationality.MOLDOVAN": "Moldovan",
  "nationality.MONACAN": "Monacan",
  "nationality.MONGOLIAN": "Mongolian",
  "nationality.MONTENEGRIN": "Montenegrin",
  "nationality.MOROCCAN": "Moroccan",
  "nationality.MOZAMBICAN": "Mozambican",
  "nationality.NAMIBIAN": "Namibian",
  "nationality.NAURUAN": "Nauruan",
  "nationality.NEPALESE": "Nepalese",
  "nationality.NEW_ZEALANDER": "New Zealander",
  "nationality.NICARAGUAN": "Nicaraguan",
  "nationality.NIGERIAN": "Nigerian",
  "nationality.NIGERIEN": "Nigerien",
  "nationality.NORTH_KOREAN": "North Korean",
  "nationality.NORWEGIAN": "Norwegian",
  "nationality.OMANI": "Omani",
  "nationality.PAKISTANI": "Pakistani",
  "nationality.PALAUAN": "Palauan",
  "nationality.PALESTINIAN": "Palestinian",
  "nationality.PANAMANIAN": "Panamanian",
  "nationality.PAPUA_NEW_GUINEAN": "Papua New Guinean",
  "nationality.PARAGUAYAN": "Paraguayan",
  "nationality.PERUVIAN": "Peruvian",
  "nationality.POLISH": "Polish",
  "nationality.PORTUGUESE": "Portuguese",
  "nationality.QATARI": "Qatari",
  "nationality.ROMANIAN": "Romanian",
  "nationality.RUSSIAN": "Russian",
  "nationality.RWANDAN": "Rwandan",
  "nationality.SAINT_KITTS_AND_NEVIS": "Saint Kitts And Nevis",
  "nationality.SAINT_LUCIAN": "Saint Lucian",
  "nationality.SAINT_VINCENTIAN": "Saint Vincentian",
  "nationality.SALVADORAN": "Salvadoran",
  "nationality.SAMOAN": "Samoan",
  "nationality.SAN_MARINESE": "San Marinese",
  "nationality.SAO_TOMEAN": "Sao Tomean",
  "nationality.SAUDI_ARABIAN": "Saudi Arabian",
  "nationality.SAUDI": "Saudi",
  "nationality.SCOTTISH": "Scottish",
  "nationality.SENEGALESE": "Senegalese",
  "nationality.SERBIAN": "Serbian",
  "nationality.SEYCHELLOIS": "Seychellois",
  "nationality.SIERRA_LEONEAN": "Sierra Leonean",
  "nationality.SINGAPOREAN": "Singaporean",
  "nationality.SLOVAK": "Slovak",
  "nationality.SLOVENIAN": "Slovenian",
  "nationality.SOLOMON_ISLANDER": "Solomon Islander",
  "nationality.SOMALI": "Somali",
  "nationality.SOUTH_AFRICAN": "South African",
  "nationality.SOUTH_KOREAN": "South Korean",
  "nationality.SOUTH_SUDANESE": "South Sudanese",
  "nationality.SPANISH": "Spanish",
  "nationality.SRI_LANKAN": "Sri Lankan",
  "nationality.SUDANESE": "Sudanese",
  "nationality.SURINAMER": "Surinamer",
  "nationality.SURINAMESE": "Surinamese",
  "nationality.SWAZI": "Swazi",
  "nationality.SWEDISH": "Swedish",
  "nationality.SWISS": "Swiss",
  "nationality.SYRIAN": "Syrian",
  "nationality.TAIWANESE": "Taiwanese",
  "nationality.TAJIK": "Tajik",
  "nationality.TANZANIAN": "Tanzanian",
  "nationality.THAI": "Thai",
  "nationality.TOGOLESE": "Togolese",
  "nationality.TONGAN": "Tongan",
  "nationality.TRINIDADIAN": "Trinidadian",
  "nationality.TUNISIAN": "Tunisian",
  "nationality.TURKISH": "Turkish",
  "nationality.TURKMEN": "Turkmen",
  "nationality.TUVALUAN": "Tuvaluan",
  "nationality.UGANDAN": "Ugandan",
  "nationality.UKRAINIAN": "Ukrainian",
  "nationality.URUGUAYAN": "Uruguayan",
  "nationality.UZBEK": "Uzbek",
  "nationality.VANUATUAN": "Vanuatuan",
  "nationality.VATICAN": "Vatican",
  "nationality.VENEZUELAN": "Venezuelan",
  "nationality.VIETNAMESE": "Vietnamese",
  "nationality.WELSH": "Welsh",
  "nationality.YEMENI": "Yemeni",
  "nationality.ZAMBIAN": "Zambian",
  "nationality.ZIMBABWEAN": "Zimbabwean",
  "cropPledge.linkToDigitalDossier": "View digital dossier",
  // CROP PLEDGE ALERT
  "cropPledge.alert.title": "Data editing is not available in this section.",
  "cropPledge.alert.detail": `To make changes, go to the 'Digital File' section, make the necessary modifications, and request approval. If you make changes, you will need to create a new pledge to apply the updates, as the initiated pledge will retain the old data.`,
  // business sign-up
  "businessSignUp.firstStep.title": "Request business registration",
  "businessSignUp.firstStep.stepIndicator": "Business data",
  "businessSignUp.firstStep.error.companyAlreadyExist": "The CUIT entered has already been registered",
  "businessSignUp.secondStep.subtitle": "Complete with the data of the person who will be given the Administrator User role. This will have full access to the services of the BC Explorer platform, on behalf of its user.",
  "businessSignUp.firstStep.error.companyNameAlreadyExist": "The company name entered has already been registered. Please contact Bolsa de Cereales for more information.",
  "businessSignUp.secondStep.stepIndicator": "Administrator data",
  "businessSignUp.secondStep.error.adminUserEmailAlreadyExists": "The email entered has already been registered",
  "businessSignUp.secondStep.error.adminUserFiscalIdAlreadyExists": "The CUIT entered has already been registered",
  "businessSignUp.thirdStep.stepIndicator": "Legal representative data",
  "businessSignUp.thirdStep.subtitle": "In this section you must complete the data of the Legal Representative or those that are necessary, in the case of a joint signature, that have sufficient power to request the registration of the company in BC Explorer. Once the process is completed, they will be the ones to sign the form that will be presented to Bolsa de Cereales.",
  "businessSignUp.form.title": "Business data",
  "businessSignUp.form.cuit.label": "Business Tax ID",
  "businessSignUp.form.cuit.placeholder": "Enter Tax ID",
  "businessSignUp.form.businessName.label": "Business Name",
  "businessSignUp.form.businessName.placeholder": "Enter Business Name",
  "businessSignUp.form.addressStreet.label": "Street",
  "businessSignUp.form.addressStreet.placeholder": "Enter street",
  "businessSignUp.form.addressNumber.label": "Number",
  "businessSignUp.form.addressNumber.placeholder": "Enter number",
  "businessSignUp.form.state.label": "State",
  "businessSignUp.form.state.placeholder": "Select state",
  "businessSignUp.form.locality.label": "Locality",
  "businessSignUp.form.locality.placeholder": "Search locality",
  "businessSignUp.form.locality.noOptions": "Your search did not match any results. Please try again.",
  "businessSignUp.form.zipCode.label": "Zip Code",
  "businessSignUp.form.zipCode.placeholder": "Enter zip code",
  "businessSignUp.form.exchanges.label": "Exchange you operate with",
  "businessSignUp.form.exchanges.placeholder": "Select Exchange",
  "businessSignUp.form.businessType.label": "Type of Corporation",
  "businessSignUp.form.businessType.placeholder": "Select type of corporation",
  "businessSignUp.form.userFirstName.label": "First Name",
  "businessSignUp.form.userFirstName.placeholder": "Enter first name",
  "businessSignUp.form.userLastName.label": "Last Name",
  "businessSignUp.form.userLastName.placeholder": "Enter last name",
  "businessSignUp.form.userFiscalId.label": "Tax ID",
  "businessSignUp.form.userFiscalId.placeholder": "Enter Tax ID",
  "businessSignUp.form.userPhone.label": "Phone",
  "businessSignUp.form.userPhone.placeholder": "Enter phone number",
  "businessSignUp.form.userEmail.label": "Email",
  "businessSignUp.form.userEmailConfirm.label": "Confirm Email",
  "businessSignUp.form.userEmail.placeholder": "Enter email",
  "businessSignUp.form.legalRepresentativeFirstName.addSecond": "Add legal representative",
  "businessSignUp.form.legalRepresentativeFirstName.label": "First Name",
  "businessSignUp.form.legalRepresentativeFirstName.placeholder": "Enter legal representative\u2019s first name",
  "businessSignUp.form.legalRepresentativeLastName.label": "Last Name",
  "businessSignUp.form.legalRepresentativeLastName.placeholder": "Enter legal representative\u2019s last name",
  "businessSignUp.form.legalRepresentativeIdDocumentNumber.label": "ID Number",
  "businessSignUp.form.legalRepresentativeIdDocumentNumber.placeholder": "Enter legal representative\u2019s ID number",
  "businessSignUp.form.legalRepresentativeEmail.label": "Email",
  "businessSignUp.form.legalRepresentativeEmail.placeholder": "Enter legal representative\u2019s email",
  "businessSignUp.form.legalRepresentativePosition.label": "Position",
  "businessSignUp.form.legalRepresentativePosition.placeholder": "Select position",
  "businessSignUp.form.idDocumentFile.label": "ID Document",
  "businessSignUp.form.signupPermissionFile.label": "Accreditation of legal representation: upload the minutes, power of attorney or document from which your representation arises.",
  "businessSignup.form.representativePosition.PRESIDENT": "President",
  "businessSignup.form.representativePosition.PROXY": "Proxy",
  "businessSignup.form.representativePosition.INCUMBENT": "Incumbent",
  "businessSignup.form.representativePosition.MANAGING_PARTNER": "Managing Partner",
  "businessSignup.form.representativePosition.OTHER": "Other",
  "businessSignup.form.companyType.PF": "Individual",
  "businessSignup.form.companyType.SH": "Partnerships",
  "businessSignup.form.companyType.SA": "Corporation",
  "businessSignup.form.companyType.SRL": "Limited Liability Company",
  "businessSignup.form.companyType.SAS": "Simplified Stock Company",
  "businessSignup.form.companyType.SAU": "Single Shareholder Corporation",
  "businessSignup.form.companyType.COOP": "Cooperatives",
  "businessSignup.form.companyType.AS": "Civil Associations",
  "businessSignup.form.companyType.FUND": "Foundations",
  "businessSignup.form.companyType.FID": "Trusts",
  "businessSignup.form.companyType.OTHER": "Other",
  "businessSignup.form.idDocumentFile.clickHereMessage": "Click here",
  "businessSignup.form.idDocumentFile.orDropTheFileMessage": "or drop the file",
  "businessSignup.form.idDocumentFile.tryAgainMessage": "Upload again",
  "businessSignup.form.idDocumentFile.fileInvalidTypeMessage": "The file is invalid",
  "businessSignup.form.idDocumentFile.fileTooLargeMessage": "The file is too large",
  "businessSignup.form.idDocumentFile.fileTooSmallMessage": "The file is too small",
  "businessSignup.form.idDocumentFile.tooManyFilesMessage": "Too many files",
  "businessSignUp.form.next": "Next",
  // COMPANY_CONTACT_INFORMATION
  "companyContactInformation.form.error.validLocality": "Enter a valid location for the selected province",
  "companyContactInformation.toast.success.title": "The information was successfully updated",
  // EXCHANGE
  "exchange.BCBA": "Bolsa de Cereales de Buenos Aires",
  // ERROR MESSAGE TOASTS
  "toast.error.UPDATES_NOT_TRIGGERED_CHANGES.title": "Error",
  "toast.error.UPDATES_NOT_TRIGGERED_CHANGES.text": "There are no pending changes to be saved.",
  "toast.error.RECORD_NOT_FOUND.title": "Information not found",
  "toast.error.RECORD_NOT_FOUND.text": "",
  "toast.error.EMAIL_ALREADY_EXISTS.title": "Email already exists",
  "toast.error.EMAIL_ALREADY_EXISTS.text": "",
  "toast.error.FISCAL_ID_IN_USE.title": "Fiscal ID already in use",
  "toast.error.FISCAL_ID_IN_USE.text": "",
  "toast.error.EMPTY_FILE.title": "No file found to upload",
  "toast.error.EMPTY_FILE.text": "",
  "toast.error.USER_ALREADY_EXISTS.title": "User already exists",
  "toast.error.USER_ALREADY_EXISTS.text": "",
  "toast.error.COMPANY_ALREADY_EXISTS.title": "Company already exists",
  "toast.error.COMPANY_ALREADY_EXISTS.text": "",
  "toast.error.SNAPSHOT_ALREADY_REJECTED.title": "Already rejected",
  "toast.error.SNAPSHOT_ALREADY_REJECTED.text": "Cannot request changes",
  "toast.error.SNAPSHOT_MUST_BE_PENDING_APPROVAL.title": "The status must be pending approval to approve",
  "toast.error.SNAPSHOT_MUST_BE_PENDING_APPROVAL.text": "",
  "toast.error.SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED.title": "Cannot approve",
  "toast.error.SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED.text": "Previously rejected or approved",
  "toast.error.SNAPSHOT_NON_ACTIVE.title": "An error occurred",
  "toast.error.SNAPSHOT_NON_ACTIVE.text": "Please try again later",
  "toast.error.SNAPSHOT_WITH_MISSING_INFORMATION.title": "Cannot approve",
  "toast.error.SNAPSHOT_WITH_MISSING_INFORMATION.text": "Missing information",
  "toast.error.COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER.title": "The company does not yet have a certified digital dossier",
  "toast.error.COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER.text": "",
  "toast.error.COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES.title": "The company does not have available queries",
  "toast.error.COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES.text": "",
  "toast.error.SIGNUP_REQUEST_ALREADY_REJECTED.title": "Signup request already rejected",
  "toast.error.SIGNUP_REQUEST_ALREADY_REJECTED.text": "",
  "toast.error.SIGNUP_REQUEST_ALREADY_APPROVED.title": "Cannot reject an already approved signup request",
  "toast.error.SIGNUP_REQUEST_ALREADY_APPROVED.text": "",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS.title": "Signup request is not in a pending approval status",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS.text": "",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS.title": "Signup request is not in a pending change request status",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS.text": "",
  "toast.error.SNAPSHOT_ALREADY_APPROVED.title": "Already approved. Cannot request changes",
  "toast.error.SNAPSHOT_ALREADY_APPROVED.text": "",
  "toast.error.MALFORMED_REQUEST.title": "Malformed request",
  "toast.error.MALFORMED_REQUEST.text": "Malformed request",
  "toast.error.PROCESSING_ERROR.title": "Processing error",
  "toast.error.PROCESSING_ERROR.text": "Processing error",
  "toast.error.CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS.title": "Certificate request already in progress",
  "toast.error.CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS.text": "Certificate request already in progress",
  "toast.error.BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION.title": "Gross income set as Local Jurisdiction must have a single Jurisdiction",
  "toast.error.BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION.text": "",
  "toast.error.BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION.title": "Gross income set as Multilateral Agreement must have at least one Jurisdiction",
  "toast.error.BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION.text": "",
  "toast.error.BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS.title": "Gross income set as exempt must not have any jurisdictions",
  "toast.error.BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS.text": "",
  "toast.error.ERROR_SENDING_EMAIL.title": "Error sending email notification",
  "toast.error.ERROR_SENDING_EMAIL.text": "",
  "toast.error.ERROR_UPLOADING_FILE.title": "Error uploading file",
  "toast.error.ERROR_UPLOADING_FILE.text": "An error occurred while uploading the file, please try again",
  "toast.error.ERROR_FETCHING_FILE.title": "Error downloading file",
  "toast.error.ERROR_FETCHING_FILE.text": "",
  "toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.text": "The crop pledge process cannot be initiated because the company does not yet have a complete digital dossier.",
  "toast.error.CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION.text": "The crop pledge process cannot be initiated because the company does not yet have complete contact information.",
  "toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.text": "The crop pledge process cannot be initiated because the company does not have a phone number configured in the contact information.",
  "toast.error.CROP_PLEDGE_NO_EMAIL.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_EMAIL.text": "The crop pledge process cannot be initiated because the company does not have an email configured in the contact information.",
  "toast.error.CROP_PLEDGE_NO_CP.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_CP.text": "The crop pledge process cannot be initiated because the company does not have a postal code configured in the contact information.",
  "toast.error.CROP_PLEDGE_NO_INCUMBENT.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_NO_INCUMBENT.text": "The crop pledge process cannot be initiated because the company does not have a legal representative configured.",
  "toast.error.CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER.title": "Error trying to create a crop pledge",
  "toast.error.CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER.text": "The crop pledge process cannot be initiated because the company is not a producer.",
  "toast.error.CROP_PLEDGE_CANT_USE_OWN_COMPANY.title": "",
  "toast.error.CROP_PLEDGE_CANT_USE_OWN_COMPANY.text": `You can't use your own company as a creditor`,
  "toast.error.CROP_PLEDGE_COMPANY_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_COMPANY_NOT_FOUND.text": "No creditor was found using this fiscal id",
  "toast.error.CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND.text": "The creditor information was not found",
  "toast.error.CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND.text": "The farm information was not found",
  "toast.error.CROP_PLEDGE_USER_IS_NOT_CREDITOR.title": "",
  "toast.error.CROP_PLEDGE_USER_IS_NOT_CREDITOR.text": "The user is not a creditor",
  "toast.error.CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS.title": "",
  "toast.error.CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS.text": "Crop pledge must be in PENDING_CREDITOR_APPROVAL status.",
  "toast.error.CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS.title": "",
  "toast.error.CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS.text": "All first three sections must be in APPROVED status.",
  "toast.error.CROP_PLEDGE_INVALID_STAGE.title": "",
  "toast.error.CROP_PLEDGE_INVALID_STAGE.text": "The crop pledge is in an invalid stage to perform this action",
  // ERROR MESSAGE
  "error.CUIT_MUST_BE_11_DIGITS.errorDescription": "Must be exactly 11 characters long",
  "error.VALIDATION_ERROR.errorDescription": "An error has occurred please try again later.",
  "error.CUIT_INVALID.errorDescription": "The cuit entered is invalid",
  "error.CUIT_NOT_FOUND_IN_AFIP.errorDescription": "AFIP does not have this CUIT registered",
  "error.ERR_NETWORK.errorDescription": "Network connection error. Please try again in a few minutes.",
  // business sing-up summary
  "businessSignup.summary.title": "Registration request generated successfully!",
  "businessSignup.summary.subtitle": "The chosen administrator user will receive a temporary password to enter the Legajo Digital platform along with the registration form, in PDF, for printing and signature by the indicated legal representatives.",
  "businessSignup.summary.listTitle": "What are the next steps?",
  "businessSignup.summary.firstListItem": "Download the PDF of the registration form and print it.",
  "businessSignup.summary.secondListItem": "Sign the registration form by the indicated legal representatives (certify their signatures before a Notary and Legalize them - see requirements at the bottom of the form)",
  "businessSignup.summary.thirdListItem": "Send the registration form to the Bolsa de Cereales and wait for its approval (Documentation Control Office: Av. Corrientes 123 - Floor 3. (C1043AAB))",
  "businessSignup.summary.sendEmailOtherPerson": "Do you want to send the PDF to another email?",
  "businessSignup.summary.downloadPDF": "Download PDF",
  "businessSignup.summary.signIn": "Log in",
  "businessSignup.summary.send": "Send",
  "businessSignup.summary.toast.title.success": "The document has been sent successfully",
  "businessSignup.summary.toast.title.error": "Error sending document",
  // DIGITAL DOSSIERS
  "digitalDossiers.status.RUCA_EXPIRED": "RUCA not current",
  "digitalDossiers.status.INFORMATION_EXPIRED": "Expired information",
  "digitalDossiers.status.PENDING_DATA_UPLOAD_BACKOFFICE": "Pending data upload backoffice",
  "digitalDossiers.status.PENDING_DATA_UPLOAD_CLIENT": "Pending data upload client",
  "digitalDossiers.status.PENDING_APPROVAL": "Pending approval",
  "digitalDossiers.status.APPROVED": "Approved",
  "digitalDossiers.table.filters.fiscalId": "Search by company name, Tax ID",
  "digitalDossiers.searchThirdPartyDossier.awaitingApproval": "Your request to access this dossier is pending approval",
  // VALIDATION STATUS
  "validationStatus.INCOMPLETE": "Pending user data",
  "validationStatus.PENDING_APPROVAL": "Pending approval",
  "validationStatus.PENDING_CHANGE_REQUEST": "Pending review",
  "validationStatus.PENDING_DATA_UPLOAD": "Pending data upload",
  "validationStatus.REJECTED": "Rejected",
  "validationStatus.APPROVED": "Approved",
  // Backoffice validation status
  "backofficevalidationStatus.PENDING_DATA_UPLOAD_CLIENT": "Pending Client Upload",
  "backofficevalidationStatus.PENDING_DATA_UPLOAD_BACKOFFICE": "Pending Backoffice Upload",
  "backofficevalidationStatus.PENDING_APPROVAL": "Pending Approval",
  "backofficevalidationStatus.APPROVED": "Approved",
  // IDENTITY DOCUMENT TYPES
  "identityDocumentType.DNI": "DNI",
  "identityDocumentType.ENROLAMIENTO": "Enlistment",
  "identityDocumentType.PASSPORT": "Passport",
  // DOCUMENT TYPES
  "documentType.IGJ": "IGJ",
  "documentType.CBU": "CBU",
  "documentType.CUIT": "CUIT",
  "documentType.IIBB": "IIBB",
  "documentType.CM05": "CM05",
  "documentType.PROFITS": "Profits",
  "documentType.IVA": "IVA",
  "documentType.EXEMPTIONS": "Exemptions",
  "documentType.UNKNOWN": "Unknown",
  "documentType.SISA": "SISA",
  "documentType.PRODUCTION_CAPACITY": "Production capacity",
  "documentType.STORAGE_CAPACITY": "Storage capacity",
  "documentType.BALANCE_SHEET": "Balance sheet",
  "documentType.OWNER_ID_CARD": "Owner ID card",
  "documentType.STATUTE": "Statute",
  "documentType.ASSEMBLY_BOARD_MINUTES": "Assembly board minutes",
  "documentType.POWERS_OF_ATTORNEY": "Powers of Attorney",
  "documentType.SIGNUP_PERMISSION": "Permission to sign the application",
  "documentType.REPRESENTATIVE_ID_CARD": "DNI",
  "documentType.STATUTE_CHANGE": "Statute change",
  "documentType.GEOLOCATION": "Geolocation",
  "documentType.ADDITIONAL_EQUITY_DOCUMENT": "Additional equity document",
  "documentType.ADDITIONAL_FORMS_AND_DOCS_DOCUMENT": "Additional equity document",
  "documentType.COMPANY_QUERY_LOAD_CONTRACT": "Company query load contract",
  "documentType.LOAN_CONTRACT": "Loan contract",
  "documentType.ADDITIONAL_CROP_PLEDGE_DOCUMENT": "Additional document",
  "documentType.CARBON_ANALYSIS": "Carbon analysis",
  "documentType.DOMAIN_REPORT": "Domain report",
  "documentType.MODIFICATION_FORM": "Form 6 (modification/endorsement)",
  "documentType.REGISTERED_PLEDGE": "Registered pledge",
  "documentType.DEREGISTRATION_OF_PLEDGE": "Deregistration of pledge",
  "documentType.ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT": "Additional document",
  "documentType.PLEDGE_REGISTRATION_FORM_TEMPLATE": "Pledge registration template",
  // REPRESENTATIVE POSITIONS
  "representativePosition.PRESIDENT": "President",
  "representativePosition.PROXY": "Proxy",
  "representativePosition.INCUMBENT": "Incumbent",
  "representativePosition.MANAGING_PARTNER": "Managing Partner",
  "representativePosition.OTHER": "Other",
  // PRODUCTS
  "product.COTTON": "Cotton",
  "product.RICE": "Rice",
  "product.BARLEY": "Barley",
  "product.SUNFLOWER": "Sunflower",
  "product.CORN": "Corn",
  "product.PEANUTS": "Peanuts",
  "product.SOY": "Soy",
  "product.SORGHUM": "Sorghum",
  "product.WHEAT": "Wheat",
  "product.OTHER": "Other",
  // SIGNATURE LEVELS
  "signatureLevel.ZERO": "0",
  "signatureLevel.ONE": "1",
  "signatureLevel.TWO": "2",
  "signatureLevel.THREE": "3",
  "signatureLevel.NINE": "9",
  // POWER OF ATTORNEY EXCHANGES
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_BUENOS_AIRES": "Bolsa de Cereales de Buenos Aires",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_BAHIA_BLANCA": "Bolsa de Cereales de Bahia Blanca ",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_ENTRE_RIOS": "Bolsa de Cereales de Entre R\xEDos",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_CORDOBA": "Bolsa de Cereales de C\xF3rdoba",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_CHACO": "Bolsa de Cereales de Chaco",
  "powerOfAttorneyExchange.STOCK_EXCHANGE_ROSARIO": "Bolsa de Comercio de Rosario",
  "powerOfAttorneyExchange.STOCK_EXCHANGE_SANTA_FE": "Bolsa de Comercio de Santa Fe",
  // CURRENCIES
  "currency.ARS": "Peso",
  "currency.USD": "Dolar",
  // EXPLOITATION TYPES
  "exploitationType.AGRICULTURAL": "Agricultural",
  "exploitationType.LIVE_STOCK": "Live stock",
  "exploitationType.MIXED": "Mixed",
  // OWNERSHIP OPTIONS
  "ownershipType.OWN": "Own",
  "ownershipType.THIRD_PARTY": "Third party",
  // PLEDGE CLASSES
  "pledgeClass.FIXED": "Fixed",
  "pledgeClass.FLOATING": "Floating",
  // PLEDGE DEGREES
  "pledgeDegree.FIRST_DEGREE": "First degree",
  // CREDITOR INSPECTION RIGHTS
  "creditorInspectionRights.BROAD": "Broad",
  "creditorInspectionRights.LIMITED": "Limited",
  // DOCUMENTATION NEEDED
  "documentationNeeded.ownerIdentityDocument": "DNI del titular (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.proxies": "Apoderados: Poder + DNI apoderado. Copias certificadas y legalizadas",
  "documentationNeeded.socialContractAndChanges": "Contrato Social y sus modificaciones: copia certificada y legalizada",
  "documentationNeeded.partnersIdentityDocument": "DNI de los socios (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.membershipMeetingMinutes": "Actas de reuni\xF3n de socios: copia certificada y legalizada. Incluir hoja de r\xFAbrica",
  "documentationNeeded.statute": "Estatuto inscripto y sus modificaciones: copia certificada y legalizada.",
  "documentationNeeded.assemblyMinutes": "Acta de Asamblea donde tratan la designaci\xF3n de los accionistas y la elecci\xF3n de las autoridades, firmada por los accionistas y el presidente: copia certificada y legalizada. Incluir hoja de r\xFAbrica",
  "documentationNeeded.boardMinutes": "Acta de directorio, donde se trata la distribuci\xF3n y aceptaci\xF3n de cargos por parte de los directores elegidos en asamblea, firmada por todos los directores electos: copia certificada y legalizada. Incluir hoja de r\xFAbrica.",
  "documentationNeeded.legalRepresentativesIdentityDocument": "DNI de Representantes legales (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.statuteWithTransitoryProvisions": "Estatuto inscripto con disposiciones transitorias y sus modificaciones: copia certificada y legalizada.",
  "documentationNeeded.chiefAdministratorIdentityDocument": "DNI del Administrador Titular (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.socialContract": "Contrato social: copia certificada y legalizada",
  "documentationNeeded.extraDocsMessage": "Deber\xE1s comunicarte con la Bolsa de Cereales para consultar qu\xE9 documentaci\xF3n adicional deber\xE1s enviar para completar tu Legajo Digital",
  "documentationNeeded.alert.title": "Depending on the type of company you are, you must submit additional information to Bolsa de Cereales as follows.",
  "documentationNeeded.alert.viewDetails": "View details",
  "documentationNeeded.modal.understood": "Understood",
  "documentationNeeded.modal.title": "You have pending information to submit to La Bolsa.",
  "documentationNeeded.modal.text.start": "Since your company type is {{companyType}} you need to send the following documents to Bolsa de Cereales:",
  "documentationNeeded.modal.text.end": "In case you have previously submitted documents, you will see these documents preloaded and it will not be necessary to send them again. Please note that these documents are mandatory to complete the certification of the Digital Record.",
  // ERROR CODES
  "errorCode.createAdmin.firstName.minLength": "Must be at least 2 characters",
  "errorCode.createAdmin.lastName.minLength": "Must be at least 2 characters",
  "errorCode.createAdmin.email.isEmail": "Must be a valid email",
  "errorCode.createAdmin.authUuid.required": "Authentication UUID is required",
  "errorCode.createAdmin.adminRole.isValid": "Admin role must be a valid role",
  // ERROR PAGE
  "errorPage.RECORD_NOT_FOUND.mainErrorMessage": "Page not found",
  "errorPage.RECORD_NOT_FOUND.errorDescription": "The page you are looking for does not exist or has been moved.",
  "errorPage.goBack": "Go back",
  "errorPage.FORBIDDEN_RESOURCE.mainErrorMessage": "Access denied",
  "errorPage.FORBIDDEN_RESOURCE.errorDescription": "Sorry, you are not authorized to access this page. If you need help, contact us at {{emailContact}}",
  "errorPage.INTERNAL_SERVER_ERROR.mainErrorMessage": "Oops an error occurred",
  "errorPage.INTERNAL_SERVER_ERROR.errorDescription": "An error has occurred please try again later.",
  "errorCode.status.isValid": "Status must be a valid status",
  "errorCode.updateAdmin.status.isValid": "Status must be a valid status",
  "errorCode.fiscalIdInvalidFormat": "You must enter a valid CUIT/CUIL",
  "errorCode.createCompany.name.minLength": "Must be at least 2 characters",
  "errorCode.createCompany.fiscalId.minLength": "Must be exactly 11 characters long",
  "errorCode.createCompany.ruca.isValid": "Must be a valid RUCA status",
  "errorCode.createCompany.renspa.minLength": "Must be exactly 11 characters long",
  "errorCode.createCompany.type.isValid": "Company type must be a valid type",
  "errorCode.createProductiveFacility.ownershipType.isValid": "Productive facility ownership bust be a valid type",
  "errorCode.createCompany.mainActivity.length": "Must be between 1 and 200 characters",
  "errorCode.createCompany.activityStartDate.isValid": "Must be a valid date",
  "errorCode.updateCompany.status.validStatus": "Status must be a valid status",
  "errorCode.createCompany.invalidationMessage.length": "Must be between 1 and 200 characters",
  "errorCode.createCompany.activity.isValid": "Invalid activity type",
  "errorCode.createCompanyDocument.companyUuid.isNotEmpty": "Company UUID is required",
  "errorCode.createCompanyDocument.identifier.length": "Must be between 1 and 200 characters",
  "errorCode.createCompanyDocument.category.isValid": "Must be a valid document category",
  "errorCode.createCompanyDocument.type.isValid": "Must be a valid document type",
  "errorCode.createCompanyDocument.expirationDate.isValid": "Must be a number",
  "errorCode.createCompanyDocument.expirationDate.min": "Must be at least 1 digit",
  "errorCode.createCompanyDocument.expirationDate.max": "Cannot exceed 10 digits",
  "errorCode.createUserCompany.companyUuid.length": "Company UUID must be exactly 36 characters long",
  "errorCode.createUserCompany.userUuid.length": "User UUID must be exactly 36 characters long",
  "errorCode.createUserCompany.status.isValid": "Status must be a valid status",
  "errorCode.createUserCompany.role.isValid": "Role must be a valid role",
  "errorCode.createUser.fiscalId.notEmpty": "Fiscal ID is required",
  "errorCode.createUser.phoneNumber.isRequired": "Phone number is required",
  "errorCode.createUser.status.isValid": "Status must be a valid status",
  "errorCode.createUser.fiscalId.minLength": "It must be exactly 11 characters long",
  "errorCode.createUser.email.isEmail": "Must be a valid email",
  "errorCode.createUser.email.emailsDontMatch": "The emails do not match. Please check and try again.",
  "errorCode.createRepresentative.documentType.isValid": "Document type must be a valid document type",
  "errorCode.createRepresentative.documentNumber.required": "Document number is required",
  "errorCode.createRepresentative.position.isValid": "Position must be a valid position",
  "errorCode.createSignUp.companyExchange.isValid": "A valid company exchange is required",
  "errorCode.createSignUp.representantMinLength": "There must be at least one legal representative.",
  "errorCode.createSignUp.representantMaxLength": "There must be a maximum of two legal representatives.",
  "errorCode.updateCompany.validationStatus.isValid": "Must be a valid validation status",
  "errorCode.updateCompany.invalidationMessage.length": "Must be between 1 and 200 characters",
  "errorCode.updateCompanyDocument.validatedAt.isValid": "Must be a number",
  "errorCode.updateCompanyDocument.validatedAt.min": "Must be at least 1 digit",
  "errorCode.updateCompanyDocument.validatedAt.max": "Cannot exceed 10 digits",
  "errorCode.updateCompanyGeneralInformation.sisaActivities.isValid": "Must be a valid SISA activity",
  "errorCode.updateCompanyGeneralInformation.sisaScoring.isValid": "Must be a valid SISA scoring",
  "errorCode.digitalDossier.updateBankingInfo.cbu.length": "Must be 22 characters",
  "errorCode.accessRequest.update.status.isValid": "Status must be a valid Access Request status",
  "errorCode.accessRequest.update.accessibleSection.isValid": "The section must be a valid section.",
  "errorCode.minLength.2": "Must be at least 2 characters",
  // class-validator errors
  "class-validator.maxLength10.error": "The max length for this field is 10",
  "class-validator.isNotEmpty.error": "This field is required",
  "class-validator.isNumber.error": "This field must be a number",
  "class-validator.email.isEmail": "Must be a valid email",
  "class-validator.isBase64.error": "This field must contain a file.",
  "class-validator.url.isURL": "The URL provided is invalid. It must be a complete URL with http or https.",
  "class-validator.isValidRepresentantBirthDate.error": `The representative's date of birth must be in the past.`,
  "class-validator.min.1": "Must be greater than 1",
  "class-validator.max.100": "Must be less than 100",
  "class-validator.isLatitude": "Must be a valid latitude",
  "class-validator.isLongitude": "Must be a valid longitude",
  // EXPLORER
  "explorer.navigation.menu.profile": "Profile",
  "explorer.navigation.menu.availableQueries": "Available queries",
  "explorer.navigation.availableQueries.label": "Queries:",
  "explorer.navigation.availableQueries.tooltip": "This is your currently available query amount for third party digital dossiers.",
  "explorer.navigation.route.home": "My Digital Dossier",
  "explorer.navigation.route.signUpRequest": "My Sign Up Request",
  "explorer.navigation.route.receivedAccessRequests": "Access Requests",
  "explorer.navigation.route.dossierExplorer": "Dossier Explorer",
  "explorer.navigation.route.sentAccessRequests": "Requests History",
  "explorer.digitalDossier.generalInformation.alert.title": "When reviewing the Dossier, keep in mind that some fields cannot be edited, since only Bolsa de Cereales users can enter information in them.",
  // Digital dossier
  "explorer.digitalDossier.getGeneralInfo.error": "Error loading general information",
  "explorer.digitalDossier.updateGeneralInfo.success.toast.title": "Your General Company Data approval request has been submitted successfully.",
  "explorer.digitalDossier.updateGeneralInfo.error.toast.text": "Please try again later",
  "explorer.changeRequest.alert.title": "You have data to review",
  "explorer.digitalDossier.getBankingInfo.error": "Error loading bank information",
  "explorer.digitalDossier.updateBankingInfo.success.toast.title": "Your Banking Information Company Data approval request has been submitted successfully.",
  "explorer.digitalDossier.updateBankingInfo.error.toast.text": "Please try again later",
  "explorer.digitalDossier.updateBankingInfo.accountSection.title": "Cuenta nro {{num}}",
  "explorer.digitalDossier.updateBankingInfo.addBankAccount": "Add bank account",
  "explorer.digitalDossier.updateBankingInfo.doYouHaveBankingInfo": "Do you have banking information?",
  "explorer.digitalDossier.updateBankingInfo.form.bankEntity.label": "Bank",
  "explorer.digitalDossier.updateBankingInfo.form.bankEntity.placeholder": "Enter bank name",
  "explorer.digitalDossier.updateBankingInfo.form.cbu.label": "CBU",
  "explorer.digitalDossier.updateBankingInfo.form.cbu.placeholder": "Enter CBU",
  "explorer.digitalDossier.updateBankingInfo.form.cbuDocument.label": "CBU certificate",
  "explorer.digitalDossier.updateBankingInfo.form.documentId.label": "Document identifier",
  "explorer.digitalDossier.updateBankingInfo.form.dueDate.label": "Due date",
  "explorer.signUp.modal.exitForm.title": "Are you sure about exiting this page?",
  "explorer.signUp.modal.exitForm.text": "If you confirm, you will lose all the information you entered.",
  "explorer.digitalDossier.explorer.subTitle": "Search company files, request viewing and stay up to date with the latest updates.",
  "explorer.digitalDossier.explorer.history": "Consulted dossiers",
  "explorer.digitalDossier.explorer.resultsTitle": "Results:",
  "explorer.digitalDossier.explorer.noResultsTitle": "No results for your search.",
  "explorer.digitalDossier.explorer.noResultsSubtitle": "It appears that no Files were found that match the search criteria you entered. Please verify your search details and try again.",
  "explorer.digitalDossier.explorer.action.view": "See digital dossier",
  "explorer.digitalDossier.explorer.action.requestAccess": "Request access",
  "explorer.digitalDossier.explorer.action.tooltip.hasntBeenApprovedDigitalDossier": "It is necessary that you finish uploading and approving your File in order to proceed with viewing third-party Files.",
  "explorer.digitalDossier.explorer.status.PENDING": "Pending",
  "explorer.digitalDossier.explorer.status.AVAILABLE": "Available",
  "explorer.digitalDossier.explorer.newSearch": "New search",
  "explorer.digitalDossier.explorer.newSearch.search.placeholder": "Search by CUIT or by company",
  "explorer.digitalDossier.explorer.newSearch.search.availableInquiries": "Available queries:",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.emptyState.title": "There are no legal representatives yet.",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.emptyState.description": "Bolsa will upload the legal representatives of your company, according to the documentation you provide and you will be able to see them here once they are available.",
  "explorer.digitalDossier.getLegalRepresentativesInfo.error": "Error loading legal representatives information",
  // BACKOFFICE
  "backoffice.navigation.route.home": "Digital dossiers",
  "backoffice.navigation.route.signupRequests": "Sign up requests",
  "backoffice.navigation.route.signupRequestsDetail": "Sign up requests",
  "backoffice.navigation.route.digitalDossiers": "Digital dossiers",
  "backoffice.navigation.route.digitalDossierDetail": "Digital dossiers",
  "backoffice.navigation.route.dossierQueries": "Dossier queries",
  "backoffice.navigation.route.cropPledges": "Crop Pledges",
  "backoffice.pages.dossierQueries.subTitle": "Manage the number of company queries and recharge their balance if necessary.",
  "backoffice.pages.dossierQueries.table.title.available": "Available Queries",
  "backoffice.pages.dossierQueries.table.title.lastLoad": "Date of Last Request",
  "backoffice.pages.dossierQueries.modal.title": "Load Queries",
  "backoffice.pages.dossierQueries.modal.subTitle": "Enter the number of queries and load the query contracts.",
  "backoffice.pages.dossierQueries.modal.amount.label": "Number of Queries",
  "backoffice.pages.dossierQueries.modal.amount.placeholder": "Enter number",
  "backoffice.pages.dossierQueries.modal.file.label": "Contract",
  "backoffice.pages.dossierQueries.modal.confirm": "Load",
  "backoffice.pages.digitalDossiers.table.search.placeholder": "Search by company name, CUIT",
  "backoffice.pages.digitalDossiers.table.statusFilter.placeholder": "Filter by status",
  "backoffice.pages.digitalDossiers.table.statusFilter.allText": "All",
  "backoffice.pages.signUpRequests.table.search.placeholder": "Search by company name, CUIT",
  "backoffice.pages.signUpRequests.table.statusFilter.placeholder": "Filter by status",
  "backoffice.pages.signUpRequests.table.statusFilter.allText": "All",
  "backoffice.pages.generalInformation.saveChanges": "Save changes",
  "backoffice.pages.generalInformation.saveAndApprove": "Save and approve",
  "backoffice.pages.generalInformation.requestRevision": "Request revision",
  "backoffice.pages.generalInformation.selectDate": "Select Date",
  "backoffice.pages.generalInformation.selectRuca": "Select RUCA",
  "backoffice.pages.generalInformation.typeIgj": "Type IGJ",
  "backoffice.pages.generalInformation.typeSignatureSchema": "Type signature schema",
  "backoffice.pages.generalInformation.selectSisaScoring": "Select scoring",
  "backoffice.pages.generalInformation.changeRequest.title": "Request review of general company data",
  "backoffice.pages.docsAndForms.changeRequest.title": "Request review of docs and forms data",
  "backoffice.pages.taxInformation.changeRequest.title": "Request review of tax information",
  "backoffice.pages.generalInformation.changeRequest.confirmButton": "Request review",
  "backoffice.pages.generalInformation.validationMessage.label": "Comments or observations",
  "backoffice.pages.generalInformation.validationMessage.placeholder": "Please provide a brief explanation of why you requested the review to ensure the correct information is entered.",
  "backoffice.pages.generalInformation.validationMessage.minLength": "This field must have at least 3 characters",
  "backoffice.pages.generalInformation.validationMessage.maxLength": "This field must be under 200 characters",
  "backoffice.pages.generalInformation.activityStartDate.startDateMustBeOlderThanEndDate": "The Start Date of Activity must be prior to the End Date of Activity",
  "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate": "The Start Date of Activity must be later than the End Date of Activity",
  "backoffice.digitalDossier.update.success.toast.title": "The information has been submitted successfully.",
  "backoffice.digitalDossier.approve.success.toast.title": "This section has been approved successfully.",
  "backoffice.digitalDossier.requestChange.success.toast.title": "Changes for this section have been requested successfully.",
  "backoffice.digitalDossier.update.error.toast.title": "An error occurred",
  "backoffice.digitalDossier.update.error.toast.text": "Please try again later",
  "backoffice.pages.bankInformation.bankName": "Bank",
  "backoffice.pages.bankInformation.bankName.placeholder": "Enter bank name",
  "backoffice.pages.bankInformation.cbu": "CBU",
  "backoffice.pages.bankInformation.cbu.placeholder": "Enter CBU",
  "backoffice.pages.bankInformation.cbuDocument": "CBU Certificate",
  "backoffice.pages.bankInformation.documentId": "Document Identifier",
  "backoffice.pages.bankInformation.documentId.placeholder": "Enter identifier",
  "backoffice.pages.bankInformation.expirationDate": "Expiration Date",
  "backoffice.pages.bankInformation.expirationDate.placeholder": "Expiration Date",
  "backoffice.pages.bankInformation.bankAccountTitle": "Bank account number {{bankAccountNumber}}",
  "backoffice.pages.bankInformation.removeBankForm": "Remove",
  "backoffice.pages.bankInformation.addBankForm": "Add bank account",
  "backoffice.pages.bankInformation.doYouHaveBankInfo": "Do you have bank details?",
  "backoffice.pages.bankInformation.changeRequest.title": "Request review of Tax Data",
  "backoffice.pages.taxInformation.cuitCertificateDocument.label": "CUIT Certificate",
  "backoffice.pages.taxInformation.cuitCertificateDocumentId.label": "Document Identifier",
  "backoffice.pages.taxInformation.cuitCertificateDocumentId.placeholder": "Enter identifier",
  "backoffice.pages.taxInformation.cuitCertificateDocumentExpirationDate.label": "Expiration Date",
  "backoffice.pages.taxInformation.cuitCertificateDocumentExpirationDate.placeholder": "Select date",
  "backoffice.pages.taxInformation.IVACondition.label": "VAT Condition",
  "backoffice.pages.taxInformation.IVACondition.placeholder": "Select condition",
  "backoffice.pages.taxInformation.IBB.label": "IIBB",
  "backoffice.pages.taxInformation.IBB.placeholder": "Select IIBB",
  "backoffice.pages.taxInformation.jurisdiction.label": "Jurisdiction",
  "backoffice.pages.taxInformation.jurisdiction.placeholder": "Select jurisdiction",
  "backoffice.pages.taxInformation.IBBCertificate.label": "IIBB Certificate",
  "backoffice.pages.taxInformation.IBBCertificateDocumentId.label": "Document Identifier",
  "backoffice.pages.taxInformation.IBBCertificateDocumentId.placeholder": "Enter identifier",
  "backoffice.pages.taxInformation.profitsDocument.label": "Select income tax",
  "backoffice.pages.taxInformation.profitsDocument.placeholder": "Select income tax",
  "backoffice.pages.taxInformation.CM05Certificate.label": "CM05",
  "backoffice.pages.taxInformation.ExemptionsCertificate.label": "Exemptions",
  "backoffice.pages.taxInformation.additionalDocumentation.label": "Additional Documentation",
  "backoffice.pages.taxInformation.additionalDocumentation.add": "Add additional documentation",
  "backoffice.pages.taxInformation.tobeFilledByBC.placeholder": "To be filled by the Exchange",
  "backoffice.pages.taxInformation.PROFIT_TYPES.REGISTERED": "Registered",
  "backoffice.pages.taxInformation.PROFIT_TYPES.NOT_REGISTERED": "Not Registered",
  "backoffice.pages.taxInformation.PROFIT_TYPES.EXEMPT": "Exempt",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_REGISTERED_RESPONSIBLE": "IVA Registered Responsible",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_EXEMPT_SUBJECT": "IVA Exempt Subject",
  "backoffice.pages.taxInformation.IVA_CONDITION.MONOTAX_RESPONSIBLE": "Monotax Responsible",
  "backoffice.pages.taxInformation.IVA_CONDITION.UNCATEGORIZED_SUBJECT": "Uncategorized Subject",
  "backoffice.pages.taxInformation.IVA_CONDITION.FOREIGN_SUPPLIER": "Foreign Supplier",
  "backoffice.pages.taxInformation.IVA_CONDITION.FOREIGN_CLIENT": "Foreign Client",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_RELEASED": "IVA Released",
  "backoffice.pages.taxInformation.IVA_CONDITION.MONOTRIBUTIST_SOCIAL": "Monotributist Social",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_NOT_REACHED": "IVA Not Reached",
  "backoffice.pages.taxInformation.IVA_CONDITION.PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST": "Promoted Independent Worker Monotributist",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.LOCAL_JURISDICTION": "Local Jurisdiction",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.MULTILATERAL_AGREEMENT": "Multilateral Agreement",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.EXEMPT": "Exempt",
  "backoffice.form.update.success.toast.title": "The section has been updated successfully.",
  "backoffice.form.approve.success.toast.title": "The section has been updated and approved successfully.",
  "common.expirationDate.error.dateFromPast": "This field is required and the expiration date cannot be exceeded",
  "common.pages.docsAndForms.sisaFile.label": "Signed SISA Public Consultation Copy",
  "common.pages.docsAndForms.statuteFile.label": "Statute/Social Contract",
  "common.pages.docsAndForms.statuteChangeFiles.label": "Statute Modifications",
  "common.pages.docsAndForms.additionalStatuteChangeFiles.label": "Add Statute Modifications",
  "common.pages.docsAndForms.assemblyBoardMinutesFiles.label": "Assembly and Board Minutes",
  "common.pages.docsAndForms.additionalAssemblyBoardMinutesFiles.label": "Add Minutes",
  "common.pages.docsAndForms.powerOfAttorneyFiles.label": "Power of Attorney",
  "common.pages.docsAndForms.additionalPowerOfAttorneyFiles.label": "Add Power of Attorney",
  "common.pages.docsAndForms.businessSingupForm.label": "Business Registration Form",
  "common.pages.docsAndForms.additionalDocument.label": "Additional document",
  "common.pages.docsAndForms.additionalDocument.addNew.label": "Add additional documentationl",
  // AMPLIFY
  //
  "amplify.email.placeholder": "Enter email",
  "amplify.fiscalId.placeholder": "Enter CUIT/CUIL",
  "amplify.password.placeholder": "Enter password",
  "amplify.confirmationCode.placeholder": "Enter your confirmation code",
  "amplify.newPassword.label": "New password",
  "amplify.newPassword.placeholder": "Enter your new password",
  "amplify.confirmPassword.label": "Confirm your password",
  "amplify.confirmPassword.placeholder": "Confirm your password",
  //
  "amplify.incorrectUsernameOrPassword": "Invalid credentials",
  "amplify.fiscalIdRequiredToSignIn": "CUIT/CUIL is required",
  "amplify.emailRequiredToSignIn": "Email is required",
  "amplify.passwordRequiredToSignIn": "Password is required",
  "amplify.fiscalIdRequiredToResetPassword": "CUIT/CUIL is required to reset password",
  "amplify.emailRequiredToResetPassword": "Email is required to reset password",
  "amplify.newPasswordIsRequiredToConfirmResetPassword": "New password is required",
  "amplify.confirmationCodeIsRequiredToConfirmResetPassword": "Confirmation code is required",
  "amplify.invalidVerificationCodeProvided": "Invalid confirmation code provided, please try again",
  "amplify.passwordAtLeast8Characters": "Password must have at least 8 characters",
  "amplify.passwordMustHaveSpecialCharacters": "Password must contain at least 1 of these special characters : !@#$%&*?",
  "amplify.passwordMustHaveLowercaseCharacters": "Password must contain at least 1 lowercase letter",
  "amplify.passwordMustHaveUppercaseCharacters": "Password must contain at least 1 upper case letter",
  "amplify.passwordMustHasNumber": "Password must contain at least 1 number",
  "amplify.passwordTooltip": "The password must be at least 8 characters and include uppercase and lowercase letters, at least one number, and one special character.",
  //
  "amplify.signIn.title": "Welcome!",
  "amplify.signIn.subtitle": "Enter your credentials to log in",
  "amplify.resetPassword.title": "Reset password",
  "amplify.forgotYourPassword": "Forgot your password?",
  "amplify.doNotHaveAnAccount": "You do not have an account?",
  "amplify.signup": "Sign up",
  // IVA_CONDITION
  "ivaCondition.IVA_REGISTERED_RESPONSIBLE": "Responsible IVA registered",
  "ivaCondition.IVA_EXEMPT_SUBJECT": "IVA exempt subject",
  "ivaCondition.MONOTAX_RESPONSIBLE": "Monotribute responsible",
  "ivaCondition.UNCATEGORIZED_SUBJECT": "Uncategorized subject",
  "ivaCondition.FOREIGN_SUPPLIER": "Foreign supplier",
  "ivaCondition.FOREIGN_CLIENT": "Foreign client",
  "ivaCondition.IVA_RELEASED": "IVA released - law no. 19640",
  "ivaCondition.MONOTRIBUTIST_SOCIAL": "Social monotributist",
  "ivaCondition.IVA_NOT_REACHED": "IVA not reached",
  "ivaCondition.PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST": "Promoted independent worker monotributista",
  // SIGNUP
  "errorCode.signupRequest.rejectionReason.required": "Rejection reason is required",
  "errorCode.signupRequest.rejectionReason.maxLength": "Rejection reason must be under 200 characters",
  "errorCode.renspa.invalidFormat": "The RENSPA identifier must follow the format 00.000.0.00000.00",
  "errorCode.exploitationType.isValid": "The exploitation type must be a valid type",
  // SIGNUP REQUEST DETAIL
  "signupRequestDetail.description": "Here you can manage the registration request. Approve, request a review or reject the request if necessary.",
  "signupRequestDetail.requestedDocumentChanges.alert.title": "Documentation review request",
  "signupRequestDetail.downloadPdf": "Download signup PDF",
  // REGISTER REQUEST
  "signUpRequest.generalCompanyInformation": "General company information",
  "signUpRequest.administratorData": "Datos de administrador",
  "signUpRequest.legalRepresentativeData": "Datos de representante legal",
  "signUpRequest.pageSubtitle": "Here you can manage the company registration request.",
  "signUpRequest.updateData": "Update information",
  "signUpRequest.form.signUpPermissionFile.label": "Accreditation of legal representation: upload the minutes, power of attorney or document from which your representation arises.",
  "signUpRequest.modal.label": "Are you sure to update the information?",
  "signUpRequest.modal.confirm": "Update information",
  "signUpRequest.toast.success.label": "The information was successfully updated",
  "signUpRequest.toast.success.text": "We will review the information and notify you when it is approved.",
  "signUpRequest.toast.error.label": "An error occurred",
  "signUpRequest.toast.error.text": "Please try again later.",
  // sections
  "signupRequestDetail.sections.generalData.title": "General company information",
  "signupRequestDetail.sections.administratorData.title": "Administrator data",
  "signupRequestDetail.sections.representativesData.title": "Legal representative {{representantId}}",
  // approve
  "signupRequestDetail.approveModal.title": "Are you sure to approve {{companyName}}'s signup request?",
  "signupRequestDetail.success.title": "The signup request was successfully approved",
  "signupRequestDetail.success.text": "The company was notified by email to complete its digital file.",
  "signupRequestDetail.error.title": "An error occurred",
  "signupRequestDetail.error.text": "Please try again later",
  // reject
  "signupRequestDetail.reject.modal.title": "Are you sure to reject {{companyName}}'s signup request?",
  "signupRequestDetail.reject.success.title": "Signup request was successfully rejected",
  "signupRequestDetail.reject.success.text": "An email was sent notifying the company.",
  "signupRequestDetail.reject.error.text": "Please try again later",
  "signupRequestDetail.reject.alert.title": "Reason for rejection",
  // request review
  "signupRequestDetail.requestReview.title": "Request review",
  "signupRequestDetail.requestReview.modal.title": "Are you sure to submit the review request for {{companyName}}?",
  "signupRequestDetail.requestReview.success.title": "Review request submitted successfully",
  "signupRequestDetail.requestReview.success.text": "An email was sent notifying the company.",
  "signupRequestDetail.requestReview.error.text": "Please try again later.",
  "signupRequestDetail.requestReview.radio.label": "Do you want to request the review of {{documentType}}?",
  "signupRequestDetail.requestReview.missingPermissionFile": "Please upload permission to sign the application.",
  "signupRequestDetail.requestReview.missingPermissionFile.title": "Do you want to request the upload of permission to sign the application?",
  // update
  "signupRequestDetail.updateSignupRequest.success.title": "You saved the data successfully",
  "signupRequestDetail.updateSignupRequest.error.text": "Please try again later.",
  // access requests
  "accessRequests.page.title": "Digital Dossier query history",
  "accessRequests.page.description": "Access the Digital Files you requested to view and stay up-to-date with the latest updates.\nRemember that each new update consumes queries from your balance.",
  "accessRequests.table.requestedAt": "Requested",
  "accessRequests.table.companyFiscalId": "CUIT",
  "accessRequests.table.companyName": "Company",
  "accessRequests.table.requestStatus": "Request status",
  "accessRequests.table.dossierStatus": "Dossier status",
  "accessRequests.table.dossierUpdatedAt": "Last updated",
  "accessRequests.table.accessRequestStatusFilter.placeHolder": "Filter by request status",
  "accessRequests.table.digitalDossierStatusFilter.placeHolder": "Filter by Dossier status",
  "accessRequests.status.PENDING": "Pending approval",
  "accessRequests.status.APPROVED": "Available",
  "accessRequests.status.REJECTED": "Rejected",
  "accessRequests.status.EXPIRED": "Expired",
  "accessRequests.status.REVOKED": "Access revoked",
  "accessRequests.status.digitalDossierStatus.APPROVED": "Approved",
  "accessRequests.status.digitalDossierStatus.RUCA_EXPIRED": "RUCA not current",
  "accessRequests.status.digitalDossierStatus.INFORMATION_EXPIRED": "Expired information",
  "accessRequests.successModal.title": "Your viewing request was successfully sent!",
  "accessRequests.successModal.description": "The company must now confirm your request to access and view its File.",
  "accessRequests.successModal.confirm": "Understood",
  // received access requests
  "receivedAccessRequests.page.title": "Access requests",
  "receivedAccessRequests.page.description": "Consult the companies that requested to see your Digital Dossier.",
  "receivedAccessRequests.table.requestedAt": "Date of request",
  "receivedAccessRequests.table.companyFiscalId": "CUIT",
  "receivedAccessRequests.table.requestedBy": "Requester",
  "receivedAccessRequests.table.requestStatus": "Status",
  "receivedAccessRequests.table.actions": "Actions",
  "receivedAccessRequests.table.accessibleSections": "Visible sections",
  "receivedAccessRequests.table.accessibleSections.button": "See visible sections",
  "receivedAccessRequests.status.PENDING": "Pending approval",
  "receivedAccessRequests.status.APPROVED": "Approved",
  "receivedAccessRequests.status.REJECTED": "Rejected",
  "receivedAccessRequests.status.EXPIRED": "Expired",
  "receivedAccessRequests.status.REVOKED": "Access revoked",
  "receivedAccessRequests.approveRequest.modal.title": "By approving this request you will be giving access to your digital dossier and contact information.",
  "receivedAccessRequests.approveRequest.modal.text": "If you want to share additional sections you must select them below:",
  "receivedAccessRequests.rejectRequest.modal.title": "Are you sure you want to reject the viewing request for {{selectedCompanyName}}?",
  "receivedAccessRequests.revokeRequest.modal.title": "Are you sure you want to revoke access for {{selectedCompanyName}} from your Digital Dossier?",
  "receivedAccessRequests.accessibleSections.modal.title": "Visible sections",
  "receivedAccessRequests.accessibleSections.modal.description": "You can view the different sections of the Digital File. Select the sections you want this user to see.",
  "receivedAccessRequests.approveRequest.success.title": "The approval request was successfully completed",
  "receivedAccessRequests.rejectRequest.success.title": "Access request successfully rejected",
  "receivedAccessRequests.revokeRequest.success.title": "Access successfully revoked",
  "receivedAccessRequests.accessibleSections.toast.success.title": "The sections were edited correctly.",
  "receivedAccessRequests.accessibleSections.toast.error.title": "There was an error editing the visible sections. Please try again.",
  "renewAccessRequest.modal.title": "Are you sure you want to renew this access request?",
  "renewAccessRequest.modal.text": "Remember that the renewal will consume 1 visualization request from your balance. You currently have {{remainingAccessRequestsTickets}} visualization requests remaining.",
  // Dropzone
  "dropzone.clickHereMessage": "Click here",
  "dropzone.orDropTheFileMessage": "or drop the file",
  "dropzone.tryAgainMessage": "Upload again",
  "dropzone.fileInvalidTypeMessage": "The file is invalid",
  // Shared digital dossier
  "sharedDigitalDossier.error.default": "Error when loading the digital dossier",
  "sharedDigitalDossier.error.FORBIDDEN_RESOURCE": "You do not have access to this digital dossier",
  "sharedDigitalDossier.alert.nonCurrentData.title": "This Dossier contains data that is not current.",
  "sharedDigitalDossier.alert.nonCurrentData.description": "We have already informed the company so that it can make the necessary changes. Once these are made by the client and approved by Bolsa, you will see a new update of the Dossier with the changes made.",
  "sharedDigitalDossier.bankingInfo.emptyState.title": "No data to display",
  "sharedDigitalDossier.bankingInfo.emptyState.description": "{{companyName}} did not enter data in this section of the Dossier.",
  "sharedDigitalDossier.affidavits.productiveFacilities.emptyState.title": "No facility has been approved yet",
  "sharedDigitalDossier.affidavits.productiveFacilities.emptyState.description": "When a facility is approved, it will be listed here along with all its affidavits.",
  "sharedDigitalDossier.affidavits.storageFacilities.emptyState.title": "No stockpile has been approved yet",
  "sharedDigitalDossier.affidavits.storageFacilities.emptyState.description": "When a stockpile is approved, it will be listed here along with it affidavit.",
  "sharedDigitalDossier.equityInformation.emptyState.title": "No equity infofmation has been approved yet",
  "sharedDigitalDossier.equityInformation.emptyState.description": "When equity information is approved, it will be listed here.",
  "sharedDigitalDossier.contactInformation.emptyState.title": "No contact infofmation has been approved yet",
  "sharedDigitalDossier.contactInformation.emptyState.description": "When contact information is approved, it will be listed here.",
  "sharedDigitalDossier.restrictedSection.title": "You currently do not have access to this section",
  "sharedDigitalDossier.restrictedSection.description": "If you have any questions or would like to request access to this section, please contact the company.",
  // My Digital Dossier - Legal Representatives section
  "digitalDossier.legalRepresentatives.error.startOfTermMustBeNewerThanEndOfTerm": "The start date of term must be prior to the end date",
  "digitalDossier.legalRepresentatives.error.endOfTermMustBeOlderThanStartOfTerm": "The end date of term must be after the start date",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.idDocument": "Identity document image",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.idOfTheAuthorizedLegalRepresentationDocument": "Identification of the authorized legal representation document",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.hasCurrencyCap": "Amount cap",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.hasProductCap": "Product cap",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.addProductCap": "Add product cap",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.addCurrencyCap": "Add amount cap",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.addRepresentative": "Add representative",
  "backoffice.digitalDossier.updateRepresentantsInformation.success.toast.title": "Data saved successfully.",
  "backoffice.digitalDossier.approveRepresentantsInformation.success.toast.title": "The legal representatives were successfully approved.",
  "backoffice.digitalDossier.requestReviewRepresentantsInformation.success.toast.title": "The legal representatives review request was successfully submitted.",
  "digitalDossier.updateLegalRepresentantivesInfo.representativeSection.title": "Legal representative {{num}}",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.firstName": "Enter firstname",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.lastName": "Enter lastname",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identityDocumentType": "Select document type",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identityDocumentId": "Enter document",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.email": "Enter email",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.position": "Select position",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.startOfTerm": "Select date",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.endOfTerm": "Select date",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identifier": "Enter identifier",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.expirationDate": "Select date",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.bcAuthorizedDocumentIdentifier": "Enter document name",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.signatureLevel": "Select signature level",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.powerOfAttorneyExchange": "Select exchange",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.product": "Select product",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.amount": "Enter amount",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.currency": "Select currency",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.tons": "Enter tons",
  // legal representatives section
  "digitalDossier.legalRepresentatives.representativeCaps": "Representative caps",
  "digitalDossier.legalRepresentatives.requestChangesModal.title": "Request review of legal representatives",
  // Affidavits
  // Producers
  "explorer.productiveFacilities.addFacility": "Add facility",
  "explorer.productiveFacilities.editFacility": "Edit facility",
  "explorer.productiveFacilities.addAffidavit": "Add affidavit",
  "explorer.productiveFacilities.editAffidavit": "Edit affidavit",
  "explorer.productiveFacilities.getInfo.error": "Error loading productive facilities",
  "explorer.productiveFacilities.emptyState.title": "There is no added establishment.",
  "explorer.productiveFacilities.emptyState.description": "Add a new establishment to record all its information.",
  "explorer.productiveFacilities.deleteFacility.modal.title": "Are you sure you want to delete the establishment?",
  "explorer.productiveFacilities.deleteFacility.modal.text": "You will not be able to reverse this action",
  "explorer.productiveFacilities.deleteFacility.success.title": "Facility successfully removed",
  "explorer.productiveFacilities.deleteAffidavit.modal.title": "Are you sure you want to delete the affidavit?",
  "explorer.productiveFacilities.deleteAffidavit.modal.text": "You will not be able to reverse this action",
  "explorer.productiveFacilities.deleteAffidavit.success.title": "Successfully deleted affidavit",
  "productiveFacilities.accordion.title": "Facility {{n}}",
  "productiveFacilities.affidavitsEmptyState.title": "You have not added any affidavit yet",
  "productiveFacilities.affidavitsEmptyState.description": "To request approval of the facility you must upload at least one affidavit.",
  "productiveFacilities.facilityStatusAlert.PENDING_CHANGE_REQUEST.title": "You have data to review. Click 'Edit' to modify the necessary fields. Once edited, request approval again.",
  "productiveFacilities.upsert.establishmentName.label": "Establishment name",
  "productiveFacilities.upsert.establishmentName.placeholder": "Enter establishment",
  "explorer.productiveFacilities.create.success.title": "Facility created successfully",
  "explorer.productiveFacilities.update.success.title": "Facility updated successfully",
  "explorer.productiveFacilities.createAffidavit.success.title": "Affidavit created successfully",
  "explorer.productiveFacilities.updateAffidavit.success.title": "Affidavit updated successfully",
  "explorer.productiveFacilities.requestApproval.success.title": "Approval request sent successfully",
  "backoffice.productiveFacilities.approve.success.title": "Facility approved successfully",
  "backoffice.productiveFacilities.requestChanges.success.title": "Review request sent successfully",
  "productiveFacilities.upsert.province.label": "Province",
  "productiveFacilities.upsert.province.placeholder": "Select province",
  "productiveFacilities.upsert.locality.label": "Locality",
  "productiveFacilities.upsert.locality.placeholder": "Select locality",
  "productiveFacilities.upsert.locality.noOptionsMessage": "Your search did not match any results. Please try again.",
  "productiveFacilities.upsert.geolocationDocument.label": "Geolocation",
  "productiveFacilities.upsert.ownership.label": "Ownership",
  "productiveFacilities.upsert.ownership.placeholder": "Select ownership",
  "productiveFacilities.upsert.productiveHectares.label": "Productive has",
  "productiveFacilities.upsert.productiveHectares.placeholder": "Enter productive has",
  "productiveFacilities.upsert.exploitationType.label": "Exploitation type",
  "productiveFacilities.upsert.exploitationType.placeholder": "Enter exploitation type",
  "productiveFacilities.upsert.startDate.label": "Start date",
  "productiveFacilities.upsert.startDate.placeholder": "Select date",
  "productiveFacilities.upsert.endDate.label": "End date",
  "productiveFacilities.upsert.endDate.placeholder": "Select date",
  "productiveFacilities.upsert.renspa.label": "RENSPA",
  "productiveFacilities.upsert.renspa.placeholder": "Enter RENSPA",
  "productiveFacilities.upsert.currentRenspa.label": "Current RENSPA",
  "productiveFacilities.upsert.currentRenspa.placeholder": "Enter validity",
  "productiveFacilities.upsert.addNewAffidavit": "Add new",
  "productiveFacilities.upsert.newAffidavit.title": "Affidavit {{n}}",
  // Storage
  "explorer.storageFacilities.title": "Storage facilities",
  "explorer.storageFacilities.addFacility": "Add storage facility",
  "explorer.storageFacilities.editFacility": "Edit storage facility",
  "explorer.storageFacilities.addAffidavit": "Add affidavit",
  "explorer.storageFacilities.editAffidavit": "Edit affidavit",
  "explorer.storageFacilities.getInfo.error": "Error loading storage facilities",
  "explorer.storageFacilities.emptyState.title": "There is no added establishment.",
  "explorer.storageFacilities.emptyState.description": "Add a new establishment to record all its information.",
  "explorer.storageFacilities.deleteFacility.modal.title": "Are you sure you want to delete the establishment?",
  "explorer.storageFacilities.deleteFacility.modal.text": "You will not be able to reverse this action",
  "explorer.storageFacilities.deleteFacility.success.title": "Facility successfully removed",
  "explorer.storageFacilities.deleteAffidavit.modal.title": "Are you sure you want to delete the affidavit?",
  "explorer.storageFacilities.deleteAffidavit.modal.text": "You will not be able to reverse this action",
  "explorer.storageFacilities.deleteAffidavit.success.title": "Successfully deleted affidavit",
  "storageFacilities.accordion.title": "Facility {{n}}",
  "explorer.storageFacilities.affidavitsEmptyState.title": "You have not added any affidavit yet",
  "explorer.storageFacilities.affidavitsEmptyState.description": "To request approval of the storage facility you must upload at least one affidavit.",
  "storageFacilities.storage facilityStatusAlert.PENDING_CHANGE_REQUEST.title": "You have data to review. Click 'Edit' to modify the necessary fields. Once edited, request approval again.",
  "storageFacilities.upsert.identifier.label": "Facility name",
  "storageFacilities.upsert.identifier.placeholder": "Enter facility name",
  "explorer.storageFacilities.create.success.title": "Facility created successfully",
  "explorer.storageFacilities.update.success.title": "Facility updated successfully",
  "explorer.storageFacilities.createAffidavit.success.title": "Affidavit created successfully",
  "explorer.storageFacilities.updateAffidavit.success.title": "Affidavit updated successfully",
  "explorer.storageFacilities.requestApproval.success.title": "Approval request sent successfully",
  "storageFacilities.upsert.province.label": "Province",
  "storageFacilities.upsert.province.placeholder": "Select province",
  "storageFacilities.upsert.locality.label": "Locality",
  "storageFacilities.upsert.locality.placeholder": "Select locality",
  "storageFacilities.upsert.locality.noOptionsMessage": "Your search did not match any results. Please try again.",
  "storageFacilities.upsert.ownership.label": "Ownership",
  "storageFacilities.upsert.ownership.placeholder": "Select ownership",
  "storageFacilities.upsert.storageCapacity.label": "Storage capacity (in tons)",
  "storageFacilities.upsert.storageCapacity.placeholder": "Enter capacity",
  "storageFacilities.upsert.rucaStatus.label": "RUCA",
  "storageFacilities.upsert.rucaStatus.placeholder": "Select current",
  "storageFacilities.upsert.startDate.label": "Start date",
  "storageFacilities.upsert.startDate.placeholder": "Select date",
  "storageFacilities.upsert.endDate.label": "End date",
  "storageFacilities.upsert.endDate.placeholder": "Select date",
  "storageFacilities.upsert.observations.label": "Observations",
  "storageFacilities.upsert.observations.placeholder": "Enter Observations",
  "storageFacilities.upsert.addNewAffidavit": "Add new",
  "storageFacilities.upsert.newAffidavit.title": "Affidavit",
  "backoffice.storageFacilities.approve.success.title": "Facility approved successfully",
  "backoffice.storageFacilities.requestChanges.success.title": "Request review sent successfully",
  "backoffice.storageFacilities.affidavitsEmptyState.title": "You have not added an affidavit yet",
  "backoffice.storageFacilities.affidavitsEmptyState.description": "To approve the facility you must upload one affidavit.",
  // My Digital Dossier - Equity Information section
  "backoffice.equityInformation.validationMessage.minLength": "This field must have at least 3 characters",
  "backoffice.equityInformation.validationMessage.maxLength": "This field must be under 200 characters",
  "common.equityInformation.balance.title": "Balance",
  "common.equityInformation.add.balance": "Add balance",
  "common.equityInformation.additionalDocument.title": "Additional document",
  "common.equityInformation.add.additionalDocument": "Add additional document",
  "common.cropPledgeNumber": "Number of crop pledge",
  "common.creditor": "Creditor",
  "common.debtor": "Debtor",
  "common.expiration": "Expiration",
  "cropPledges.freeTheCrop": "Release crop pledge",
  "explorer.equityInformation.toast.success.title": "Your Equity Information approval request has been submitted successfully.",
  "backoffice.equityInformation.toast.success.title": "Equity Information has been submitted successfully.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_ACTIVE.title": "You have data to review.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_ACTIVE.text": "We have registered that your registration in RUCA is not valid. Therefore, this dossier will continue to be active only for activities that do not require this registration.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_ACTIVE.title": "RUCA not current.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_ACTIVE.text": "The registration in RUCA is not valid. This dossier will continue to be active only for activities that do not require this registration.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_EXPIRED.title": "You have data to review.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_EXPIRED.text": "We have registered that your registration in RUCA is not valid. Since your registration is associated with activities that require this registration, your dossier will expire until the necessary update is made by the corresponding entity.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_EXPIRED.title": "RUCA not current.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_EXPIRED.text": "The registration in RUCA is not valid. Since the registration is associated with activities that require this registration, the dossier will remain expired until the necessary update is made by the corresponding entity.",
  // PRENDA DE CULTIVO
  "errorCode.cropPledge.maritalStatus": "Must be a valid marital status",
  "errorCode.cropPledge.nationality": "Must be a valid nationality",
  "cropPledge.page.title.label": "Pledge #{{cropPledgeNumber}}",
  "cropPledge.page.tab.creditor": "Creditor",
  "cropPledge.page.tab.debtor": "Debtor",
  "cropPledge.page.button.create": "Crear crop pledge",
  "cropPledge.table.column.internalIdentifier": "Nro of pledge",
  "cropPledge.table.column.companyName": "Company",
  "cropPledge.table.column.fiscalId": "CUIT",
  "cropPledge.table.column.expirationDate": "Expiration",
  "cropPledge.table.column.status": "Status",
  "cropPledge.table.column.actions": "Actions",
  "cropPledge.table.button.release": "Mark as stolen",
  "cropPledge.form.igj.label": "IGJ/Public commercial registry",
  "cropPledgeDetails.button.digitalDossier": "Go digital dossier",
  "cropPledge.actions.approve": "Confirm pledge",
  "cropPledge.actions.reject": "Reject pledge",
  "cropPledge.actions.approve.tooltip.pendingSections.text": "The pledge has pending sections to be completed. Please complete the missing information before confirming the pledge.",
  "cropPledge.actions.approve.modal.title": "Are you sure you want to confirm this pledge?",
  "cropPledge.actions.approve.modal.text": "The estimated production amount is  {{currency}} {{amount}}.",
  "cropPledge.actions.approve.modal.confirmLabel": "Confirm",
  "cropPledge.actions.reject.modal.title": "Are you sure you want to reject this pledge?",
  "cropPledge.actions.reject.modal.text": `You won't be able to reverse this action.`,
  "cropPledge.actions.reject.modal.confirmLabel": "Reject",
  "cropPledge.actions.markAsPaid": "Mark as collected",
  "cropPledge.actions.markAsPaid.modal.title": "Are you sure you want to mark this pledge as collected?",
  "cropPledge.actions.markAsPaid.modal.text": "By continuing, Bolsa will proceed to manage the release of the Pledge in the Pledge Registry and we will inform you of any progress in the process.",
  "cropPledge.actions.markAsPaid.modal.confirmLabel": "Continue",
  "cropPledge.actions.markAsPaid.modal.success.title": "The pledge #{{id}} was successfully marked as collected",
  "cropPledge.actions.markAsRegistered": "Mark as registered",
  "cropPledge.actions.markAsRegistered.modal.title": "Are you sure you want to mark this pledge as registered?",
  "cropPledge.actions.markAsRegistered.modal.text": "To register the pledge, you must upload proof of pledge registration. Once the document is uploaded and the garment is approved, you will not be able to make any further edits to it.",
  "cropPledge.actions.markAsRegistered.modal.file.label": "Pledge registration document",
  "cropPledge.actions.markAsRegistered.modal.confirmLabel": "Register",
  "cropPledge.actions.markAsRegistered.modal.success.title": "The registration request for Pledge #{{id}} was made successfully.",
  "cropPledge.actions.release": "Release pledge",
  "cropPledge.actions.release.modal.title": "Are you sure you want to release this pledge?",
  "cropPledge.actions.release.modal.text": "To mark it as released, you must upload proof of the pledge registration. Once the document is loaded and the pledge is released, it cannot be used again.",
  "cropPledge.actions.release.modal.file.label": "Proof",
  "cropPledge.actions.release.modal.confirmLabel": "Release",
  "cropPledge.actions.release.modal.success.title": "Pledge #{{id}} was successfully released.",
  "cropPledge.creditor.searchForm.fiscalId.label": "Company CUIT",
  "cropPledge.creditor.searchForm.fiscalId.placeholder": "Search CUIT",
  "cropPledge.reject.toast.success": "The pledge was successfully rejected",
  "cropPledge.approve.toast.success": "The pledge was successfully approved",
  "cropPledge.backoffice.pendingRegistrationAlert.title": "Pledge #{{id}} has not yet been registered.",
  "cropPledge.backoffice.pendingRegistrationAlert.description": "Please, once you have the signatures of the creditor and the debtor, proceed to register the pledge in the pledge registry and mark the pledge as registered on the platform. Subsequently, a modal will open where you can upload proof of the pledge registration. Please note that once the receipt is uploaded, you will not be able to make changes.",
  "cropPledge.creditor.lotsAmountAlert.description": "The estimated production amount is {{currency}} {{amount}}.",
  // CROP PLEDGE BACKOFFICE
  "backoffice.cropPledge.alert.title": "Data editing is not available in this section.",
  "backoffice.cropPledge.alert.subtitle": 'To make changes, go to the "Digital Dossier" section, make the corresponding modification and approve it. If you make changes, the debtor will need to create a new pledge for the updates to be applied, as the initiated pledge will retain the old data.',
  // SUCCESS TOASTS
  "explorer.digitalDossier.taxInfo.update.success.toast": "Your tax information update request has been submitted successfully",
  "explorer.digitalDossier.legalRepsInfo.update.success.toast": "Your legal representatives update request has been submitted successfully",
  "explorer.digitalDossier.formsAndDocsInfo.update.success.toast": "Your forms and documents update request has been submitted successfully",
  // CROP PLEDGE FARM INFO LEASE CONTRACT TYPES
  "common.LEASE_CONTRACT_TYPES.LEASE.title": "Lease",
  "common.LEASE_CONTRACT_TYPES.ACCIDENTAL_LEASE.title": "Accidental lease",
  "common.LEASE_CONTRACT_TYPES.SHARECROPPING.title": "Sharecropping",
  "common.LEASE_CONTRACT_TYPES.ACCIDENTAL_SHARECROPPING.title": "Accidental sharecropping",
  "common.LEASE_CONTRACT_TYPES.PERCENTAGE_BASED_FARMING.title": "Percentage based farming",
  "common.LEASE_CONTRACT_TYPES.ASSOCIATIVE.title": "Associative",
  "common.LEASE_CONTRACT_TYPES.FREE_TRANSFER_WITH_USUFRUCT_RIGHTS.title": "Free transfer with usufruct rights",
  "common.LEASE_CONTRACT_TYPES.PAID_TRANSFER_WITH_USUFRUCT_RIGHTS.title": "Paid transfer with usufruct rights",
  "common.LEASE_CONTRACT_TYPES.JOINT_EXPLOITATION_CONTRACT.title": "Joint exploitation contract",
  "common.LEASE_CONTRACT_TYPES.OTHER.title": "Other",
  // CROP PLEDGE FARM INFO DETAIL
  // FARM INFO
  "cropPledge.farmInfo.form.identifier.label": "Farm identifier",
  "cropPledge.farmInfo.form.identifier.placeholder": "Enter farm identifier",
  "cropPledge.farmInfo.form.cadastralNomenclature.label": "Cadastral nomenclature",
  "cropPledge.farmInfo.form.cadastralNomenclature.placeholder": "Enter cadastral nomenclature",
  "cropPledge.farmInfo.form.totalHectares.label": "Total hectares",
  "cropPledge.farmInfo.form.totalHectares.placeholder": "Enter total hectares",
  "cropPledge.farmInfo.form.province.label": "Province",
  "cropPledge.farmInfo.form.province.placeholder": "Select province",
  "cropPledge.farmInfo.form.locality.label": "Locality",
  "cropPledge.farmInfo.form.locality.placeholder": "Select locality",
  "cropPledge.farmInfo.form.address.label": "Address",
  "cropPledge.farmInfo.form.address.placeholder": "Enter address",
  "cropPledge.farmInfo.form.postalCode.label": "Postal code",
  "cropPledge.farmInfo.form.postalCode.placeholder": "Enter postal code",
  "cropPledge.farmInfo.form.productionEstimateOfLots.label": "Estimated production of lots to be pledged (USD)",
  "cropPledge.farmInfo.form.productionEstimateOfLots.toBeCompletedByBolsa": "It will be completed when Bolsa assigns amounts to the lots",
  "cropPledge.farmInfo.form.geolocation.label": "Geolocation",
  "cropPledge.farmInfo.form.geolocation.supportedFileTypes": "KMZ or GeoJSON",
  "cropPledge.farmInfo.form.latitudeOfBarycenter.label": "Latitude of the barycenter",
  "cropPledge.farmInfo.form.latitudeOfBarycenter.placeholder": "Enter latitude",
  "cropPledge.farmInfo.form.longitudeOfBarycenter.label": "Longitude of the barycenter",
  "cropPledge.farmInfo.form.longitudeOfBarycenter.placeholder": "Enter longitude",
  // FARM PROPIETARY INFO
  "cropPledge.farmPropietaryData.form.isPropietary.label": "Propietary",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.label": "Aditional documentation",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.helperText": "This documentation may include information about ownership of the field, deed, lease, etc., depending on the type of owner.",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.add": "Add aditional documentation",
  "cropPledge.farmPropietaryData.form.contractType.label": "Contract type",
  "cropPledge.farmPropietaryData.form.contractType.placeholder": "Select contract type",
  "cropPledge.farmPropietaryData.form.incumbentFiscalId.label": "Establishment owner",
  "cropPledge.farmPropietaryData.form.incumbentFiscalId.placeholder": "Enter CUIT/CUIL",
  "cropPledge.farmPropietaryData.form.activityStartDate.label": "Start date",
  "cropPledge.farmPropietaryData.form.activityStartDate.placeholder": "Enter date",
  "cropPledge.farmPropietaryData.form.activityEndDate.label": "End date",
  "cropPledge.farmPropietaryData.form.activityEndDate.placeholder": "Enter date",
  // LOT AFFIDAVITS INFO
  "cropPledge.lotAffidavitsData.title": "Lots affidavits",
  "cropPledge.lotAffidavitsData.addAffidavit": "Add affidavit",
  "cropPledge.lotAffidavitsData.lotNumber": "Lot #{{lotNumber}}",
  "cropPledge.lotAffidavitsData.form.lotIdentifier.label": "Lot identifier",
  "cropPledge.lotAffidavitsData.form.lotIdentifier.placeholder": "Enter identifier",
  "cropPledge.lotAffidavitsData.form.areaPercentage.label": "% of the lot on the farm surface",
  "cropPledge.lotAffidavitsData.form.areaPercentage.placeholder": "Enter percentage",
  "cropPledge.lotAffidavitsData.form.geolocation.label": "Geolocation",
  "cropPledge.lotAffidavitsData.form.geolocation.supportedFileTypes": "KMZ or GeoJSON",
  "cropPledge.lotAffidavitsData.form.latitudeOfBarycenter.label": "Latitude of the barycenter",
  "cropPledge.lotAffidavitsData.form.latitudeOfBarycenter.placeholder": "Enter latitude",
  "cropPledge.lotAffidavitsData.form.longitudeOfBarycenter.label": "Longitude of the barycenter",
  "cropPledge.lotAffidavitsData.form.longitudeOfBarycenter.placeholder": "Enter longitude",
  "cropPledge.lotAffidavitsData.form.crop.label": "Crop",
  "cropPledge.lotAffidavitsData.form.crop.placeholder": "Select crop",
  "cropPledge.lotAffidavitsData.form.startDate.label": "Start date",
  "cropPledge.lotAffidavitsData.form.startDate.placeholder": "Enter date",
  "cropPledge.lotAffidavitsData.form.endDate.label": "End date",
  "cropPledge.lotAffidavitsData.form.endDate.placeholder": "Enter date",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason.label": "Average yield of the previous season",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason.placeholder": "Enter average",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason1.label": "Average yield of the previous season +1",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason1.placeholder": "Enter average",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason2.label": "Average yield of the previous season +2",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason2.placeholder": "Enter average",
  "cropPledge.lotAffidavitsData.form.estimatedLotProductionAmount.label": "Estimated production amount (USD)",
  "cropPledge.lotAffidavitsData.form.estimatedLotProductionAmount.placeholder": "Enter amount",
  // DOCUMENTATION SECTION
  "cropPledge.documentationSection.form.loanContractFile.label": "Loan contract",
  "cropPledge.documentationSection.form.loanContractFile.expirationDateHelperText": "This expiration is from the last lot and establishes the expiration date of the pledge.",
  "cropPledge.documentationSection.form.carbonAnalysisFile.label": "Carbon analysis",
  "cropPledge.documentationSection.form.domainReportFile.label": "Domain report",
  "cropPledge.documentationSection.form.modificationFormFile.label": "Form 6 (endorsement/modification)",
  "cropPledge.documentationSection.form.additionalDocumentFiles.label": "Additional documentation",
  "cropPledge.documentationSection.form.additionalDocumentFiles.add": "Add additional documentation",
  "cropPledge.farmInfo.form.registeredPledgeFile.label": "Registered pledge",
  "cropPledge.farmInfo.form.deregistrationOfPledgeFile.label": "Deregistration of pledge",
  // PLEDGE INFORMATION SECTION
  "cropPledge.pledgeInformation.form.celebrationProvince.label": "Place",
  "cropPledge.pledgeInformation.form.celebrationProvince.placeholder": "Select place",
  "cropPledge.pledgeInformation.form.celebratedAt.label": "Celebration date",
  "cropPledge.pledgeInformation.form.celebratedAt.placeholder": "Enter date",
  "cropPledge.pledgeInformation.form.pledgeClass.label": "Class",
  "cropPledge.pledgeInformation.form.pledgeClass.placeholder": "Select class",
  "cropPledge.pledgeInformation.form.degree.label": "Degree",
  "cropPledge.pledgeInformation.form.degree.placeholder": "Select degree",
  "cropPledge.pledgeInformation.form.currency.label": "Currency type",
  "cropPledge.pledgeInformation.form.currency.placeholder": "Select currency",
  "cropPledge.pledgeInformation.form.contractAmount.label": "Contract amount",
  "cropPledge.pledgeInformation.form.contractAmount.placeholder": "Enter amount",
  "cropPledge.pledgeInformation.form.contractAmountInText.label": "Contract amount in text",
  "cropPledge.pledgeInformation.form.contractAmountInText.placeholder": "Enter amount in text",
  "cropPledge.pledgeInformation.form.exchangeRate.label": "Exchange rate",
  "cropPledge.pledgeInformation.form.exchangeRate.placeholder": "Enter rate",
  "cropPledge.pledgeInformation.form.amountInPesos.label": "Equivalence in national currency",
  "cropPledge.pledgeInformation.form.amountInPesos.helperText": "The equivalence is automatically calculated as amount \xD7 exchange rate.",
  "cropPledge.pledgeInformation.form.obligationConcept.label": "Obligation concept",
  "cropPledge.pledgeInformation.form.obligationConcept.placeholder": "Enter concept",
  "cropPledge.pledgeInformation.form.documentation.label": "Documentation",
  "cropPledge.pledgeInformation.form.documentation.placeholder": "Enter documentation",
  "cropPledge.pledgeInformation.form.paymentMethodsAndTerms.label": "Payment methods and terms",
  "cropPledge.pledgeInformation.form.paymentMethodsAndTerms.placeholder": "Enter payment methods and terms",
  "cropPledge.pledgeInformation.form.annualInterestRate.label": "Annual interest rate",
  "cropPledge.pledgeInformation.form.annualInterestRate.placeholder": "Enter rate",
  "cropPledge.pledgeInformation.form.paymentProvince.label": "Payment place",
  "cropPledge.pledgeInformation.form.paymentProvince.placeholder": "Select place",
  "cropPledge.pledgeInformation.form.creditorInspectionRights.label": "Creditor inspection rights",
  "cropPledge.pledgeInformation.form.creditorInspectionRights.placeholder": "Select creditor inspection rights",
  "cropPledge.pledgeInformation.form.liens.label": "Liens",
  "cropPledge.pledgeInformation.form.liens.placeholder": "Enter liens",
  // PLEDGE INSURANCE INFO SECTION
  "cropPledge.pledgeInsuranceInformation.form.hasInsurance.label": "Pledge has insurance?",
  "cropPledge.pledgeInsuranceInformation.form.insuranceType.label": "Insurance type",
  "cropPledge.pledgeInsuranceInformation.form.insuranceType.placeholder": "Select insurance type",
  "cropPledge.pledgeInsuranceInformation.form.currency.label": "Currency type",
  "cropPledge.pledgeInsuranceInformation.form.currency.placeholder": "Select currency",
  "cropPledge.pledgeInsuranceInformation.form.amount.label": "Amount",
  "cropPledge.pledgeInsuranceInformation.form.amount.placeholder": "Enter amount",
  "cropPledge.pledgeInsuranceInformation.form.insuranceCompany.label": "Company",
  "cropPledge.pledgeInsuranceInformation.form.insuranceCompany.placeholder": "Enter company",
  "cropPledge.pledgeInsuranceInformation.form.streetName.label": "Street",
  "cropPledge.pledgeInsuranceInformation.form.streetName.placeholder": "Enter street",
  "cropPledge.pledgeInsuranceInformation.form.streetNumber.label": "Number",
  "cropPledge.pledgeInsuranceInformation.form.streetNumber.placeholder": "Enter number",
  "cropPledge.pledgeInsuranceInformation.form.province.label": "Province",
  "cropPledge.pledgeInsuranceInformation.form.province.placeholder": "Select province",
  "cropPledge.pledgeInsuranceInformation.form.locality.label": "Locality",
  "cropPledge.pledgeInsuranceInformation.form.locality.placeholder": "Search locality",
  "cropPledge.pledgeInsuranceInformation.form.postalCode.label": "Postal code",
  "cropPledge.pledgeInsuranceInformation.form.postalCode.placeholder": "Enter postal code",
  "cropPledge.pledgeInsuranceInformation.form.policyNumber.label": "Policy number",
  "cropPledge.pledgeInsuranceInformation.form.policyNumber.placeholder": "Enter policy number"
};

// src/locales/es.ts
var locales_ES = {
  // ACCESSIBLE SECTIONS
  "accessibleSection.DIGITAL_DOSSIER": "Legajo digital",
  "accessibleSection.CONTACT_INFORMATION": "Datos de contacto",
  "accessibleSection.DECLARED_JURISDICTIONS": "Declaraciones juradas",
  "accessibleSection.ASSET_INFORMATION": "Informaci\xF3n patrimonial",
  // COMPANY_ACTIVITIES
  "companyActivities.PRODUCER": "Productor",
  "companyActivities.RUNNER": "Corredor",
  "companyActivities.CEREAL_MARKET_AT_THE_END": "Mercado de cereales al final",
  "companyActivities.OPERATOR_WITH_PLANT": "Operador con planta",
  "companyActivities.OPERATOR_WITHOUT_PLANT": "Operador sin planta",
  "companyActivities.EXCHANGER": "Canjeador",
  // COMPANY_TYPES
  "companyTypes.PF": "Persona fisica",
  "companyTypes.SH": "Sociedades de hecho",
  "companyTypes.SA": "Sociedad anonima",
  "companyTypes.SRL": "Sociedad responsabildiad limitada",
  "companyTypes.SAS": "Sociedad anonima simplificada",
  "companyTypes.SAU": "Sociedad anonima unipersonal",
  "companyTypes.COOP": "Cooperativa",
  "companyTypes.AS": "Asociaciones civiles",
  "companyTypes.FUND": "Fundaciones",
  "companyTypes.FID": "Fideicomisos",
  "companyTypes.OTHER": "Otro",
  // SISA_ACTIVITIES
  "sisaActivities.PRODUCER": "Productor",
  "sisaActivities.BROKER": "Corredor",
  "sisaActivities.OPERATOR_WITH_A_PLANT": "Operador con planta",
  "sisaActivities.OPERATOR_WITHOUT_A_PLANT": "Operador sin planta",
  "sisaActivities.BARTERER": "Canjeador",
  "sisaActivities.FUTURES_GRAIN_MARKET": "Mercado de cereales a t\xE9rmino",
  // SISA_SCORING
  "sisaScoring.SITUATION_1": "Situaci\xF3n 1",
  "sisaScoring.SITUATION_2": "Situaci\xF3n 2",
  "sisaScoring.SITUATION_3": "Situaci\xF3n 3",
  // RUCA_STATUSES
  "rucaStatus.CURRENT": "Vigente",
  "rucaStatus.NOT_CURRENT": "No vigente",
  // MARITAL_STATUSES
  "maritalStatus.SINGLE": "Soltero/a",
  "maritalStatus.MARRIED": "Casado/a",
  "maritalStatus.DIVORCED": "Divorciado/a",
  "maritalStatus.WIDOWED": "Viudo/a",
  // COMMON
  "common.downloadPdf": "Descargar PDF",
  "common.seeInBlockchain": "Ver en Blockchain",
  "common.genericError": "Se produjo un error, por favor intentalo de nuevo m\xE1s tarde.",
  "common.yes": "Si",
  "common.no": "No",
  "common.reset": "Resetear",
  "common.next": "Siguiente",
  "common.previous": "Anterior",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.add": "Agregar",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.clear": "Limpiar",
  "common.close": "Cerrar",
  "common.actions": "Acciones",
  "common.status": "Estado",
  "common.date": "Fecha",
  "common.loading": "Cargando",
  "common.noResults": "No se encontraron resultados",
  "common.error": "Error",
  "common.success": "\xC9xito",
  "common.warning": "Advertencia",
  "common.info": "Informaci\xF3n",
  "common.confirm": "Confirmar",
  "common.areYouSure": "\xBFEst\xE1 seguro?",
  "common.areYouSureDelete": "\xBFEst\xE1 seguro que deseas eliminar?",
  "common.areYouSureCancel": "\xBFEst\xE1 seguro que deseas cancelar?",
  "common.areYouSureSave": "\xBFEst\xE1 seguro que deseas guardar?",
  "common.digitalDossiers": "Legajos digitales",
  "common.cropPledges": "Prendas de cultivo",
  "common.viewDetail": "Ver detalle",
  "common.digitalDossier": "Legajo digital",
  "common.companyName": "Raz\xF3n social",
  "common.socialReason": "Raz\xF3n social",
  "common.fiscalId": "Id Fiscal",
  "common.table.emptyState": "Ajust\xE1 las opciones de b\xFAsqueda y los filtros para encontrar lo que est\xE1s buscando",
  "common.CUIT": "CUIT",
  "common.CUIL": "CUIL",
  "common.DNI": "DNI",
  "common.CUIT/CUIL": "CUIT/CUIL",
  "common.password": "Contrase\xF1a",
  "common.email": "Email",
  "common.confirmationCode": "C\xF3digo de confirmaci\xF3n",
  "common.signUpRequests": "Solicitudes de registro",
  "common.lastLogin": "\xDAltimo ingreso",
  "common.logout": "Cerrar sesi\xF3n",
  "common.approve": "Aprobar",
  "common.reject": "Rechazar",
  "common.revokeAccess": "Revocar acceso",
  "common.renewAccessRequest": "Renovar consulta",
  "common.renew": "Renovar",
  "common.succesfullyRenewed": "Renovaci\xF3n exitosa",
  "common.rejectRequest": "Rechazar solicitud",
  "common.requestReview": "Solicitar revisi\xF3n",
  "common.submitReviewRequest": "Enviar solicitud de revisi\xF3n",
  "common.street": "Calle",
  "common.number": "N\xFAmero",
  "common.province": "Provincia",
  "common.locality": "Localidad",
  "common.name": "Nombre",
  "common.lastName": "Apellido",
  "common.phone": "Tel\xE9fono",
  "common.document": "Documento",
  "common.documentType": "Tipo de documento",
  "common.documentIdentifier": "Identificador del documento",
  "common.dueDate": "Fecha de vencimiento",
  "common.postalCode": "C\xF3digo postal",
  "common.exchange": "Bolsa con la que opera",
  "common.socialType": "Tipo societario",
  "common.mobile": "Tel\xE9fono",
  "common.position": "Cargo",
  "common.web": "Web",
  "common.reasonForRejection": "Motivo del rechazo",
  "common.saveAndApprove": "Guardar y aprobar",
  "common.saveChanges": "Guardar cambios",
  "common.approveChanges": "Aprobar informaci\xF3n",
  "common.contactInformation": "Datos de contacto",
  "common.affidavit": "Declaraci\xF3n jurada",
  "common.affidavits": "Declaraciones juradas",
  "common.establishments": "Establecimientos",
  "common.equityInformation": "Informaci\xF3n patrimonial",
  "common.companyGeneralInformation": "Datos generales de empresa",
  "common.bankData": "Datos bancarios",
  "common.taxData": "Datos impositivos",
  "common.legalRepresentatives": "Representantes legales",
  "common.documentationAndForms": "Documentaci\xF3n y formularios",
  "common.companyType": "Tipo societario",
  "common.mainActivity": "Actividad principal",
  "common.startDateOfActivity": "Fecha de inicio de actividad",
  "common.endDateOfActivity": "Fecha de fin de actividad",
  "common.startDateOfTerm": "Fecha de inicio de mandato",
  "common.endDateOfTerm": "Fecha de fin de mandato",
  "common.RUCA": "RUCA",
  "common.IGJ": "IGJ/Reg P\xFAblico de Comercio",
  "common.sisaActivity": "SISA Actividad",
  "common.sisaActivity.placeholder": "Seleccionar actividad",
  "common.sisaScoring": "SISA Scoring",
  "common.signatureSchema": "Esquema de firmas",
  "common.signatureLevel": "Nivel de firmas",
  "common.powerByBolsa": "Poder por Bolsa",
  "common.amount": "Monto",
  "common.currency": "Moneda",
  "common.product": "Producto",
  "common.tons": "Toneladas",
  "common.activity": "Actividad",
  "common.toBeCompletedByBolsa": "A completar por la Bolsa",
  "common.toBeUploadedByBolsa": "A cargar por la Bolsa",
  "common.toBeCompletedByCreditor": "A completar por acreedor",
  "common.requestApproval": "Solicitar aprobaci\xF3n",
  "common.updateData": "Actualizar datos",
  "common.lastUpdate": "\xDAltima actualizaci\xF3n: {{lastUpdate}}",
  "common.selectActivity": "Seleccionar actividad",
  "common.error.loadingGeneralInformation": "Error al cargar informaci\xF3n general de la empresa",
  "common.error.loadingData": "Error al cargar informaci\xF3n",
  "common.fileUpload.disabled": "Presione actualizar datos para cargar un nuevo archivo",
  "common.requestApproval.toast.success": "Solicitud enviada con \xE9xito",
  "common.approve.toast.success": "La informaci\xF3n fue aprobada con \xE9xito",
  "common.update.toast.success": "La informaci\xF3n fue actualizada con \xE9xito",
  "common.expirationDate.label": "Fecha de vencimiento",
  "common.expirationDate.error.dateFromPast": "Este campo es obligatorio y la fecha de vencimiento no puede ser excedida",
  "common.expirationDate.placeholder": "Seleccionar fecha",
  "common.documentId.label": "Identificador del documento",
  "common.documentId.placeholder": "Ingresar identificador",
  "common.typeNumber.placeholder": "Ingresar n\xFAmero",
  "common.producers": "Productores",
  "common.stockpiles": "Acopios",
  "common.error.greaterOrEqualThanZero": "El valor debe ser igual o mayor a 0",
  "common.error.greaterOrEqualThanOne": "El valor debe ser igual o mayor a 1",
  "common.error.valueMustBeANumber": "El valor debe ser num\xE9rico",
  "common.commentsOrObservations": "Comentarios u observaciones",
  "common.seeDetails": "Ver detalle",
  "common.nationality": "Nacionalidad",
  "common.birthDate": "Fecha de nacimiento",
  "common.maritalStatus": "Estado civil",
  "common.user.name": "Nombre",
  "common.user.lastName": "Apellido",
  "common.user.documentType": "Tipo de documento",
  "common.user.document": "Documento",
  "common.user.position": "Cargo",
  "common.user.email": "Email",
  "common.user.mobile": "Tel\xE9fono",
  "common.user.CUIT/CUIL": "CUIT/CUIL",
  "common.company.name": "Raz\xF3n social",
  "common.company.fiscalId": "CUIT",
  "common.company.streetName": "Calle",
  "common.company.streetNumber": "N\xFAmero",
  "common.company.postalCode": "C\xF3digo postal",
  "common.company.exchange": "Bolsa con la que opera",
  "common.company.companyType": "Tipo societario",
  "common.birthDate.label": "Fecha de nacimiento",
  "common.birthDate.placeholder": "Ingresar fecha",
  "common.maritalStatus.label": "Estado civil",
  "common.maritalStatus.placeholder": "Seleccionar estado civil",
  "common.nationality.label": "Nacionalidad",
  "common.nationality.placeholder": "Seleccionar nacionalidad",
  "common.toast.error.title": "Ocurri\xF3 un error",
  "common.toast.error.text": "Intente nuevamente m\xE1s tarde.",
  "common.toast.error.reCaptcha": "Error al obtener el token de ReCaptcha. Intente nuevamente m\xE1s tarde.",
  "common.toast.error.reCaptchaNotAvailable": "Validaci\xF3n de ReCaptcha no disponible de momento. Intente nuevamente m\xE1s tarde.",
  "common.toast.error.CROP_PLEDGE_INVALID_CREDITOR_SELECTION.text": "El CUIT ingresado no puede ser asignado como acreedor.",
  "common.toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.text": "El CUIT ingresado no tiene su legajo digital cargado y aprobado",
  "common.toast.error.CROP_PLEDGE_NO_EMAIL.text": "El CUIT ingresado no tiene un mail asociado",
  "common.toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.text": "El CUIT ingresado no tiene un tel\xE9fono asociado",
  "common.noOptionsMessage": "Tu b\xFAsqueda no trajo resultados. Intenta nuevamente.",
  // COMMON TABLES
  "common.table.search.placeholder": "Buscar por raz\xF3n social, CUIT",
  "common.table.statusFilter.allText": "Todos",
  // COMMON ROUTES
  "common.navigation.route.cropPledge": "Prenda de cultivo",
  // COMMON UPLOAD S3 FILE
  "common.uploadFile.clickHereMessage": "Haz clic aqu\xED",
  "common.uploadFile.orDropTheFileMessage": "o suelta el archivo",
  "common.uploadFile.tryAgainMessage": "Subir de nuevo",
  "common.uploadFile.fileInvalidTypeMessage": "El archivo no es v\xE1lido",
  "common.uploadFile.fileTooLargeMessage": "El archivo es demasiado grande",
  "common.uploadFile.fileTooSmallMessage": "El archivo es demasiado peque\xF1o",
  "common.uploadFile.tooManyFilesMessage": "Demasiados archivos",
  "common.uploadFile.uploadError": "Ha ocurrido un error al cargar el archivo, por favor intente nuevamente.",
  // COMMON MARITAL STATUS
  "common.maritalStatus.SINGLE": "Soltero",
  "common.maritalStatus.MARRIED": "Casado",
  "common.maritalStatus.DIVORCED": "Divorciado",
  "common.maritalStatus.WIDOWED": "Viudo",
  // COMMON CROP PLEDGES
  "cropPledge.section.debtorInfo.title.label": "Datos solicitante",
  "cropPledge.section.debtorInfo.subtitle.label": "Representante legal titular",
  "cropPledge.section.fieldInfo.label": "Datos del campo",
  "cropPledge.section.creditorInfo.label": "Datos acreedor",
  "cropPledge.section.document.label": "Documentaci\xF3n",
  "cropPledge.section.cropPledgeInfo.label": "Datos de la prenda",
  "cropPledge.section.insuranceInfo.label": "Seguros",
  // PLEDGE SECTION STATUS
  "cropPledge.section.status.PENDING_DEBTOR_LOAD": "Pendiente de carga solicitante",
  "cropPledge.section.status.PENDING_BOLSA_LOAD": "Pendiente de carga Bolsa",
  "cropPledge.section.status.PENDING_CREDITOR_LOAD": "Pendiente de carga acreedor",
  "cropPledge.section.status.PENDING_BOLSA_APPROVAL": "Pendiente de aprobaci\xF3n Bolsa",
  "cropPledge.section.status.PENDING_CREDITOR_APPROVAL": "Pendiente de aprobaci\xF3n acreedor",
  "cropPledge.section.status.APPROVED": "Aprobada",
  // PLEDGE STATUS
  "cropPledge.status.PENDING_DEBTOR_LOAD": "Pendiente de carga solicitante",
  "cropPledge.status.PENDING_BOLSA_LOAD": "Pendiente de carga Bolsa",
  "cropPledge.status.PENDING_CREDITOR_LOAD": "Pendiente de carga acreedor",
  "cropPledge.status.PENDING_BOLSA_FARM_LOAD": "Pendiente de carga Bolsa",
  "cropPledge.status.PENDING_DEBTOR_DOCUMENTATION_LOAD": "Pendiente de documentaci\xF3n de solicitante",
  "cropPledge.status.PENDING_BOLSA_APPROVAL": "Pendiente de aprobaci\xF3n Bolsa",
  "cropPledge.status.PENDING_CREDITOR_APPROVAL": "Pendiente de aprobaci\xF3n acreedor",
  "cropPledge.status.PENDING_REGISTRATION": "Pendiente de registro",
  "cropPledge.status.PENDING_REGISTRATION_BLOCKCHAIN": "En proceso de registro",
  "cropPledge.status.REJECTED": "Rechazada",
  "cropPledge.status.REGISTERED": "Registrada",
  "cropPledge.status.PENDING_RELEASE": "Pendiente de liberaci\xF3n",
  "cropPledge.status.RELEASED": "Liberado",
  // PLEDGE STATUS SECTIONS
  "cropPledge.statusSection.PENDING_DEBTOR_LOAD": "Pendiente de carga solicitante",
  "cropPledge.statusSection.PENDING_BOLSA_LOAD": "Pendiente de carga Bolsa",
  "cropPledge.statusSection.PENDING_CREDITOR_LOAD": "Pendiente de carga acreedor",
  "cropPledge.statusSection.PENDING_BOLSA_APPROVAL": "Pendiente de aprobaci\xF3n Bolsa",
  "cropPledge.statusSection.PENDING_CREDITOR_APPROVAL": "Pendiente de aprobaci\xF3n acreedor",
  "cropPledge.statusSection.APPROVED": "Aprobado",
  // PLEDGE STATUS TOOLTIPS BY ROLE
  "cropPledge.section.disabled.tooltip": "Esta secci\xF3n se habilitar\xE1 una vez que la Bolsa y el solicitante hayan ingresado toda la informaci\xF3n requerida.",
  // DEBTOR
  "cropPledge.status.DEBTOR.PENDING_DEBTOR_LOAD.tooltip": "Ten\xE9s datos pendientes a cargar.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por la Bolsa.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_FARM_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por la Bolsa.",
  "cropPledge.status.DEBTOR.PENDING_CREDITOR_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por el acreedor.",
  "cropPledge.status.DEBTOR.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "Ten\xE9s datos de documentaci\xF3n pendientes a cargar.",
  "cropPledge.status.DEBTOR.PENDING_BOLSA_APPROVAL.tooltip": "Los datos est\xE1n pendientes de aprobaci\xF3n de la Bolsa.",
  "cropPledge.status.DEBTOR.PENDING_CREDITOR_APPROVAL.tooltip": "Los datos est\xE1n pendientes de aprobaci\xF3n del acreedor.",
  "cropPledge.status.DEBTOR.PENDING_REGISTRATION.tooltip": "La prenda ya fue aprobada y est\xE1 pendiente de ser registrada en el registro prendario.",
  "cropPledge.status.DEBTOR.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "La prenda est\xE1 en proceso de registro, pronto la ver\xE1s como registrada.",
  "cropPledge.status.DEBTOR.REJECTED.tooltip": "La prenda fue rechazada por el acreedor.",
  "cropPledge.status.DEBTOR.REGISTERED.tooltip": "La prenda est\xE1 registrada en el registro prendario.",
  "cropPledge.status.DEBTOR.PENDING_RELEASE.tooltip": "El acreedor marc\xF3 la prenda como cobrada y est\xE1 pendiente de ser liberada en el registro prendario.",
  "cropPledge.status.DEBTOR.RELEASED.tooltip": "La prenda fue liberada en el registro prendario.",
  // BACKOFFICE
  "cropPledge.status.BACKOFFICE.PENDING_DEBTOR_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por el solicitante.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_LOAD.tooltip": "Ten\xE9s datos pendientes a cargar.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_FARM_LOAD.tooltip": "Ten\xE9s datos pendientes a cargar.",
  "cropPledge.status.BACKOFFICE.PENDING_CREDITOR_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por el acreedor.",
  "cropPledge.status.BACKOFFICE.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "Los datos de documentaci\xF3n est\xE1n pendientes de ser cargados por el solicitante.",
  "cropPledge.status.BACKOFFICE.PENDING_BOLSA_APPROVAL.tooltip": "Ten\xE9s datos pendientes de aprobar",
  "cropPledge.status.BACKOFFICE.PENDING_CREDITOR_APPROVAL.tooltip": "Los datos est\xE1n pendientes de aprobaci\xF3n del acreedor.",
  "cropPledge.status.BACKOFFICE.PENDING_REGISTRATION.tooltip": "La prenda est\xE1 pendiente de que la registres en el registro prendario.",
  "cropPledge.status.BACKOFFICE.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "La prenda est\xE1 en proceso de registro, pronto la ver\xE1s como registrada.",
  "cropPledge.status.BACKOFFICE.REJECTED.tooltip": "La prenda fue rechazada por el acreedor.",
  "cropPledge.status.BACKOFFICE.REGISTERED.tooltip": "La prenda est\xE1 registrada en el registro prendario.",
  "cropPledge.status.BACKOFFICE.PENDING_RELEASE.tooltip": "El acreedor marc\xF3 la prenda como cobrada y est\xE1 pendiente de que la liberes en el registro prendario.",
  "cropPledge.status.BACKOFFICE.RELEASED.tooltip": "La prenda fue liberada en el registro prendario.",
  // CREDITOR
  "cropPledge.status.CREDITOR.PENDING_DEBTOR_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por el solicitante.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por la Bolsa.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_FARM_LOAD.tooltip": "Los datos est\xE1n pendientes de ser cargados por la Bolsa.",
  "cropPledge.status.CREDITOR.PENDING_CREDITOR_LOAD.tooltip": "Ten\xE9s datos pendientes a cargar.",
  "cropPledge.status.CREDITOR.PENDING_DEBTOR_DOCUMENTATION_LOAD.tooltip": "Los datos de documentaci\xF3n est\xE1n pendientes de ser cargados por el solicitante.",
  "cropPledge.status.CREDITOR.PENDING_BOLSA_APPROVAL.tooltip": "Los datos est\xE1n pendientes de aprobaci\xF3n de la Bolsa.",
  "cropPledge.status.CREDITOR.PENDING_CREDITOR_APPROVAL.tooltip": "Ten\xE9s datos pendientes de aprobar",
  "cropPledge.status.CREDITOR.PENDING_REGISTRATION.tooltip": "La prenda ya fue aprobada y est\xE1 pendiente de ser registrada en el registro prendario.",
  "cropPledge.status.CREDITOR.PENDING_REGISTRATION_BLOCKCHAIN.tooltip": "La prenda est\xE1 en proceso de registro, pronto la ver\xE1s como registrada.",
  "cropPledge.status.CREDITOR.REJECTED.tooltip": "Rechazaste esta prenda",
  "cropPledge.status.CREDITOR.REGISTERED.tooltip": "La prenda est\xE1 registrada en el registro prendario.",
  "cropPledge.status.CREDITOR.PENDING_RELEASE.tooltip": "Marcaste la prenda como cobrada y est\xE1 pendiente de ser liberada en el registro prendario.",
  "cropPledge.status.CREDITOR.RELEASED.tooltip": "La prenda fue liberada en el registro prendario.",
  "cropPledgeDetail.page.title": "Crear prenda",
  "cropPledgeDetail.asideNav.fieldData": "Datos del campo",
  "cropPledgeDetail.asideNav.debtorData": "Datos solicitante",
  "cropPledgeDetail.asideNav.creditorData": "Datos acreedor",
  "cropPledgeDetail.asideNav.documentation": "Documentaci\xF3n",
  "cropPledgeDetail.asideNav.cropPledgeData": "Datos de la prenda",
  "cropPledgeDetail.asideNav.insuranceData": "Seguros",
  // NATIONALITY TYPES
  "nationality.ARGENTINE": "Argentino",
  "nationality.AFGHAN": "Afgano",
  "nationality.ALBANIAN": "Alban\xE9s",
  "nationality.ALGERIAN": "Argelino",
  "nationality.AMERICAN": "Estadounidense",
  "nationality.ANDORRAN": "Andorrano",
  "nationality.ANGOLAN": "Angole\xF1o",
  "nationality.ARMENIAN": "Armenio",
  "nationality.AUSTRALIAN": "Australiano",
  "nationality.AUSTRIAN": "Austriaco",
  "nationality.AZERBAIJANI": "Azerbaiyano",
  "nationality.BAHAMIAN": "Bahamense",
  "nationality.BAHRAINI": "Barein\xED",
  "nationality.BANGLADESHI": "Banglades\xED",
  "nationality.BARBADIAN": "Barbadense",
  "nationality.BELARUSIAN": "Bielorruso",
  "nationality.BELGIAN": "Belga",
  "nationality.BELIZEAN": "Belice\xF1o",
  "nationality.BENINESE": "Benin\xE9s",
  "nationality.BHUTANESE": "Butan\xE9s",
  "nationality.BOLIVIAN": "Boliviano",
  "nationality.BOSNIAN": "Bosnio",
  "nationality.BRAZILIAN": "Brasile\xF1o",
  "nationality.BRITISH": "Brit\xE1nico",
  "nationality.BRUNEIAN": "Bruneano",
  "nationality.BULGARIAN": "B\xFAlgaro",
  "nationality.BURKINABE": "Burkin\xE9s",
  "nationality.BURMESE": "Birmano",
  "nationality.BURUNDIAN": "Burund\xE9s",
  "nationality.CAMBODIAN": "Camboyano",
  "nationality.CAMEROONIAN": "Camerun\xE9s",
  "nationality.CANADIAN": "Canadiense",
  "nationality.CAPE_VERDEAN": "Cabo Verdeano",
  "nationality.CENTRAL_AFRICAN": "Centroafricano",
  "nationality.CHADIAN": "Chadiano",
  "nationality.CHILEAN": "Chileno",
  "nationality.CHINESE": "Chino",
  "nationality.COLOMBIAN": "Colombiano",
  "nationality.COMORIAN": "Comorano",
  "nationality.CONGOLESE": "Congole\xF1o",
  "nationality.COSTA_RICAN": "Costarricense",
  "nationality.CROATIAN": "Croata",
  "nationality.CUBAN": "Cubano",
  "nationality.CYPRIOT": "Chipriota",
  "nationality.CZECH": "Checo",
  "nationality.DANISH": "Dan\xE9s",
  "nationality.DJIBOUTIAN": "Yibutiano",
  "nationality.DOMINICAN": "Dominicano",
  "nationality.DUTCH": "Neerland\xE9s",
  "nationality.EAST_TIMORESE": "Timorense",
  "nationality.ECUADOREAN": "Ecuatoriano",
  "nationality.EGYPTIAN": "Egipcio",
  "nationality.EMIRATI": "Emirat\xED",
  "nationality.EQUATORIAL_GUINEAN": "Ecuatoguineano",
  "nationality.ERITREAN": "Eritreo",
  "nationality.ESTONIAN": "Estonio",
  "nationality.ETHIOPIAN": "Et\xEDope",
  "nationality.FIJIAN": "Fiyiano",
  "nationality.FILIPINO": "Filipino",
  "nationality.FINNISH": "Finland\xE9s",
  "nationality.FRENCH": "Franc\xE9s",
  "nationality.GABONESE": "Gabon\xE9s",
  "nationality.GAMBIAN": "Gambiano",
  "nationality.GEORGIAN": "Georgiano",
  "nationality.GERMAN": "Alem\xE1n",
  "nationality.GHANAIAN": "Ghan\xE9s",
  "nationality.GREEK": "Griego",
  "nationality.GRENADIAN": "Granadino",
  "nationality.GUATEMALAN": "Guatemalteco",
  "nationality.GUINEAN": "Guineano",
  "nationality.GUINEA_BISSAUAN": "Guineabissauano",
  "nationality.GUYANESE": "Guyan\xE9s",
  "nationality.HAITIAN": "Haitiano",
  "nationality.HONDURAN": "Hondure\xF1o",
  "nationality.HUNGARIAN": "H\xFAngaro",
  "nationality.ICELANDER": "Island\xE9s",
  "nationality.INDIAN": "Indio",
  "nationality.INDONESIAN": "Indonesio",
  "nationality.IRANIAN": "Iran\xED",
  "nationality.IRAQI": "Iraqu\xED",
  "nationality.IRISH": "Irland\xE9s",
  "nationality.ISRAELI": "Israel\xED",
  "nationality.ITALIAN": "Italiano",
  "nationality.IVORIAN": "Marfile\xF1o",
  "nationality.JAMAICAN": "Jamaicano",
  "nationality.JAPANESE": "Japon\xE9s",
  "nationality.JORDANIAN": "Jordano",
  "nationality.KAZAKH": "Kazajo",
  "nationality.KENYAN": "Keniata",
  "nationality.KIRIBATI": "Kiribatiano",
  "nationality.KOREAN": "Coreano",
  "nationality.KUWAITI": "Kuwait\xED",
  "nationality.KYRGYZ": "Kirgu\xEDs",
  "nationality.LAOTIAN": "Laosiano",
  "nationality.LATVIAN": "Let\xF3n",
  "nationality.LEBANESE": "Liban\xE9s",
  "nationality.LESOTHO": "Lesotense",
  "nationality.LIBERIAN": "Liberiano",
  "nationality.LIBYAN": "Libio",
  "nationality.LIECHTENSTEINER": "Liechtensteiniano",
  "nationality.LITHUANIAN": "Lituano",
  "nationality.LUXEMBOURGISH": "Luxemburgu\xE9s",
  "nationality.MACANESE": "Macaense",
  "nationality.MACEDONIAN": "Macedonio",
  "nationality.MALAGASY": "Malgache",
  "nationality.MALAWIAN": "Malau\xED",
  "nationality.MALAYSIAN": "Malasio",
  "nationality.MALDIVIAN": "Maldivo",
  "nationality.MALIEN": "Maliense",
  "nationality.MALTESE": "Malt\xE9s",
  "nationality.MARSHALLESE": "Marshal\xE9s",
  "nationality.MAURITANIAN": "Mauritano",
  "nationality.MAURITIAN": "Mauriciano",
  "nationality.MEXICAN": "Mexicano",
  "nationality.MICRONESIAN": "Micronesio",
  "nationality.MOLDOVAN": "Moldavo",
  "nationality.MONACAN": "Monegasco",
  "nationality.MONGOLIAN": "Mongol",
  "nationality.MONTENEGRIN": "Montenegrino",
  "nationality.MOROCCAN": "Marroqu\xED",
  "nationality.MOZAMBICAN": "Mozambique\xF1o",
  "nationality.NAMIBIAN": "Namibio",
  "nationality.NAURUAN": "Nauruano",
  "nationality.NEPALESE": "Nepal\xED",
  "nationality.NEW_ZEALANDER": "Neozeland\xE9s",
  "nationality.NICARAGUAN": "Nicarag\xFCense",
  "nationality.NIGERIAN": "Nigeriano",
  "nationality.NIGERIEN": "Nigerino",
  "nationality.NORTH_KOREAN": "Norcoreano",
  "nationality.NORTHERN_IRISH": "Norirland\xE9s",
  "nationality.NORWEGIAN": "Noruego",
  "nationality.OMANI": "Oman\xED",
  "nationality.PAKISTANI": "Pakistan\xED",
  "nationality.PALAUAN": "Palauano",
  "nationality.PALESTINIAN": "Palestino",
  "nationality.PANAMANIAN": "Paname\xF1o",
  "nationality.PAPUA_NEW_GUINEAN": "Pap\xFA",
  "nationality.PARAGUAYAN": "Paraguayo",
  "nationality.PERUVIAN": "Peruano",
  "nationality.POLISH": "Polaco",
  "nationality.PORTUGUESE": "Portugu\xE9s",
  "nationality.QATARI": "Catar\xED",
  "nationality.ROMANIAN": "Rumano",
  "nationality.RUSSIAN": "Ruso",
  "nationality.RWANDAN": "Ruand\xE9s",
  "nationality.SAINT_KITTS_AND_NEVIS": "Sancristobale\xF1o",
  "nationality.SAINT_LUCIAN": "Santalucense",
  "nationality.SAINT_VINCENT_AND_THE_GRENADINES": "Sanvicentino",
  "nationality.SAINT_VINCENTIAN": "Sanvicentino",
  "nationality.SALVADORAN": "Salvadore\xF1o",
  "nationality.SAMOAN": "Samoano",
  "nationality.SAN_MARINESE": "Sanmarinense",
  "nationality.SAO_TOMEAN": "Saotomeense",
  "nationality.SAUDI_ARABIAN": "Saud\xED",
  "nationality.SAUDI": "Saud\xED",
  "nationality.SCOTTISH": "Escoc\xE9s",
  "nationality.SENEGALESE": "Senegal\xE9s",
  "nationality.SERBIAN": "Serbio",
  "nationality.SEYCHELLOIS": "Seychelense",
  "nationality.SIERRA_LEONEAN": "Sierraleon\xE9s",
  "nationality.SINGAPOREAN": "Singapurense",
  "nationality.SLOVAK": "Eslovaco",
  "nationality.SLOVENIAN": "Esloveno",
  "nationality.SOLOMON_ISLANDER": "Salomonense",
  "nationality.SOMALI": "Somal\xED",
  "nationality.SOUTH_AFRICAN": "Sudafricano",
  "nationality.SOUTH_KOREAN": "Surcoreano",
  "nationality.SOUTH_SUDANESE": "Sudan\xE9s del sur",
  "nationality.SPANISH": "Espa\xF1ol",
  "nationality.SRI_LANKAN": "Ceilan\xE9s",
  "nationality.SUDANESE": "Sudan\xE9s",
  "nationality.SURINAMER": "Suriname",
  "nationality.SURINAMESE": "Surinam\xE9s",
  "nationality.SWAZI": "Suazi",
  "nationality.SWEDISH": "Sueco",
  "nationality.SWISS": "Suizo",
  "nationality.SYRIAN": "Sirio",
  "nationality.TAIWANESE": "Taiwan\xE9s",
  "nationality.TAJIK": "Tayiko",
  "nationality.TANZANIAN": "Tanzano",
  "nationality.THAI": "Tailand\xE9s",
  "nationality.TOGOLESE": "Togol\xE9s",
  "nationality.TONGAN": "Tongano",
  "nationality.TRINIDADIAN": "Trinitense",
  "nationality.TUNISIAN": "Tunisiano",
  "nationality.TURKISH": "Turco",
  "nationality.TURKMEN": "Turcomano",
  "nationality.TUVALUAN": "Tuvaluano",
  "nationality.UGANDAN": "Ugand\xE9s",
  "nationality.UKRAINIAN": "Ucraniano",
  "nationality.URUGUAYAN": "Uruguayo",
  "nationality.UZBEK": "Uzbeko",
  "nationality.VANUATUAN": "Vanuatuense",
  "nationality.VATICAN": "Vaticana",
  "nationality.VENEZUELAN": "Venezolano",
  "nationality.VIETNAMESE": "Vietnamita",
  "nationality.WELSH": "Galesa",
  "nationality.YEMENI": "Yemen\xED",
  "nationality.ZAMBIAN": "Zambiano",
  "nationality.ZIMBABWEAN": "Zimbabuense",
  "cropPledge.linkToDigitalDossier": "Ir a legajo digital",
  // CROP PLEDGE ALERT
  "cropPledge.alert.title": "La edici\xF3n de datos no est\xE1 disponible en esta secci\xF3n.",
  "cropPledge.alert.detail": `Para realizar cambios, dirigete a la secci\xF3n 'Legajo Digital', realiz\xE1 la modificaci\xF3n correspondiente y solicita su aprobaci\xF3n. Si realizas cambios, deber\xE1s crear una nueva prenda para aplicar las actualizaciones, ya que la prenda iniciada conservar\xE1 los datos antiguos.`,
  // business sing-up
  "businessSignUp.firstStep.title": "Solicitar registro de empresa",
  "businessSignUp.firstStep.stepIndicator": "Datos empresa",
  "businessSignUp.firstStep.error.companyAlreadyExist": "El CUIT ingresado ya fue registrado. Por favor ponete en contacto con Bolsa de Cereales por m\xE1s informaci\xF3n.",
  "businessSignUp.firstStep.error.companyNameAlreadyExist": "La raz\xF3n social ingresada ya fue registrada. Por favor ponete en contacto con Bolsa de Cereales por m\xE1s informaci\xF3n.",
  "businessSignUp.secondStep.stepIndicator": "Datos administrador",
  "businessSignUp.secondStep.subtitle": "Completar con los datos de la persona a la cual se le dar\xE1 el rol de Usuario administrador. Este usuario tendr\xE1 acceso completo a los servicios de la plataforma de BC Explorer, en representaci\xF3n de su empresa.",
  "businessSignUp.secondStep.error.adminUserEmailAlreadyExists": "El email ingresado ya fue registrado. Por favor ponete en contacto con Bolsa de Cereales por m\xE1s informaci\xF3n.",
  "businessSignUp.secondStep.error.adminUserFiscalIdAlreadyExists": "El CUIT ingresado ya fue registrado. Por favor ponete en contacto con Bolsa de Cereales por m\xE1s informaci\xF3n.",
  "businessSignUp.thirdStep.stepIndicator": "Datos del representante legal",
  "businessSignUp.thirdStep.subtitle": "En esta secci\xF3n deber\xE1 completar los datos del Representante legal o los que sean necesarios, en caso de firma conjunta, que tengan poder suficiente para solicitar el registro de la empresa en BC Explorer. Una vez finalizado el proceso, ser\xE1n quienes firmen el formulario que se presentar\xE1 ante la Bolsa de Cereales.",
  "businessSignUp.form.title": "Datos empresa",
  "businessSignUp.form.cuit.label": "CUIT empresa",
  "businessSignUp.form.cuit.placeholder": "Ingresar CUIT",
  "businessSignUp.form.businessName.label": "Raz\xF3n social",
  "businessSignUp.form.businessName.placeholder": "Raz\xF3n social CUIT",
  "businessSignUp.form.addressStreet.label": "Calle",
  "businessSignUp.form.addressStreet.placeholder": "Ingresar calle",
  "businessSignUp.form.addressNumber.label": "N\xFAmero",
  "businessSignUp.form.addressNumber.placeholder": "Ingresar n\xFAmero",
  "businessSignUp.form.state.label": "Provincia",
  "businessSignUp.form.state.placeholder": "Seleccionar provincia",
  "businessSignUp.form.locality.label": "Localidad",
  "businessSignUp.form.locality.placeholder": "Buscar localidad",
  "businessSignUp.form.locality.noOptions": "Tu b\xFAsqueda no trajo resultados. Intenta nuevamente.",
  "businessSignUp.form.zipCode.label": "C\xF3digo postal",
  "businessSignUp.form.zipCode.placeholder": "Ingresar c\xF3digo postal",
  "businessSignUp.form.exchanges.label": "Bolsa con la que opera",
  "businessSignUp.form.exchanges.placeholder": "Seleccionar Bolsa",
  "businessSignUp.form.businessType.label": "Tipo societario",
  "businessSignUp.form.businessType.placeholder": "Seleccionar tipo societario",
  "businessSignUp.form.userFirstName.label": "Nombre",
  "businessSignUp.form.userFirstName.placeholder": "Ingresar nombre",
  "businessSignUp.form.userLastName.label": "Apellido",
  "businessSignUp.form.userLastName.placeholder": "Ingresar apellido",
  "businessSignUp.form.userFiscalId.label": "CUIT/CUIL",
  "businessSignUp.form.userFiscalId.placeholder": "Ingresar CUIT/CUIL",
  "businessSignUp.form.userPhone.label": "Tel\xE9fono",
  "businessSignUp.form.userPhone.placeholder": "Ingresar tel\xE9fono",
  "businessSignUp.form.userEmail.label": "Email",
  "businessSignUp.form.userEmailConfirm.label": "Confirmar email",
  "businessSignUp.form.userEmail.placeholder": "Ingresar email",
  "businessSignUp.form.legalRepresentativeFirstName.addSecond": "Agregar representante",
  "businessSignUp.form.legalRepresentativeFirstName.label": "Nombre",
  "businessSignUp.form.legalRepresentativeFirstName.placeholder": "Ingresar nombre del representante legal",
  "businessSignUp.form.legalRepresentativeLastName.label": "Apellido",
  "businessSignUp.form.legalRepresentativeLastName.placeholder": "Ingresar apellido del representante legal",
  "businessSignUp.form.legalRepresentativeIdDocumentNumber.label": "DNI",
  "businessSignUp.form.legalRepresentativeIdDocumentNumber.placeholder": "Ingresar DNI del representante legal",
  "businessSignUp.form.legalRepresentativeEmail.label": "Email",
  "businessSignUp.form.legalRepresentativeEmail.placeholder": "Ingresar email del representante legal",
  "businessSignUp.form.legalRepresentativePosition.label": "Posici\xF3n",
  "businessSignUp.form.legalRepresentativePosition.placeholder": "Seleccionar posici\xF3n",
  "businessSignUp.form.idDocumentFile.label": "DNI",
  "businessSignUp.form.signupPermissionFile.label": "Acreditaci\xF3n de representaci\xF3n legal: cargar el acta, poder o documento de donde surja su representaci\xF3n.",
  "businessSignup.form.representativePosition.PRESIDENT": "Presidente",
  "businessSignup.form.representativePosition.PROXY": "Apoderado",
  "businessSignup.form.representativePosition.INCUMBENT": "Titular",
  "businessSignup.form.representativePosition.MANAGING_PARTNER": "Socio Gerente",
  "businessSignup.form.representativePosition.OTHER": "Otro",
  "businessSignup.form.companyType.PF": "Persona f\xEDsica",
  "businessSignup.form.companyType.SH": "Sociedades de Hecho",
  "businessSignup.form.companyType.SA": "Sociedad An\xF3nima",
  "businessSignup.form.companyType.SRL": "Sociedad Responsabilidad Limitada",
  "businessSignup.form.companyType.SAS": "Sociedad An\xF3nima Simplificada",
  "businessSignup.form.companyType.SAU": "Sociedad An\xF3nima Unipersonal",
  "businessSignup.form.companyType.COOP": "Cooperativas",
  "businessSignup.form.companyType.AS": "Asociaciones Civiles",
  "businessSignup.form.companyType.FUND": "Fundaciones",
  "businessSignup.form.companyType.FID": "Fideicomisos",
  "businessSignup.form.companyType.OTHER": "Otras",
  "businessSignup.form.idDocumentFile.clickHereMessage": "Haz clic aqu\xED",
  "businessSignup.form.idDocumentFile.orDropTheFileMessage": "o suelta el archivo",
  "businessSignup.form.idDocumentFile.tryAgainMessage": "Subir de nuevo",
  "businessSignup.form.idDocumentFile.fileInvalidTypeMessage": "El archivo no es v\xE1lido",
  "businessSignup.form.idDocumentFile.fileTooLargeMessage": "El archivo es demasiado grande",
  "businessSignup.form.idDocumentFile.fileTooSmallMessage": "El archivo es demasiado peque\xF1o",
  "businessSignup.form.idDocumentFile.tooManyFilesMessage": "Demasiados archivos",
  "businessSignUp.form.next": "Siguiente",
  // COMPANY_CONTACT_INFORMATION
  "companyContactInformation.form.error.validLocality": "Ingrese una localidad v\xE1lida para la provincia selecionada",
  "companyContactInformation.toast.success.title": "La informaci\xF3n fue actualizada exitosamente",
  // EXCHANGE
  "exchange.BCBA": "Bolsa de Cereales de Buenos Aires",
  // ERROR MESSAGE TOASTS
  "toast.error.UPDATES_NOT_TRIGGERED_CHANGES.title": "Error",
  "toast.error.UPDATES_NOT_TRIGGERED_CHANGES.text": "No hay cambios pendientes de guardado",
  "toast.error.RECORD_NOT_FOUND.title": "Informaci\xF3n no encontrada.",
  "toast.error.RECORD_NOT_FOUND.text": "",
  "toast.error.EMAIL_ALREADY_EXISTS.title": "Email ya existente",
  "toast.error.EMAIL_ALREADY_EXISTS.text": "",
  "toast.error.FISCAL_ID_IN_USE.title": "Cuit/Cuil ya existente",
  "toast.error.FISCAL_ID_IN_USE.text": "",
  "toast.error.EMPTY_FILE.title": "No se ha encontrado archivo para cargar",
  "toast.error.EMPTY_FILE.text": "",
  "toast.error.USER_ALREADY_EXISTS.title": "Usuario ya existente",
  "toast.error.USER_ALREADY_EXISTS.text": "",
  "toast.error.COMPANY_ALREADY_EXISTS.title": "Compania ya existente",
  "toast.error.COMPANY_ALREADY_EXISTS.text": "",
  "toast.error.SNAPSHOT_ALREADY_REJECTED.title": "Ya se ha rechazado.",
  "toast.error.SNAPSHOT_ALREADY_REJECTED.text": "No se pueden solicitar cambios",
  "toast.error.SNAPSHOT_MUST_BE_PENDING_APPROVAL.title": "El estado debe estar pendiente de aprobaci\xF3n para su aprobaci\xF3n.",
  "toast.error.SNAPSHOT_MUST_BE_PENDING_APPROVAL.text": "",
  "toast.error.SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED.title": "No se puede aprobar la secci\xF3n",
  "toast.error.SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED.text": "La misma ya ha sido rechazada o aprobada anteriormente.",
  "toast.error.SNAPSHOT_NON_ACTIVE.title": "Ocurri\xF3 un error",
  "toast.error.SNAPSHOT_NON_ACTIVE.text": "Intente nuevamente m\xE1s tarde",
  "toast.error.SNAPSHOT_WITH_MISSING_INFORMATION.title": "No se puede aprobar.",
  "toast.error.SNAPSHOT_WITH_MISSING_INFORMATION.text": "Falta informaci\xF3n.",
  "toast.error.COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER.title": "La empresa a\xFAn no cuenta con un expediente digital certificado.",
  "toast.error.COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER.text": "",
  "toast.error.COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES.title": "La empresa no tiene saldo disponible para realizar esta acci\xF3n",
  "toast.error.COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES.text": "",
  "toast.error.SIGNUP_REQUEST_ALREADY_REJECTED.title": "Solicitud de registro ya rechazada.",
  "toast.error.SIGNUP_REQUEST_ALREADY_REJECTED.text": "",
  "toast.error.SIGNUP_REQUEST_ALREADY_APPROVED.title": "No se puede rechazar una solicitud de registro ya aprobada.",
  "toast.error.SIGNUP_REQUEST_ALREADY_APPROVED.text": "",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS.title": "La solicitud de registro no est\xE1 en estado de aprobaci\xF3n pendiente",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS.text": "",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS.title": "La solicitud de registro no est\xE1 en estado de solicitud de cambio pendiente",
  "toast.error.SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS.text": "",
  "toast.error.SNAPSHOT_ALREADY_APPROVED.title": "Ya se ha aprobado. No se pueden solicitar cambios",
  "toast.error.SNAPSHOT_ALREADY_APPROVED.text": "",
  "toast.error.MALFORMED_REQUEST.title": "MALFORMED_REQUEST",
  // TODO preguntar aca
  "toast.error.MALFORMED_REQUEST.text": "MALFORMED_REQUEST",
  "toast.error.PROCESSING_ERROR.title": "PROCESSING_ERROR",
  // TODO preguntar aca
  "toast.error.PROCESSING_ERROR.text": "PROCESSING_ERROR",
  "toast.error.CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS.title": "CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS",
  "toast.error.CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS.text": "CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS",
  "toast.error.BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION.title": "Los ingresos brutos establecidos como Jurisdicci\xF3n Local deben tener una \xFAnica Jurisdicci\xF3n.",
  "toast.error.BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION.text": "",
  "toast.error.BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION.title": "Los ingresos brutos establecidos como Acuerdo Multilateral deben tener al menos una Jurisdicci\xF3n.",
  "toast.error.BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION.text": "",
  "toast.error.BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS.title": "Los ingresos brutos establecidos como exentos no deben tener ninguna jurisdicci\xF3n.",
  "toast.error.BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS.text": "",
  "toast.error.ERROR_SENDING_EMAIL.title": "Error al enviar la notificaci\xF3n por correo electr\xF3nico.",
  "toast.error.ERROR_SENDING_EMAIL.text": "",
  "toast.error.ERROR_UPLOADING_FILE.title": "Error al cargar el archivo",
  "toast.error.ERROR_UPLOADING_FILE.text": "Ha ocurrido un error al cargar el archivo, por favor intente nuevamente",
  "toast.error.ERROR_FETCHING_FILE.title": "Error al descargar el archivo",
  "toast.error.ERROR_FETCHING_FILE.text": "",
  "toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_DIGITAL_DOSSIER.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa a\xFAn no tiene un legajo digital completo.",
  "toast.error.CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa a\xFAn no tiene datos de contacto completos.",
  "toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_PHONE_NUMBER.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa no tiene un n\xFAmero de tel\xE9fono configurado en datos de contacto.",
  "toast.error.CROP_PLEDGE_NO_EMAIL.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_EMAIL.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa no tiene un email configurado en datos de contacto.",
  "toast.error.CROP_PLEDGE_NO_CP.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_CP.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa no tiene un c\xF3digo postal configurado en datos de contacto.",
  "toast.error.CROP_PLEDGE_NO_INCUMBENT.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_NO_INCUMBENT.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa no tiene un representante legal titular configurado.",
  "toast.error.CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER.title": "Error al crear una nueva prenda",
  "toast.error.CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER.text": "No se puede inicializar el proceso de prenda de cultivo porque la empresa no tiene Productor como actividad asociada.",
  "toast.error.CROP_PLEDGE_CANT_USE_OWN_COMPANY.title": "",
  "toast.error.CROP_PLEDGE_CANT_USE_OWN_COMPANY.text": "No puedes usar tu propia empresa como acreedor",
  "toast.error.CROP_PLEDGE_COMPANY_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_COMPANY_NOT_FOUND.text": "No se ha encontrado la empresa con este CUIT",
  "toast.error.CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND.text": "No se ha encontrado la informaci\xF3n del acreedor",
  "toast.error.CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND.title": "",
  "toast.error.CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND.text": "No se ha encontrado la informaci\xF3n del campo",
  "toast.error.CROP_PLEDGE_USER_IS_NOT_CREDITOR.title": "",
  "toast.error.CROP_PLEDGE_USER_IS_NOT_CREDITOR.text": "El usuario no es un acreedor",
  "toast.error.CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS.title": "",
  "toast.error.CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS.text": "La prenda no est\xE1 en estado de aprobaci\xF3n de acreedor",
  "toast.error.CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS.title": "",
  "toast.error.CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS.text": "Las secciones no est\xE1n en estado aprobado",
  "toast.error.CROP_PLEDGE_INVALID_STAGE.title": "",
  "toast.error.CROP_PLEDGE_INVALID_STAGE.text": "La prenda no se encuentra en una etapa v\xE1lida para realizar esta acci\xF3n",
  // ERROR MESSAGE
  "error.CUIT_MUST_BE_11_DIGITS.errorDescription": "Debe ser de un largo exacto de 11 caracteres",
  "error.VALIDATION_ERROR.errorDescription": "Ha ocurrido un error por favor intente nuevamente m\xE1s tarde.",
  "error.CUIT_INVALID.errorDescription": "El cuit ingresado es inv\xE1lido",
  "error.CUIT_NOT_FOUND_IN_AFIP.errorDescription": "AFIP no tiene registrado este CUIT",
  "error.ERR_NETWORK.errorDescription": "Error de conexi\xF3n de red. Intente nuevamente en unos minutos",
  // business sing-up summary
  "businessSignup.summary.title": "\xA1Solicitud de registro generada con \xE9xito!",
  "businessSignup.summary.subtitle": "El usuario administrador elegido recibir\xE1 una contrase\xF1a temporal para ingresar a la plataforma de Legajo Digital junto al formulario de registro, en PDF, para su impresi\xF3n y firma de los representantes legales indicados.",
  "businessSignup.summary.listTitle": "\xBFCu\xE1les son los pr\xF3ximos pasos?",
  "businessSignup.summary.firstListItem": "Descargar el PDF del formulario de registro e imprimirlo.",
  "businessSignup.summary.secondListItem": "Firmar el formulario de registro por los representantes legales indicados (certificar sus firmas ante Escribano y Legalizarlas - ver requisitos al pie del formulario)",
  "businessSignup.summary.thirdListItem": "Enviar el formulario de registro a la Bolsa de Cereales y esperar su aprobaci\xF3n (Oficina Control de Documentaci\xF3n: Av. Corrientes 123 - Piso 3. (C1043AAB))",
  "businessSignup.summary.sendEmailOtherPerson": "\xBFQuer\xE9s enviar el PDF a otro email?",
  "businessSignup.summary.downloadPDF": "Descargar PDF",
  "businessSignup.summary.signIn": "Iniciar sesi\xF3n",
  "businessSignup.summary.send": "Enviar",
  "businessSignup.summary.toast.title.success": "Se ha enviado el documento correctamente",
  "businessSignup.summary.toast.title.error": "Error al enviar el documento",
  // DIGITAL DOSSIERS
  "digitalDossiers.status.RUCA_EXPIRED": "RUCA no vigente",
  "digitalDossiers.status.INFORMATION_EXPIRED": "Informaci\xF3n vencida",
  "digitalDossiers.status.PENDING_DATA_UPLOAD_BACKOFFICE": "Pendiente de carga backoffice",
  "digitalDossiers.status.PENDING_DATA_UPLOAD_CLIENT": "Pendiente de carga cliente",
  "digitalDossiers.status.PENDING_APPROVAL": "Pendiente de aprobaci\xF3n",
  "digitalDossiers.status.APPROVED": "Aprobado",
  "digitalDossiers.table.filters.fiscalId": "Buscar por raz\xF3n social, CUIT",
  "digitalDossiers.searchThirdPartyDossier.awaitingApproval": "Tu solicitud de acceso a este dossier est\xE1 pendiente de aprobaci\xF3n",
  // VALIDATION STATUS
  "validationStatus.INCOMPLETE": "Pendiente de carga",
  "validationStatus.PENDING_APPROVAL": "Pendiente de aprobaci\xF3n",
  "validationStatus.PENDING_CHANGE_REQUEST": "Pendiente de revisi\xF3n",
  "validationStatus.PENDING_DATA_UPLOAD": "Pendiente de carga",
  "validationStatus.REJECTED": "Rechazado",
  "validationStatus.APPROVED": "Aprobado",
  // Backoffice validation status
  "backofficevalidationStatus.PENDING_DATA_UPLOAD_CLIENT": "Pendiente de carga cliente",
  "backofficevalidationStatus.PENDING_DATA_UPLOAD_BACKOFFICE": "Pendiente de carga backoffice",
  "backofficevalidationStatus.PENDING_APPROVAL": "Pendiente de aprobaci\xF3n",
  "backofficevalidationStatus.APPROVED": "Aprobado",
  // IDENTITY DOCUMENT TYPES
  "identityDocumentType.DNI": "DNI",
  "identityDocumentType.ENROLAMIENTO": "Enrolamiento",
  "identityDocumentType.PASSPORT": "Pasaporte",
  // DOCUMENT TYPES
  "documentType.IGJ": "IGJ",
  "documentType.CBU": "CBU",
  "documentType.CUIT": "CUIT",
  "documentType.IIBB": "IIBB",
  "documentType.CM05": "CM05",
  "documentType.PROFITS": "Profits",
  "documentType.IVA": "IVA",
  "documentType.EXEMPTIONS": "Exenciones",
  "documentType.UNKNOWN": "Sin especificar",
  "documentType.SISA": "SISA",
  "documentType.PRODUCTION_CAPACITY": "Capacidad de producci\xF3n",
  "documentType.STORAGE_CAPACITY": "Capacidad de almacenamiento",
  "documentType.BALANCE_SHEET": "Hoja de balance",
  "documentType.OWNER_ID_CARD": "Identificaci\xF3n del propietario",
  "documentType.STATUTE": "Estatuto",
  "documentType.ASSEMBLY_BOARD_MINUTES": "Acta de la junta de asamblea",
  "documentType.POWERS_OF_ATTORNEY": "Poderes notariales",
  "documentType.SIGNUP_PERMISSION": "Permiso para firmar la solicitud",
  "documentType.REPRESENTATIVE_ID_CARD": "DNI",
  "documentType.STATUTE_CHANGE": "Modificaci\xF3n de estatuto",
  "documentType.GEOLOCATION": "Geolocalizaci\xF3n",
  "documentType.ADDITIONAL_EQUITY_DOCUMENT": "Documentos adicionales",
  "documentType.ADDITIONAL_FORMS_AND_DOCS_DOCUMENT": "Documentos adicionales",
  "documentType.COMPANY_QUERY_LOAD_CONTRACT": "Contrato de carga de consulta de empresa",
  "documentType.LOAN_CONTRACT": "Contrato de pr\xE9stamo",
  "documentType.ADDITIONAL_CROP_PLEDGE_DOCUMENT": "Documento adicional",
  "documentType.CARBON_ANALYSIS": "An\xE1lisis de carbono",
  "documentType.DOMAIN_REPORT": "Informe de dominio",
  "documentType.MODIFICATION_FORM": "Formulario 6 (modificaci\xF3n/endozo)",
  "documentType.REGISTERED_PLEDGE": "Prenda registrada",
  "documentType.DEREGISTRATION_OF_PLEDGE": "Baja prenda",
  "documentType.ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT": "Documento adicional",
  "documentType.PLEDGE_REGISTRATION_FORM_TEMPLATE": "Plantilla de formulario de inscripci\xF3n de prenda",
  // REPRESENTATIVE POSITIONS
  "representativePosition.PRESIDENT": "Presidente",
  "representativePosition.PROXY": "Apoderado",
  "representativePosition.INCUMBENT": "Titular",
  "representativePosition.MANAGING_PARTNER": "Socio Gerente",
  "representativePosition.OTHER": "Otro",
  // PRODUCTS
  "product.COTTON": "Algod\xF3n",
  "product.RICE": "Arroz",
  "product.BARLEY": "Cebada",
  "product.SUNFLOWER": "Girasol",
  "product.CORN": "Ma\xEDz",
  "product.PEANUTS": "Man\xED",
  "product.SOY": "Soja",
  "product.SORGHUM": "Sorgo",
  "product.WHEAT": "Trigo",
  "product.OTHER": "Otro",
  // SIGNATURE LEVELS
  "signatureLevel.ZERO": "0",
  "signatureLevel.ONE": "1",
  "signatureLevel.TWO": "2",
  "signatureLevel.THREE": "3",
  "signatureLevel.NINE": "9",
  // POWER OF ATTORNEY EXCHANGES
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_BUENOS_AIRES": "Bolsa de Cereales de Buenos Aires",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_BAHIA_BLANCA": "Bolsa de Cereales de Bahia Blanca ",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_ENTRE_RIOS": "Bolsa de Cereales de Entre R\xEDos",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_CORDOBA": "Bolsa de Cereales de C\xF3rdoba",
  "powerOfAttorneyExchange.GRAIN_EXCHANGE_CHACO": "Bolsa de Cereales de Chaco",
  "powerOfAttorneyExchange.STOCK_EXCHANGE_ROSARIO": "Bolsa de Comercio de Rosario",
  "powerOfAttorneyExchange.STOCK_EXCHANGE_SANTA_FE": "Bolsa de Comercio de Santa Fe",
  // CURRENCIES
  "currency.ARS": "Peso",
  "currency.USD": "D\xF3lar",
  // EXPLOITATION TYPES
  "exploitationType.AGRICULTURAL": "Agr\xEDcola",
  "exploitationType.LIVE_STOCK": "Ganadera",
  "exploitationType.MIXED": "Mixta",
  // OWNERSHIP OPTIONS
  "ownershipType.OWN": "Propia",
  "ownershipType.THIRD_PARTY": "Terceros",
  // PLEDGE CLASSES
  "pledgeClass.FIXED": "Fija",
  "pledgeClass.FLOATING": "Flotante",
  // PLEDGE DEGREES
  "pledgeDegree.FIRST_DEGREE": "Primer grado",
  // CREDITOR INSPECTION RIGHTS
  "creditorInspectionRights.BROAD": "Amplios",
  "creditorInspectionRights.LIMITED": "Limitados",
  // DOCUMENTATION NEEDED
  "documentationNeeded.ownerIdentityDocument": "DNI del titular (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.proxies": "Apoderados: Poder + DNI apoderado. Copias certificadas y legalizadas",
  "documentationNeeded.socialContractAndChanges": "Contrato Social y sus modificaciones: copia certificada y legalizada",
  "documentationNeeded.partnersIdentityDocument": "DNI de los socios (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.membershipMeetingMinutes": "Actas de reuni\xF3n de socios: copia certificada y legalizada. Incluir hoja de r\xFAbrica",
  "documentationNeeded.statute": "Estatuto inscripto y sus modificaciones: copia certificada y legalizada.",
  "documentationNeeded.assemblyMinutes": "Acta de Asamblea donde tratan la designaci\xF3n de los accionistas y la elecci\xF3n de las autoridades, firmada por los accionistas y el presidente: copia certificada y legalizada. Incluir hoja de r\xFAbrica",
  "documentationNeeded.boardMinutes": "Acta de directorio, donde se trata la distribuci\xF3n y aceptaci\xF3n de cargos por parte de los directores elegidos en asamblea, firmada por todos los directores electos: copia certificada y legalizada. Incluir hoja de r\xFAbrica.",
  "documentationNeeded.legalRepresentativesIdentityDocument": "DNI de Representantes legales (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.statuteWithTransitoryProvisions": "Estatuto inscripto con disposiciones transitorias y sus modificaciones: copia certificada y legalizada.",
  "documentationNeeded.chiefAdministratorIdentityDocument": "DNI del Administrador Titular (nuevo modelo): copia certificada y legalizada",
  "documentationNeeded.socialContract": "Contrato social: copia certificada y legalizada",
  "documentationNeeded.extraDocsMessage": "Deber\xE1s comunicarte con la Bolsa de Cereales para consultar qu\xE9 documentaci\xF3n adicional deber\xE1s enviar para completar tu Legajo Digital",
  "documentationNeeded.alert.title": "Seg\xFAn el tipo de sociedad de tu empresa, deber\xE1s presentar informaci\xF3n adicional a la Bolsa seg\xFAn el siguiente detalle.",
  "documentationNeeded.alert.viewDetails": "Ver detalles",
  "documentationNeeded.modal.understood": "Entendido",
  "documentationNeeded.modal.title": "Ten\xE9s informaci\xF3n pendiente de presentar a la Bolsa de Cereales",
  "documentationNeeded.modal.text.start": "Dado que tu tipo societario es {{companyType}} es necesario que env\xEDes los siguientes documentos a la Bolsa de Cereales:",
  "documentationNeeded.modal.text.end": "En caso de tener documentaci\xF3n presentada con anterioridad, ver\xE1s precargados estos documentos y no ser\xE1 necesario enviarlos nuevamente. Ten\xE9 en cuenta que estos documentos son obligatorios para completar la certificaci\xF3n del Legajo Digital",
  // ERROR CODES
  "errorCode.createAdmin.firstName.minLength": "Debe tener al menos 2 caracteres",
  "errorCode.createAdmin.lastName.minLength": "Debe tener al menos 2 caracteres",
  "errorCode.createAdmin.email.isEmail": "Debe ser un correo electr\xF3nico v\xE1lido",
  "errorCode.createAdmin.authUuid.required": "El UUID de autenticaci\xF3n es requerido",
  "errorCode.createAdmin.adminRole.isValid": "El adminRole debe ser un rol valido",
  // ERROR PAGE
  "errorPage.RECORD_NOT_FOUND.mainErrorMessage": "P\xE1gina no encontrada",
  "errorPage.RECORD_NOT_FOUND.errorDescription": "La p\xE1gina que est\xE1s buscando no existe o ha sido movida.",
  "errorPage.goBack": "Volver atr\xE1s",
  "errorPage.FORBIDDEN_RESOURCE.mainErrorMessage": "Acceso denegado",
  "errorPage.FORBIDDEN_RESOURCE.errorDescription": "Lo sentimos, no tienes autorizaci\xF3n para acceder a esta p\xE1gina. Si necesitas ayuda, cont\xE1ctanos en {{emailContact}}",
  "errorPage.INTERNAL_SERVER_ERROR.mainErrorMessage": "Ops ha ocurrido un error",
  "errorPage.INTERNAL_SERVER_ERROR.errorDescription": "Ha ocurrido un error por favor intente nuevamente m\xE1s tarde.",
  // class-validator errors
  "class-validator.maxLength10.error": "El largo m\xE1ximo de este campo es de 10 numeros",
  "class-validator.isNotEmpty.error": "Este campo es requerido",
  "class-validator.isNumber.error": "Este campo debe ser num\xE9rico",
  "class-validator.email.isEmail": "Debe ser un correo electr\xF3nico v\xE1lido",
  "class-validator.isBase64.error": "Este campo debe contener un archivo",
  "class-validator.url.isURL": "La URL proporcionada no es v\xE1lida. Debe ser una URL completa con http o https.",
  "class-validator.isValidRepresentantBirthDate.error": `La fecha de nacimiento del representante debe ser anterior a hoy.`,
  "class-validator.min.1": "Debe ser mayor a 1",
  "class-validator.max.100": "Debe ser menor a 100",
  "class-validator.isLatitude": "Debe ser una latitud v\xE1lida",
  "class-validator.isLongitude": "Debe ser una longitud v\xE1lida",
  "errorCode.status.isValid": "El estado debe ser estado v\xE1lido",
  "errorCode.updateAdmin.status.isValid": "El estado debe ser estado v\xE1lido",
  "errorCode.fiscalIdInvalidFormat": "Debes ingresar un CUIT/CUIL v\xE1lido",
  "errorCode.createCompany.name.minLength": "Debe tener al menos 2 caracteres",
  "errorCode.createCompany.fiscalId.minLength": "Debe ser de un largo exacto de 11 caracteres",
  "errorCode.createCompany.ruca.isValid": "Debe ser un estado RUCA v\xE1lido",
  "errorCode.createCompany.renspa.minLength": "Debe ser de un largo exacto de 11 caracteres",
  "errorCode.createCompany.type.isValid": "El tipo de empresa debe ser un tipo v\xE1lido",
  "errorCode.createProductiveFacility.ownershipType.isValid": "El tipo de propiedad debe ser un tipo v\xE1lido",
  "errorCode.createCompany.mainActivity.length": "Debe tener entre 1 y 200 caracteres",
  "errorCode.createCompany.activityStartDate.isValid": "Debe ser una fecha v\xE1lida",
  "errorCode.updateCompany.status.validStatus": "El estado debe ser un estado v\xE1lido",
  "errorCode.createCompany.invalidationMessage.length": "Debe tener entre 1 y 200 caracteres",
  "errorCode.createCompany.activity.isValid": "Tipo de actividad inv\xE1lida",
  "errorCode.createCompanyDocument.companyUuid.isNotEmpty": "UUID de empresa es requerido",
  "errorCode.createCompanyDocument.identifier.length": "Debe tener entre 1 y 200 caracteres",
  "errorCode.createCompanyDocument.category.isValid": "Debe ser una categoria de documento v\xE1lida",
  "errorCode.createCompanyDocument.type.isValid": "Debe ser un tipo de documento v\xE1lido",
  "errorCode.createCompanyDocument.expirationDate.isValid": "Debe ser un n\xFAmero",
  "errorCode.createCompanyDocument.expirationDate.min": "Debe ser al menos 1 d\xEDgito",
  "errorCode.createCompanyDocument.expirationDate.max": "No puede exceder los 10 d\xEDgitos",
  "errorCode.createUserCompany.companyUuid.length": "UUID de compania debe ser de un largo exacto de 36 caracteres",
  "errorCode.createUserCompany.userUuid.length": "UUID de usuario debe ser de un largo exacto de 36 caracteres",
  "errorCode.createUserCompany.status.isValid": "El estado debe ser un estado v\xE1lido",
  "errorCode.createUserCompany.role.isValid": "El rol debe ser un rol v\xE1lido",
  "errorCode.createUser.fiscalId.notEmpty": "Id Fiscal es requerido",
  "errorCode.createUser.phoneNumber.isRequired": "El n\xFAmero de tel\xE9fono es requerido",
  "errorCode.createUser.status.isValid": "El estado debe ser un estado v\xE1lido",
  "errorCode.createUser.fiscalId.minLength": "Debe ser de un largo exacto de 11 caracteres",
  "errorCode.createUser.email.isEmail": "Debe ser un correo electr\xF3nico v\xE1lido",
  "errorCode.createUser.email.emailsDontMatch": "Los emails no coinciden. Por favor, verific\xE1 e intent\xE1 de nuevo.",
  "errorCode.createRepresentative.documentType.isValid": "El tipo de documento debe ser un tipo de documento v\xE1lido",
  "errorCode.createRepresentative.documentNumber.required": "El n\xFAmero de documento es requerido",
  "errorCode.createRepresentative.position.isValid": "La posici\xF3n debe ser una posici\xF3n v\xE1lida",
  "errorCode.createSignUp.companyExchange.isValid": "Se requiere una Bolsa de Cereales v\xE1lida.",
  "errorCode.createSignUp.representantMinLength": "Debe haber al menos un representante legal.",
  "errorCode.createSignUp.representantMaxLength": "Debe haber como m\xE1ximo dos representantes legales.",
  "errorCode.updateCompany.validationStatus.isValid": "Se requiere un estado de validaci\xF3n v\xE1lido",
  "errorCode.updateCompany.invalidationMessage.length": "Debe tener entre 1 y 200 caracteres",
  "errorCode.updateCompanyDocument.validatedAt.isValid": "Debe ser un n\xFAmero",
  "errorCode.updateCompanyDocument.validatedAt.min": "Debe ser al menos 1 d\xEDgito",
  "errorCode.updateCompanyDocument.validatedAt.max": "No puede exceder los 10 d\xEDgitos",
  "errorCode.updateCompanyGeneralInformation.sisaActivities.isValid": "Debe seleccionar una actividad SISA v\xE1lida",
  "errorCode.updateCompanyGeneralInformation.sisaScoring.isValid": "Debe seleccionar un Scoring SISA v\xE1lido",
  "errorCode.digitalDossier.updateBankingInfo.cbu.length": "Debe tener 22 caracteres",
  "errorCode.accessRequest.update.status.isValid": "El estado debe ser un estado v\xE1lido de solicitud de acceso",
  "errorCode.accessRequest.update.accessibleSection.isValid": "La secci\xF3n debe ser una secci\xF3n v\xE1lida",
  "errorCode.minLength.2": "Debe tener al menos 2 caracteres",
  // EXPLORER
  "explorer.navigation.menu.profile": "Perfil",
  "explorer.navigation.menu.availableQueries": "Saldo consultas",
  "explorer.navigation.availableQueries.label": "Saldo:",
  "explorer.navigation.availableQueries.tooltip": "Este es tu saldo actual de consultas de visualizaci\xF3n de legajos de terceros.",
  "explorer.navigation.route.home": "Mi Legajo Digital",
  "explorer.navigation.route.signUpRequest": "Mi solicitud de registro",
  "explorer.navigation.route.receivedAccessRequests": "Solicitudes de Acceso",
  "explorer.navigation.route.dossierExplorer": "Explorador de Legajos",
  "explorer.navigation.route.sentAccessRequests": "Historial de Consultas",
  "explorer.navigation.route.cropPledge": "Prendas de Cultivo",
  "explorer.digitalDossier.generalInformation.alert.title": "Al revisar el Legajo, ten\xE9 en cuenta que algunos campos no podr\xE1n ser editados, ya que solo los usuarios de la Bolsa de Cereales pueden ingresar informaci\xF3n en ellos.",
  // Digital dossier
  "explorer.digitalDossier.getGeneralInfo.error": "Error al cargar la informaci\xF3n general",
  "explorer.digitalDossier.updateGeneralInfo.success.toast.title": "Tu solicitud de aprobaci\xF3n de Datos generales de la empresa se envi\xF3 exitosamente.",
  "explorer.digitalDossier.updateGeneralInfo.error.toast.text": "Intente nuevamente m\xE1s tarde",
  "explorer.changeRequest.alert.title": "Ten\xE9s datos para revisar",
  "explorer.digitalDossier.getBankingInfo.error": "Error al cargar la informaci\xF3n bancaria",
  "explorer.digitalDossier.updateBankingInfo.success.toast.title": "Tu solicitud de aprobaci\xF3n de datos bancarios de la empresa se envi\xF3 exitosamente.",
  "explorer.digitalDossier.updateBankingInfo.error.toast.text": "Intente nuevamente m\xE1s tarde",
  "explorer.digitalDossier.updateBankingInfo.accountSection.title": "Cuenta nro {{num}}",
  "explorer.digitalDossier.updateBankingInfo.addBankAccount": "Agregar cuenta bancaria",
  "explorer.digitalDossier.updateBankingInfo.doYouHaveBankingInfo": "\xBFDeclar\xE1s datos bancarios?",
  "explorer.digitalDossier.updateBankingInfo.form.bankEntity.label": "Banco",
  "explorer.digitalDossier.updateBankingInfo.form.bankEntity.placeholder": "Ingrese banco",
  "explorer.digitalDossier.updateBankingInfo.form.cbu.label": "CBU",
  "explorer.digitalDossier.updateBankingInfo.form.cbu.placeholder": "Ingrese CBU",
  "explorer.digitalDossier.updateBankingInfo.form.cbuDocument.label": "Constancia de CBU",
  "explorer.digitalDossier.updateBankingInfo.form.documentId.label": "Identificador del documento",
  "explorer.digitalDossier.updateBankingInfo.form.dueDate.label": "Fecha de vencimiento",
  "explorer.signUp.modal.exitForm.title": "\xBFEst\xE1 seguro de querer salir?",
  "explorer.signUp.modal.exitForm.text": "Si confirma, se perder\xE1n todos los datos ingresados.",
  "explorer.digitalDossier.explorer.subTitle": "Busc\xE1 los Legajos de empresas, solicit\xE1 su visualizaci\xF3n y mantente al d\xEDa con las \xFAltimas actualizaciones.",
  "explorer.digitalDossier.explorer.newSearch": "Nueva b\xFAsqueda",
  "explorer.digitalDossier.explorer.newSearch.search.placeholder": "Busc\xE1 por CUIT o por empresa",
  "explorer.digitalDossier.explorer.newSearch.search.availableInquiries": "Saldo disponible de consultas:",
  "explorer.digitalDossier.explorer.history": "Legajos consultados",
  "explorer.digitalDossier.explorer.resultsTitle": "Resultados:",
  "explorer.digitalDossier.explorer.noResultsTitle": "No se encontraron resultados para tu b\xFAsqueda.",
  "explorer.digitalDossier.explorer.noResultsSubtitle": "Parece que no se encontraron Legajos que coincidan con los criterios de b\xFAsqueda que ingresaste. Por favor, verifica los detalles de tu b\xFAsqueda e int\xE9ntalo de nuevo.",
  "explorer.digitalDossier.explorer.action.view": "Ver Legajo Digital",
  "explorer.digitalDossier.explorer.action.requestAccess": "Solicitar visualizaci\xF3n",
  "explorer.digitalDossier.explorer.action.tooltip.hasntBeenApprovedDigitalDossier": "Es necesario que termines de cargar y aprobar tu Legajo para poder proceder con la visualizaci\xF3n de los Legajos de terceros.",
  "explorer.digitalDossier.explorer.status.PENDING": "En proceso",
  "explorer.digitalDossier.explorer.status.AVAILABLE": "Disponible",
  "backoffice.pages.bankInformation.changeRequest.title": "Solicitar revisi\xF3n de Datos impositivos",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.emptyState.title": "A\xFAn no hay representantes legales.",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.emptyState.description": "La Bolsa de Cereales cargar\xE1 los representantes legales de tu empresa, de acuerdo a la documentaci\xF3n que aportes y podr\xE1s verlos aqu\xED una vez que est\xE9n disponibles.",
  "explorer.digitalDossier.getLegalRepresentativesInfo.error": "Error al cargar la informaci\xF3n de representantes legales",
  // BACKOFFICE
  "backoffice.navigation.route.home": "Legajos digitales",
  "backoffice.navigation.route.signupRequests": "Solicitudes de registro",
  "backoffice.navigation.route.signupRequestsDetail": "Solicitudes de registro",
  "backoffice.navigation.route.digitalDossiers": "Legajos digitales",
  "backoffice.navigation.route.digitalDossierDetail": "Legajos digitales",
  "backoffice.navigation.route.dossierQueries": "Consultas de Legajos",
  "backoffice.navigation.route.cropPledges": "Prendas de cultivo",
  "backoffice.pages.digitalDossiers.table.search.placeholder": "Buscar por raz\xF3n social, CUIT",
  "backoffice.pages.digitalDossiers.table.statusFilter.placeholder": "Filtrar por estado",
  "backoffice.pages.digitalDossiers.table.statusFilter.allText": "Todos",
  "backoffice.pages.signUpRequests.table.search.placeholder": "Buscar por raz\xF3n social, CUIT",
  "backoffice.pages.signUpRequests.table.statusFilter.placeholder": "Filtrar por estado",
  "backoffice.pages.signUpRequests.table.statusFilter.allText": "Todos",
  "backoffice.pages.generalInformation.saveChanges": "Guardar cambios",
  "backoffice.pages.generalInformation.saveAndApprove": "Guardar y aprobar",
  "backoffice.pages.generalInformation.requestRevision": "Solicitar revisi\xF3n",
  "backoffice.pages.generalInformation.selectDate": "Seleccionar fecha",
  "backoffice.pages.generalInformation.selectRuca": "Seleccionar RUCA",
  "backoffice.pages.generalInformation.typeIgj": "Ingresar IGJ",
  "backoffice.pages.generalInformation.typeSignatureSchema": "Ingresar esquema de firmas",
  "backoffice.pages.generalInformation.selectSisaScoring": "Seleccionar scoring",
  "backoffice.pages.generalInformation.changeRequest.title": "Solicitar revisi\xF3n de Datos generales de empresa",
  "backoffice.pages.docsAndForms.changeRequest.title": "Solicitar revisi\xF3n de Documentaci\xF3n y formularios",
  "backoffice.pages.taxInformation.changeRequest.title": "Solicitar revisi\xF3n de Datos impositivos",
  "backoffice.pages.generalInformation.changeRequest.confirmButton": "Solicitar revisi\xF3n",
  "backoffice.pages.generalInformation.changeRequestTitle": "Solicitar revisi\xF3n de Datos generales de empresa",
  "backoffice.pages.generalInformation.validationMessage.label": "Comentarios u observaciones",
  "backoffice.pages.generalInformation.validationMessage.placeholder": "Por favor, proporciona una breve explicaci\xF3n de por qu\xE9 solicitaste la revisi\xF3n para garantizar que se ingrese la informaci\xF3n correcta.",
  "backoffice.pages.generalInformation.validationMessage.minLength": "Este campo debe tener al menos 3 caracteres",
  "backoffice.pages.generalInformation.validationMessage.maxLength": "Este campo debe tener menos de 200 caracteres",
  "backoffice.pages.generalInformation.activityStartDate.startDateMustBeOlderThanEndDate": "La fecha de inicio de actividad debe ser anterior a la Fecha de fin de actividad",
  "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate": "La fecha de fin de actividad debe ser posterior a la Fecha de inicio de actividad",
  "backoffice.digitalDossier.update.success.toast.title": "La informaci\xF3n fue enviada correctamente.",
  "backoffice.digitalDossier.approve.success.toast.title": "La secci\xF3n ha sido actualizada y aprobada correctamente.",
  "backoffice.digitalDossier.requestChange.success.toast.title": "Se han solicitado correctamente cambios para esta secci\xF3n.",
  "backoffice.digitalDossier.update.error.toast.title": "Ocurri\xF3 un error",
  "backoffice.digitalDossier.update.error.toast.text": "Por favor intente nuevamente m\xE1s tarde",
  "backoffice.pages.bankInformation.bankName": "banco",
  "backoffice.pages.bankInformation.bankName.placeholder": "Ingresar banco",
  "backoffice.pages.bankInformation.cbu": "CBU",
  "backoffice.pages.bankInformation.cbu.placeholder": "Ingresar CBU",
  "backoffice.pages.bankInformation.cbuDocument": "Constancia de CBU",
  "backoffice.pages.bankInformation.documentId": "Identificador del documento",
  "backoffice.pages.bankInformation.documentId.placeholder": "Ingresar identificador",
  "backoffice.pages.bankInformation.expirationDate": "Fecha de vencimiento",
  "backoffice.pages.bankInformation.expirationDate.placeholder": "Seleccionar fecha",
  "backoffice.pages.bankInformation.bankAccountTitle": "Cuenta Nro {{bankAccountNumber}}",
  "backoffice.pages.bankInformation.removeBankForm": "Eliminar",
  "backoffice.pages.bankInformation.addBankForm": "Agregar cuenta bancaria",
  "backoffice.pages.bankInformation.doYouHaveBankInfo": "\xBFDeclar\xE1s datos bancarios?",
  "backoffice.pages.taxInformation.cuitCertificateDocument.label": "Constancia de CUIT",
  "backoffice.pages.taxInformation.cuitCertificateDocumentId.label": "Identificador del documento",
  "backoffice.pages.taxInformation.cuitCertificateDocumentId.placeholder": "Ingresar identificador",
  "backoffice.pages.taxInformation.cuitCertificateDocumentExpirationDate.label": "Fecha de vencimiento",
  "backoffice.pages.taxInformation.cuitCertificateDocumentExpirationDate.placeholder": "Seleccionar fecha",
  "backoffice.pages.taxInformation.IVACondition.label": "Condici\xF3n frente al IVA",
  "backoffice.pages.taxInformation.IVACondition.placeholder": "Seleccionar condici\xF3n",
  "backoffice.pages.taxInformation.IBB.label": "IIBB",
  "backoffice.pages.taxInformation.IBB.placeholder": "Seleccionar IIBB",
  "backoffice.pages.taxInformation.jurisdiction.label": "Jurisdicci\xF3n",
  "backoffice.pages.taxInformation.jurisdiction.placeholder": "Seleccionar jurisdicci\xF3n",
  "backoffice.pages.taxInformation.IBBCertificate.label": "Constancia de IIBB",
  "backoffice.pages.taxInformation.IBBCertificateDocumentId.label": "Identificador del documento",
  "backoffice.pages.taxInformation.IBBCertificateDocumentId.placeholder": "Ingresar identificador",
  "backoffice.pages.taxInformation.profitsDocument.label": "Constancia de impuesto a las ganancias",
  "backoffice.pages.taxInformation.profitsTax.label": "Impuesto a las ganancias",
  "backoffice.pages.taxInformation.profitsTax.placeholder": "Seleccionar Impuesto a las ganancias",
  "backoffice.pages.taxInformation.CM05Certificate.label": "CM05",
  "backoffice.pages.taxInformation.ExemptionsCertificate.label": "Exenciones",
  "backoffice.pages.taxInformation.additionalDocumentation.label": "Documentaci\xF3n adicional",
  "backoffice.pages.taxInformation.additionalDocumentation.add": "Agregar documentaci\xF3n adicional",
  "backoffice.pages.taxInformation.tobeFilledByBC.placeholder": "A cargar por la Bolsa",
  "backoffice.pages.taxInformation.PROFIT_TYPES.REGISTERED": "Registrado",
  "backoffice.pages.taxInformation.PROFIT_TYPES.NOT_REGISTERED": "No Registrado",
  "backoffice.pages.taxInformation.PROFIT_TYPES.EXEMPT": "Exento",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_REGISTERED_RESPONSIBLE": "Responsable inscripto en IVA",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_EXEMPT_SUBJECT": "Sujeto exento de IVA",
  "backoffice.pages.taxInformation.IVA_CONDITION.MONOTAX_RESPONSIBLE": "Responsable de monotributo",
  "backoffice.pages.taxInformation.IVA_CONDITION.UNCATEGORIZED_SUBJECT": "Sujeto no categorizado",
  "backoffice.pages.taxInformation.IVA_CONDITION.FOREIGN_SUPPLIER": "Proveedor extranjero",
  "backoffice.pages.taxInformation.IVA_CONDITION.FOREIGN_CLIENT": "Cliente extranjero",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_RELEASED": "Liberado de IVA",
  "backoffice.pages.taxInformation.IVA_CONDITION.MONOTRIBUTIST_SOCIAL": "Monotributista social",
  "backoffice.pages.taxInformation.IVA_CONDITION.IVA_NOT_REACHED": "No alcanzado por el IVA",
  "backoffice.pages.taxInformation.IVA_CONDITION.PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST": "Trabajador independiente promovido monotributista",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.LOCAL_JURISDICTION": "Jurisdicci\xF3n local",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.MULTILATERAL_AGREEMENT": "Convenio multilateral",
  "backoffice.pages.taxInformation.BRUTE_INCOME_TYPES.EXEMPT": "Exento",
  "backoffice.form.update.success.toast.title": "La informaci\xF3n fue enviada correctamente.",
  "backoffice.form.approve.success.toast.title": "La secci\xF3n ha sido actualizada y aprobada correctamente.",
  "common.pages.docsAndForms.sisaFile.label": "Copia consulta p\xFAblica SISA firmada",
  "common.pages.docsAndForms.statuteFile.label": "Estatuto/Contrato social",
  "common.pages.docsAndForms.statuteChangeFiles.label": "Modificaciones estatuto",
  "common.pages.docsAndForms.additionalStatuteChangeFiles.label": "Agregar modificaciones estatuto",
  "common.pages.docsAndForms.assemblyBoardMinutesFiles.label": "Acta de Asamblea y Directorio",
  "common.pages.docsAndForms.additionalAssemblyBoardMinutesFiles.label": "Agregar acta",
  "common.pages.docsAndForms.boxNumber.label": "N\xFAmero de caja archivo",
  "common.pages.docsAndForms.powerOfAttorneyFiles.label": "Poder",
  "common.pages.docsAndForms.additionalPowerOfAttorneyFiles.label": "Agregar poder",
  "common.pages.docsAndForms.businessSingupForm.label": "Formulario alta registro empresa",
  "common.pages.docsAndForms.additionalDocument.label": "Documentaci\xF3n adicional",
  "common.pages.docsAndForms.additionalDocument.addNew.label": "Agregar documentaci\xF3n adicional",
  // load dossier queries
  "backoffice.pages.dossierQueries.subTitle": "Administr\xE1 la cantidad de consultas de las empresas y recarga su saldo si es necesario.",
  "backoffice.pages.dossierQueries.table.title.available": "Consultas disponibles",
  "backoffice.pages.dossierQueries.table.title.lastLoad": "Fecha de \xFAltimo pedido",
  "backoffice.pages.dossierQueries.modal.title": "Cargar consultas",
  "backoffice.pages.dossierQueries.modal.subTitle": "Ingres\xE1 la cantidad de consultas y sub\xED los contratos de carga de consultas.",
  "backoffice.pages.dossierQueries.modal.amount.label": "Nro de consultas",
  "backoffice.pages.dossierQueries.modal.amount.placeholder": "Ingresar n\xFAmero",
  "backoffice.pages.dossierQueries.modal.file.label": "Contrato",
  "backoffice.pages.dossierQueries.modal.confirm": "Cargar",
  // AMPLIFY
  //
  "amplify.email.placeholder": "Ingresar email",
  "amplify.fiscalId.placeholder": "Ingresar CUIT/CUIL",
  "amplify.password.placeholder": "Ingresar contrase\xF1a",
  "amplify.confirmationCode.placeholder": "Ingrese el c\xF3digo de confirmaci\xF3n",
  "amplify.newPassword.label": "Nueva contrase\xF1a",
  "amplify.newPassword.placeholder": "Ingrese su nueva contrase\xF1a",
  "amplify.confirmPassword.label": "Confirme su contrase\xF1a",
  "amplify.confirmPassword.placeholder": "Confirme su contrase\xF1a",
  //
  "amplify.incorrectUsernameOrPassword": "Credenciales inv\xE1lidas",
  "amplify.fiscalIdRequiredToSignIn": "El CUIT/CUIL es obligatorio",
  "amplify.emailRequiredToSignIn": "El email es obligatorio",
  "amplify.passwordRequiredToSignIn": "La contrase\xF1a es obligatoria",
  "amplify.fiscalIdRequiredToResetPassword": "El CUIT/CUIL es obligatorio para restablecer la contrase\xF1a",
  "amplify.emailRequiredToResetPassword": "El email es obligatorio para restablecer la contrase\xF1a",
  "amplify.newPasswordIsRequiredToConfirmResetPassword": "La nueva contrase\xF1a es obligatoria",
  "amplify.confirmationCodeIsRequiredToConfirmResetPassword": "El c\xF3digo de confirmaci\xF3n es obligatorio",
  "amplify.invalidVerificationCodeProvided": "C\xF3digo de confirmaci\xF3n inv\xE1lido, intente nuevamente",
  "amplify.passwordAtLeast8Characters": "La contrase\xF1a debe tener al menos 8 caracteres",
  "amplify.passwordMustHaveSpecialCharacters": "La contrase\xF1a debe tener al menos 1 caractere especial: !@#$%&*?",
  "amplify.passwordMustHaveLowercaseCharacters": "La contrase\xF1a debe contener al menos 1 letra min\xFAscula",
  "amplify.passwordMustHaveUppercaseCharacters": "La contrase\xF1a debe contener al menos 1 letra may\xFAscula",
  "amplify.passwordMustHasNumber": "La contrase\xF1a debe contener al menos 1 n\xFAmero",
  "amplify.passwordTooltip": "La contrase\xF1a debe tener al menos 8 caracteres e incluir letras min\xFAsculas y may\xFAsculas, al menos un n\xFAmero y un car\xE1cter especial.",
  //
  "amplify.signIn.title": "\xA1Bienvenido!",
  "amplify.signIn.subtitle": "Ingres\xE1 tus credenciales para iniciar sesi\xF3n",
  "amplify.resetPassword.title": "Restablecer contrase\xF1a",
  "amplify.forgotYourPassword": "\xBFOlvidaste tu contrase\xF1a?",
  "amplify.doNotHaveAnAccount": "\xBFNo ten\xE9s una cuenta?",
  "amplify.signup": "Reg\xEDstrate",
  // IVA_CONDITION
  "ivaCondition.IVA_REGISTERED_RESPONSIBLE": "IVA responsable inscripto",
  "ivaCondition.IVA_EXEMPT_SUBJECT": "IVA sujeto exento",
  "ivaCondition.MONOTAX_RESPONSIBLE": "Responsable monotributo",
  "ivaCondition.UNCATEGORIZED_SUBJECT": "Sujeto no categorizado",
  "ivaCondition.FOREIGN_SUPPLIER": "Proveedor del exterior",
  "ivaCondition.FOREIGN_CLIENT": "Cliente del exterior",
  "ivaCondition.IVA_RELEASED": "IVA liberado - ley nro. 19640",
  "ivaCondition.MONOTRIBUTIST_SOCIAL": "Monotributista social",
  "ivaCondition.IVA_NOT_REACHED": "IVA no alcanzado",
  "ivaCondition.PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST": "Monotributista trabajador independiente promovido",
  // SIGNUP
  "errorCode.signupRequest.rejectionReason.required": "El mensaje de rechazo es requerido.",
  "errorCode.signupRequest.rejectionReason.maxLength": "El mensaje de rechazo no debe superar los 200 caracteres.",
  "errorCode.renspa.invalidFormat": "El identificador RENSPA debe tener el formato 00.000.0.00000.00",
  "errorCode.exploitationType.isValid": "El tipo de explotaci\xF3n debe ser un tipo v\xE1lido",
  // SIGNUP REQUEST DETAIL
  "signupRequestDetail.description": "Ac\xE1 pod\xE9s gestionar la solicitud de registro. Aprob\xE1, solicit\xE1 una revisi\xF3n o rechaz\xE1 la solicitud en el caso de ser necesario.",
  "signupRequestDetail.requestedDocumentChanges.alert.title": "Solicitud de revisi\xF3n de documentaci\xF3n",
  "signupRequestDetail.downloadPdf": "Descargar PDF registro",
  // REGISTER REQUEST
  "signUpRequest.generalCompanyInformation": "Datos generales de empresa",
  "signUpRequest.administratorData": "Datos de administrador",
  "signUpRequest.legalRepresentativeData": "Datos de representante legal",
  "signUpRequest.pageSubtitle": "Ac\xE1 pod\xE9s gestionar la solicitud del registro de la empresa.",
  "signUpRequest.updateData": "Actualizar informaci\xF3n",
  "signUpRequest.form.signUpPermissionFile.label": "Acreditaci\xF3n de representaci\xF3n legal: cargar el acta, poder o documento de donde surja su representaci\xF3n.",
  "signUpRequest.modal.label": "\xBFEst\xE1s seguro de actualizar la informaci\xF3n?",
  "signUpRequest.modal.confirm": "Actualizar informaci\xF3n",
  "signUpRequest.toast.success.label": "La informaci\xF3n fue actualizada exitosamente",
  "signUpRequest.toast.success.text": "Revisaremos la informaci\xF3n y te notificaremos cuando este aprobada.",
  "signUpRequest.toast.error.label": "Ocurri\xF3 un error",
  "signUpRequest.toast.error.text": "Intente nuevamente m\xE1s tarde.",
  // sections
  "signupRequestDetail.sections.generalData.title": "Datos generales de empresa",
  "signupRequestDetail.sections.administratorData.title": "Datos de administrador",
  "signupRequestDetail.sections.representativesData.title": "Representante legal {{representantId}}",
  // approve
  "signupRequestDetail.approve.modal.title": "\xBFEst\xE1s seguro de aprobar la solicitud de registro de {{companyName}}?",
  "signupRequestDetail.approve.success.title": "La solicitud de registro fue aprobada exitosamente",
  "signupRequestDetail.approve.success.text": "La empresa fue notificada por email para completar su legajo digital.",
  "signupRequestDetail.approve.error.title": "Ocurri\xF3 un error",
  "signupRequestDetail.approve.error.text": "Intente nuevamente m\xE1s tarde",
  // reject
  "signupRequestDetail.reject.modal.title": "\xBFEst\xE1s seguro de rechazar la solicitud de registro de {{companyName}}?",
  "signupRequestDetail.reject.success.title": "La solicitud de registro fue rechazada exitosamente",
  "signupRequestDetail.reject.success.text": "Se envi\xF3 un email notificando a la empresa.",
  "signupRequestDetail.reject.error.text": "Intente nuevamente m\xE1s tarde",
  "signupRequestDetail.reject.alert.title": "Motivo del rechazo",
  // request review
  "signupRequestDetail.requestReview.title": "Solicitar revisi\xF3n",
  "signupRequestDetail.requestReview.modal.title": "\xBFEst\xE1s seguro de enviar la solicitud de revisi\xF3n de {{companyName}}?",
  "signupRequestDetail.requestReview.success.title": "Solicitud de revisi\xF3n enviada exitosamente",
  "signupRequestDetail.requestReview.success.text": "Se envi\xF3 un mail notificando a la empresa.",
  "signupRequestDetail.requestReview.error.text": "Intente nuevamente m\xE1s tarde.",
  "signupRequestDetail.requestReview.radio.label": "\xBFQuer\xE9s solicitar la revisi\xF3n de {{documentType}}?",
  "signupRequestDetail.requestReview.missingPermissionFile": "Por favor, es necesario cargar el permiso para firmar la solicitud.",
  "signupRequestDetail.requestReview.missingPermissionFile.title": "\xBFQuer\xE9s solicitar la carga de permiso para firmar la solicitud?",
  // update
  "signupRequestDetail.updateSignupRequest.success.title": "Guardaste los datos exitosamente",
  "signupRequestDetail.updateSignupRequest.error.text": "Intente nuevamente m\xE1s tarde.",
  // access requests
  "accessRequests.page.title": "Historial de consultas",
  "accessRequests.page.description": "Accede a los Legajos Digitales que solicitaste visualizar y mantente al d\xEDa con las \xFAltimas actualizaciones.\nRecuerda que cada nueva actualizaci\xF3n consume consultas de tu saldo.",
  "accessRequests.table.requestedAt": "Solicitud Visualizaci\xF3n",
  "accessRequests.table.companyFiscalId": "CUIT",
  "accessRequests.table.companyName": "Empresa",
  "accessRequests.table.requestStatus": "Estado consulta",
  "accessRequests.table.dossierStatus": "Estado Legajo",
  "accessRequests.table.dossierUpdatedAt": "\xDAltima actualizaci\xF3n",
  "accessRequests.table.accessRequestStatusFilter.placeHolder": "Filtrar por estado consulta",
  "accessRequests.table.digitalDossierStatusFilter.placeHolder": "Filtrar por estado Legajo",
  "accessRequests.status.PENDING": "Pendiente de aprobaci\xF3n",
  "accessRequests.status.APPROVED": "Disponible",
  "accessRequests.status.REJECTED": "Rechazada",
  "accessRequests.status.EXPIRED": "Expirada",
  "accessRequests.status.REVOKED": "Acceso revocado",
  "accessRequests.status.digitalDossierStatus.APPROVED": "Aprobado",
  "accessRequests.status.digitalDossierStatus.RUCA_EXPIRED": "RUCA no vigente",
  "accessRequests.status.digitalDossierStatus.INFORMATION_EXPIRED": "Informaci\xF3n vencida",
  // received access requests
  "receivedAccessRequests.page.title": "Solicitudes de acceso",
  "receivedAccessRequests.page.description": "Consult\xE1 las empresas que solicitaron ver tu Legajo Digital.",
  "receivedAccessRequests.table.requestedAt": "Fecha de solicitud",
  "receivedAccessRequests.table.companyFiscalId": "CUIT",
  "receivedAccessRequests.table.requestedBy": "Solicitante",
  "receivedAccessRequests.table.requestStatus": "Estado",
  "receivedAccessRequests.table.actions": "Acciones",
  "receivedAccessRequests.table.accessibleSections": "Secciones visibles",
  "receivedAccessRequests.table.accessibleSections.button": "Ver secciones visibles",
  "receivedAccessRequests.status.PENDING": "Pendiente de aprobaci\xF3n",
  "receivedAccessRequests.status.APPROVED": "Aprobada",
  "receivedAccessRequests.status.REJECTED": "Rechazada",
  "receivedAccessRequests.status.EXPIRED": "Expirada",
  "receivedAccessRequests.status.REVOKED": "Acceso revocado",
  "accessRequests.successModal.title": "\xA1Tu solicitud de visualizaci\xF3n se envi\xF3 con \xE9xito!",
  "accessRequests.successModal.description": "La empresa debe ahora confirmar tu solicitud para acceder y visualizar su Legajo.",
  "accessRequests.successModal.confirm": "Entendido",
  "receivedAccessRequests.approveRequest.modal.title": "Al aprobar esta solicitud estar\xE1 dando acceso a su Legajo digital y datos de contacto",
  "receivedAccessRequests.approveRequest.modal.text": "En caso de querer compartir secciones adicionales deber\xE1 seleccionarlas a continuaci\xF3n:",
  "receivedAccessRequests.rejectRequest.modal.title": "\xBFEst\xE1 seguro de rechazar la solicitud de visualizaci\xF3n a {{selectedCompanyName}}?",
  "receivedAccessRequests.revokeRequest.modal.title": "\xBFEst\xE1 seguro de revocar el acceso de {{selectedCompanyName}} de tu Legajo?",
  "receivedAccessRequests.accessibleSections.modal.title": "Secciones visibles",
  "receivedAccessRequests.accessibleSections.modal.description": "Pod\xE9s otorgar visualizaci\xF3n de las distintas secciones del Legajo Digital. Selecciona las secciones que quer\xE9s que este usuario vea.",
  "receivedAccessRequests.approveRequest.success.title": "La solicitud de aprobaci\xF3n fue realizada exitosamente",
  "receivedAccessRequests.rejectRequest.success.title": "La solicitud de rechazo fue realizada exitosamente",
  "receivedAccessRequests.revokeRequest.success.title": "La solicitud de revocaci\xF3n fue realizada exitosamente",
  "receivedAccessRequests.accessibleSections.toast.success.title": "Se editaron las secciones correctamente.",
  "receivedAccessRequests.accessibleSections.toast.error.title": "Hubo un error al editar las secciones visibles. Por favor, int\xE9ntalo nuevamente.",
  "renewAccessRequest.modal.title": "\xBFEst\xE1s seguro que quer\xE9s renovar la consulta del Legajo seleccionado?",
  "renewAccessRequest.modal.text": `Record\xE1 que la renovaci\xF3n consumir\xE1 una nueva consulta de tu saldo. Actualmente, dispon\xE9s de {{remainingAccessRequestsTickets}} consultas restantes.`,
  // Dropzone
  "dropzone.clickHereMessage": "Haga click aqu\xED",
  "dropzone.orDropTheFileMessage": "o suelte el archivo",
  "dropzone.tryAgainMessage": "Subir de nuevo",
  "dropzone.fileInvalidTypeMessage": "El archivo no es v\xE1lido",
  // Shared digital dossier
  "sharedDigitalDossier.error.default": "Error al cargar el legajo digital",
  "sharedDigitalDossier.error.FORBIDDEN_RESOURCE": "No ten\xE9s acceso a este legajo digital",
  "sharedDigitalDossier.alert.nonCurrentData.title": "Este Legajo contiene datos no vigentes.",
  "sharedDigitalDossier.alert.nonCurrentData.description": "Ya informamos a la empresa para que realice los cambios necesarios. Una vez que estos sean realizados por el cliente y aprobados por la Bolsa, ver\xE1s una nueva actualizaci\xF3n del Legajo con los cambios efectuados.",
  "sharedDigitalDossier.bankingInfo.emptyState.title": "No hay datos para mostrar",
  "sharedDigitalDossier.bankingInfo.emptyState.description": "{{companyName}} no ingres\xF3 datos en esta secci\xF3n del legajo.",
  "sharedDigitalDossier.affidavits.productiveFacilities.emptyState.title": "A\xFAn no hay ning\xFAn establecimiento aprobado",
  "sharedDigitalDossier.affidavits.productiveFacilities.emptyState.description": "Cuando se apruebe alg\xFAn establecimiento, aparecer\xE1 listado ac\xE1 junto a todas sus declaraciones juradas.",
  "sharedDigitalDossier.affidavits.storageFacilities.emptyState.title": "A\xFAn no hay ning\xFAn acopio aprobado",
  "sharedDigitalDossier.affidavits.storageFacilities.emptyState.description": "Cuando se apruebe alg\xFAn acopio, aparecer\xE1 listado ac\xE1 junto a su declaraci\xF3n jurada.",
  "sharedDigitalDossier.equityInformation.emptyState.title": "A\xFAn no hay informaci\xF3n patrimonial aprobada",
  "sharedDigitalDossier.equityInformation.emptyState.description": "Cuando se apruebe la informaci\xF3n patrimonial, aparecer\xE1 ac\xE1.",
  "sharedDigitalDossier.contactInformation.emptyState.title": "A\xFAn no hay informaci\xF3n de contacto aprobada",
  "sharedDigitalDossier.contactInformation.emptyState.description": "Cuando se apruebe la informaci\xF3n de contacto, aparecer\xE1 ac\xE1.",
  "sharedDigitalDossier.restrictedSection.title": "Actualmente no ten\xE9s acceso a esta secci\xF3n del Legajo",
  "sharedDigitalDossier.restrictedSection.description": "Si ten\xE9s alguna pregunta o quer\xE9s solicitar acceso a esta secci\xF3n, por favor comunicate con la empresa.",
  // My Digital Dossier - Legal Representatives section
  "digitalDossier.legalRepresentatives.error.startOfTermMustBeNewerThanEndOfTerm": "La fecha de inicio de mandato debe ser anterior a la de fin",
  "digitalDossier.legalRepresentatives.error.endOfTermMustBeOlderThanStartOfTerm": "La fecha de fin de mandato debe ser posterior a la de inicio",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.idDocument": "Imagen documento de identidad",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.idOfTheAuthorizedLegalRepresentationDocument": "Identificaci\xF3n del documento de representaci\xF3n legal autorizada",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.hasCurrencyCap": "Tope por monto",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.labels.hasProductCap": "Tope por producto",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.addProductCap": "Agregar tope por producto",
  "explorer.digitalDossier.updateLegalRepresentantivesInfo.addCurrencyCap": "Agregar tope por monto",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.addRepresentative": "Agregar representante",
  "backoffice.digitalDossier.updateRepresentantsInformation.success.toast.title": "Datos guardados exitosamente",
  "backoffice.digitalDossier.approveRepresentantsInformation.success.toast.title": "Los representantes legales fueron aprobados exitosamente.",
  "backoffice.digitalDossier.requestReviewRepresentantsInformation.success.toast.title": "La solicitud de revisi\xF3n de representantes legales fue enviada exitosamente.",
  "digitalDossier.updateLegalRepresentantivesInfo.representativeSection.title": "Representante legal nro {{num}}",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.firstName": "Ingresar nombre",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.lastName": "Ingresar apellido",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identityDocumentType": "Seleccionar tipo de documento",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identityDocumentId": "Ingresar documento",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.email": "Ingresar email",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.position": "Seleccionar cargo",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.startOfTerm": "Seleccionar fecha",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.endOfTerm": "Seleccionar fecha",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.identifier": "Ingresar identificador",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.expirationDate": "Seleccionar fecha",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.bcAuthorizedDocumentIdentifier": "Ingresar nombre de documento",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.signatureLevel": "Seleccionar nivel de firma",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.powerOfAttorneyExchange": "Seleccionar Bolsa",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.product": "Seleccionar producto",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.amount": "Ingresar monto",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.currency": "Seleccionar moneda",
  "backoffice.digitalDossier.updateLegalRepresentantivesInfo.placeholders.tons": "Ingresar toneladas",
  // legal representatives section
  "digitalDossier.legalRepresentatives.representativeCaps": "Topes representante",
  "digitalDossier.legalRepresentatives.requestChangesModal.title": "Solicitar revisi\xF3n de representantes legales",
  // Productive facilities
  "explorer.productiveFacilities.addFacility": "Agregar establecimiento",
  "explorer.productiveFacilities.editFacility": "Editar establecimiento",
  "explorer.productiveFacilities.addAffidavit": "Agregar declaraci\xF3n jurada",
  "explorer.productiveFacilities.editAffidavit": "Editar declaraci\xF3n jurada",
  "explorer.productiveFacilities.getInfo.error": "Error al cargar los establecimientos",
  "explorer.productiveFacilities.emptyState.title": "No hay ning\xFAn establecimiento agregado.",
  "explorer.productiveFacilities.emptyState.description": "Agreg\xE1 un nuevo establecimiento para registrar toda su informaci\xF3n.",
  "explorer.productiveFacilities.deleteFacility.modal.title": "\xBFEst\xE1s seguro de que quieres eliminar el establecimiento?",
  "explorer.productiveFacilities.deleteFacility.modal.text": "No podr\xE1s revertir esta acci\xF3n",
  "explorer.productiveFacilities.deleteFacility.success.title": "Establecimiento eliminado correctamente",
  "explorer.productiveFacilities.deleteAffidavit.modal.title": "\xBFEst\xE1s seguro de que quieres eliminar la declaraci\xF3n jurada?",
  "explorer.productiveFacilities.deleteAffidavit.modal.text": "No podr\xE1s revertir esta acci\xF3n",
  "explorer.productiveFacilities.deleteAffidavit.success.title": "Declaraci\xF3n jurada eliminada correctamente",
  "productiveFacilities.accordion.title": "Establecimiento nro {{n}}",
  "productiveFacilities.affidavitsEmptyState.title": "Todav\xEDa no agregaste ninguna declaraci\xF3n jurada",
  "productiveFacilities.affidavitsEmptyState.description": "Para solicitar aprobaci\xF3n del establecimiento tenes que cargar al menos una delcaraci\xF3n juarada.",
  "productiveFacilities.facilityStatusAlert.PENDING_CHANGE_REQUEST.title": "Ten\xE9s datos a revisar. Hac\xE9 click en 'Editar' para modificar los campos necesarios. Una vez editados, volv\xE9 a solicitar aprobaci\xF3n.",
  "productiveFacilities.upsert.establishmentName.label": "Nombre establecimiento",
  "productiveFacilities.upsert.establishmentName.placeholder": "Ingresar establecimiento",
  "explorer.productiveFacilities.createFacility.success.title": "Establecimiento creado correctamente",
  "explorer.productiveFacilities.updateFacility.success.title": "Establecimiento actualizado correctamente",
  "explorer.productiveFacilities.createAffidavit.success.title": "Declaraci\xF3n jurada creada correctamente",
  "explorer.productiveFacilities.updateAffidavit.success.title": "Declaraci\xF3n jurada actualizada correctamente",
  "explorer.productiveFacilities.requestApproval.success.title": "Solicitud de aprobaci\xF3n enviada correctamente",
  "backoffice.productiveFacilities.approve.success.title": "El establecimiento se aprob\xF3 exitosamente",
  "backoffice.productiveFacilities.requestChanges.success.title": "Solicitud de revisi\xF3n enviada exitosamente",
  "productiveFacilities.upsert.province.label": "Provincia",
  "productiveFacilities.upsert.province.placeholder": "Seleccionar provincia",
  "productiveFacilities.upsert.locality.label": "Localidad",
  "productiveFacilities.upsert.locality.placeholder": "Seleccionar localidad",
  "productiveFacilities.upsert.locality.noOptionsMessage": "Tu b\xFAsqueda no trajo resultados. Intenta nuevamente.",
  "productiveFacilities.upsert.geolocationDocument.label": "Geolocalizaci\xF3n",
  "productiveFacilities.upsert.ownership.label": "Titularidad",
  "productiveFacilities.upsert.ownership.placeholder": "Seleccionar titularidad",
  "productiveFacilities.upsert.productiveHectares.label": "Has productivas",
  "productiveFacilities.upsert.productiveHectares.placeholder": "Ingresar has productivas",
  "productiveFacilities.upsert.exploitationType.label": "Tipo de explotaci\xF3n",
  "productiveFacilities.upsert.exploitationType.placeholder": "Ingresar tipo de explotaci\xF3n",
  "productiveFacilities.upsert.startDate.label": "Fecha de inicio",
  "productiveFacilities.upsert.startDate.placeholder": "Seleccionar fecha",
  "productiveFacilities.upsert.endDate.label": "Fecha de fin",
  "productiveFacilities.upsert.endDate.placeholder": "Seleccionar fecha",
  "productiveFacilities.upsert.renspa.label": "RENSPA",
  "productiveFacilities.upsert.renspa.placeholder": "Ingresar RENSPA",
  "productiveFacilities.upsert.currentRenspa.label": "RENSPA Vigente",
  "productiveFacilities.upsert.currentRenspa.placeholder": "Ingresar vigencia",
  "productiveFacilities.upsert.addNewAffidavit": "Agregar nueva",
  "productiveFacilities.upsert.newAffidavit.title": "Declaraci\xF3n jurada nro {{n}}",
  // Storage facilities
  "explorer.storageFacilities.title": "Acopios",
  "explorer.storageFacilities.addFacility": "Agregar acopio",
  "explorer.storageFacilities.editFacility": "Editar acopio",
  "explorer.storageFacilities.addAffidavit": "Agregar declaraci\xF3n jurada",
  "explorer.storageFacilities.editAffidavit": "Editar declaraci\xF3n jurada",
  "explorer.storageFacilities.getInfo.error": "Error al cargar los acopios",
  "explorer.storageFacilities.emptyState.title": "No hay ning\xFAn acopio agregado.",
  "explorer.storageFacilities.emptyState.description": "Agreg\xE1 un nuevo acopio para registrar toda su informaci\xF3n.",
  "explorer.storageFacilities.deleteFacility.modal.title": "\xBFEst\xE1s seguro de que quieres eliminar el acopio?",
  "explorer.storageFacilities.deleteFacility.modal.text": "No podr\xE1s revertir esta acci\xF3n",
  "explorer.storageFacilities.deleteFacility.success.title": "Acopio eliminado correctamente",
  "explorer.storageFacilities.deleteAffidavit.modal.title": "\xBFEst\xE1s seguro de que quieres eliminar la declaraci\xF3n jurada?",
  "explorer.storageFacilities.deleteAffidavit.modal.text": "No podr\xE1s revertir esta acci\xF3n",
  "explorer.storageFacilities.deleteAffidavit.success.title": "Declaraci\xF3n jurada eliminada correctamente",
  "storageFacilities.accordion.title": "Acopio nro {{n}}",
  "explorer.storageFacilities.affidavitsEmptyState.title": "Todav\xEDa no agregaste ninguna declaraci\xF3n jurada",
  "explorer.storageFacilities.affidavitsEmptyState.description": "Para solicitar aprobaci\xF3n del acopio tenes que cargar una delcaraci\xF3n juarada.",
  "storageFacilities.facilityStatusAlert.PENDING_CHANGE_REQUEST.title": "Ten\xE9s datos a revisar. Hac\xE9 click en 'Editar' para modificar los campos necesarios. Una vez editados, volv\xE9 a solicitar aprobaci\xF3n.",
  "storageFacilities.upsert.identifier.label": "Nro de planta",
  "storageFacilities.upsert.identifier.placeholder": "Ingresar n\xFAmero de planta",
  "explorer.storageFacilities.createFacility.success.title": "Acopio creado correctamente",
  "explorer.storageFacilities.updateFacility.success.title": "Acopio actualizado correctamente",
  "explorer.storageFacilities.createAffidavit.success.title": "Declaraci\xF3n jurada creada correctamente",
  "explorer.storageFacilities.updateAffidavit.success.title": "Declaraci\xF3n jurada actualizada correctamente",
  "explorer.storageFacilities.requestApproval.success.title": "Solicitud de aprobaci\xF3n enviada correctamente",
  "storageFacilities.upsert.province.label": "Provincia",
  "storageFacilities.upsert.province.placeholder": "Seleccionar provincia",
  "storageFacilities.upsert.locality.label": "Localidad",
  "storageFacilities.upsert.locality.placeholder": "Seleccionar localidad",
  "storageFacilities.upsert.locality.noOptionsMessage": "Tu b\xFAsqueda no trajo resultados. Intenta nuevamente.",
  "storageFacilities.upsert.ownership.label": "Titularidad",
  "storageFacilities.upsert.ownership.placeholder": "Seleccionar titularidad",
  "storageFacilities.upsert.storageCapacity.label": "Capacidad de almacenamiento (en toneladas)",
  "storageFacilities.upsert.storageCapacity.placeholder": "Ingresar capacidad",
  "storageFacilities.upsert.rucaStatus.label": "RUCA",
  "storageFacilities.upsert.rucaStatus.placeholder": "Seleccionar vigencia",
  "storageFacilities.upsert.startDate.label": "Fecha de inicio",
  "storageFacilities.upsert.startDate.placeholder": "Seleccionar fecha",
  "storageFacilities.upsert.endDate.label": "Fecha de fin",
  "storageFacilities.upsert.endDate.placeholder": "Seleccionar fecha",
  "storageFacilities.upsert.observations.label": "Observaciones",
  "storageFacilities.upsert.observations.placeholder": "Ingresar observaciones",
  "storageFacilities.upsert.addNewAffidavit": "Agregar nueva",
  "storageFacilities.upsert.newAffidavit.title": "Declaraci\xF3n jurada",
  "backoffice.storageFacilities.approve.success.title": "Establecimiento aprobado exitosamente",
  "backoffice.storageFacilities.requestChanges.success.title": "Solicitud de revisi\xF3n enviada exitosamente",
  "backoffice.storageFacilities.affidavitsEmptyState.title": "Todav\xEDa no se agreg\xF3 la declaraci\xF3n jurada",
  "backoffice.storageFacilities.affidavitsEmptyState.description": "Para aprobar el establecimiento tenes que cargar la declaraci\xF3n jurada.",
  // My Digital Dossier - Equity Information section
  "backoffice.equityInformation.validationMessage.minLength": "Este campo debe tener al menos 3 caracteres",
  "backoffice.equityInformation.validationMessage.maxLength": "Este campo debe tener menos de 200 caracteres",
  "common.equityInformation.balance.title": "Balance",
  "common.equityInformation.add.balance": "Agregar Balance",
  "common.equityInformation.additionalDocument.title": "Documento adicional",
  "common.equityInformation.add.additionalDocument": "Agregar documentaci\xF3n adicional",
  "explorer.equityInformation.toast.success.title": "Tu solicitud de aprobaci\xF3n de Informaci\xF3n patrimonial se envi\xF3 exitosamente.",
  "common.cropPledgeNumber": "Nro de prenda",
  "common.creditor": "Acreedor",
  "common.debtor": "Solicitante",
  "common.expiration": "Vencimiento",
  "cropPledges.freeTheCrop": "Liberar prenda",
  "backoffice.equityInformation.toast.success.title": "La Informaci\xF3n patrimonial se envi\xF3 exitosamente.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_ACTIVE.title": "Ten\xE9s datos a revisar.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_ACTIVE.text": "Hemos registrado que su inscripci\xF3n en RUCA no se encuentra vigente. Por lo tanto, este legajo continuar\xE1 activo \xFAnicamente para las actividades que no requieran esta inscripci\xF3n.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_ACTIVE.title": "RUCA no vigente.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_ACTIVE.text": "La inscripci\xF3n en RUCA no se encuentra vigente. Este legajo continuar\xE1 activo \xFAnicamente para las actividades que no requieran esta inscripci\xF3n.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_EXPIRED.title": "Ten\xE9s datos a revisar.",
  "explorer.digitalDossier.rucaNotCurrentWarning.CLIENT_DOSSIER_REMAINS_EXPIRED.text": "Hemos registrado que tu inscripci\xF3n en RUCA no se encuentra vigente. Dado que tu registro est\xE1 asociado a actividades que requieren esta inscripci\xF3n, tu Legajo quedar\xE1 expirado hasta que se realice la actualizaci\xF3n necesaria por la entidad correspondiente.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_EXPIRED.title": "RUCA no vigente.",
  "explorer.digitalDossier.rucaNotCurrentWarning.VIEWER_DOSSIER_REMAINS_EXPIRED.text": "La inscripci\xF3n en RUCA no se encuentra vigente. Dado que el registro est\xE1 asociado a actividades que requieren esta inscripci\xF3n, este Legajo queda expirado hasta que se realice la actualizaci\xF3n necesaria por la entidad correspondiente.",
  // PRENDA DE CULTIVO
  "errorCode.cropPledge.maritalStatus": "Debe ser un estado civil v\xE1lido",
  "errorCode.cropPledge.nationality": "Debe ser una nacionalidad v\xE1lida",
  "cropPledge.page.title.label": "Prenda #{{cropPledgeNumber}}",
  "cropPledge.page.tab.creditor": "Acreedor",
  "cropPledge.page.tab.debtor": "Solicitante",
  "cropPledge.page.button.create": "Crear prenda",
  "cropPledge.table.column.internalIdentifier": "Nro de prenda",
  "cropPledge.table.column.companyName": "Empresa",
  "cropPledge.table.column.fiscalId": "CUIT",
  "cropPledge.table.column.expirationDate": "Vencimiento",
  "cropPledge.table.column.status": "Estado",
  "cropPledge.table.column.actions": "Acciones",
  "cropPledge.table.button.release": "Marcar como cobrado",
  "cropPledge.form.igj.label": "IGJ/Reg P\xFAblico de comercio",
  "cropPledgeDetails.button.digitalDossier": "Ir a Legajo Digital",
  "cropPledge.actions.approve": "Confirmar prenda",
  "cropPledge.actions.reject": "Rechazar prenda",
  "cropPledge.actions.approve.tooltip.pendingSections.text": "La prenda no puede confirmarse a\xFAn debido a secciones pendientes. Revis\xE1 y aprob\xE1 todas las secciones antes de la aprobaci\xF3n final.",
  "cropPledge.actions.approve.modal.title": "\xBFEst\xE1s seguro de confirmar la prenda?",
  "cropPledge.actions.approve.modal.text": "El monto estimado de producci\xF3n de este establecimiento es de  {{currency}} {{amount}}.",
  "cropPledge.actions.approve.modal.confirmLabel": "Confirmar",
  "cropPledge.actions.reject.modal.title": "\xBFEst\xE1s seguro de querer solicitar la rechazar la prenda?",
  "cropPledge.actions.reject.modal.text": "No se podr\xE1 revertir la acci\xF3n.",
  "cropPledge.actions.reject.modal.confirmLabel": "Rechazar",
  "cropPledge.actions.markAsPaid": "Marcar como cobrado",
  "cropPledge.actions.markAsPaid.modal.title": "\xBFEst\xE1s seguro que quer\xE9s marcar la Prenda como cobrada?",
  "cropPledge.actions.markAsPaid.modal.text": "Al continuar, la Bolsa de Cereales proceder\xE1 a gestionar la liberaci\xF3n de la Prenda en el Registro Prendario y te informaremos sobre cualquier avance en el proceso.",
  "cropPledge.actions.markAsPaid.modal.confirmLabel": "Continuar",
  "cropPledge.actions.markAsPaid.modal.success.title": "La Prenda #{{id}} fue marcada como cobrada exitosamente.",
  "cropPledge.actions.markAsRegistered": "Marcar como registrada",
  "cropPledge.actions.markAsRegistered.modal.title": "\xBFEst\xE1s seguro que quer\xE9s registrar la prenda?",
  "cropPledge.actions.markAsRegistered.modal.text": "Para registrar la prenda, debes cargar el comprobante del registro prendario. Una vez cargado el documento y aprobada la prenda, no podr\xE1s realizar m\xE1s ediciones en ella.",
  "cropPledge.actions.markAsRegistered.modal.file.label": "Prenda registrada",
  "cropPledge.actions.markAsRegistered.modal.confirmLabel": "Registrar",
  "cropPledge.actions.markAsRegistered.modal.success.title": "La solicitud de registro de la Prenda #{{id}} fue realizada con \xE9xito.",
  "cropPledge.actions.release": "Liberar prenda",
  "cropPledge.actions.release.modal.title": "\xBFEst\xE1s seguro que quer\xE9s liberar la prenda?",
  "cropPledge.actions.release.modal.text": "Para marcarla como liberada, debes cargar el comprobante del registro prendario. Una vez cargado el documento y liberada la prenda, no se podr\xE1 volver a usar.",
  "cropPledge.actions.release.modal.file.label": "Comprobante",
  "cropPledge.actions.release.modal.confirmLabel": "Liberar",
  "cropPledge.actions.release.modal.success.title": "La prenda #{{id}} fue liberada exitosamente.",
  "cropPledge.creditor.searchForm.fiscalId.label": "CUIT empresa",
  "cropPledge.creditor.searchForm.fiscalId.placeholder": "Buscar CUIT",
  "cropPledge.reject.toast.success": "La prenda fue rechazada exitosamente",
  "cropPledge.approve.toast.success": "La prenda fue aprobada exitosamente",
  "cropPledge.backoffice.pendingRegistrationAlert.title": "La Prenda #{{id}} a\xFAn no ha sido registrada.",
  "cropPledge.backoffice.pendingRegistrationAlert.description": "Por favor, una vez que cuentes con las firmas del acreedor y del solicitante, procede a registrar la prenda en el registro prendario y marc\xE1 la prenda como registrada en la plataforma. Posteriormente, se abrir\xE1 un modal donde podr\xE1s cargar el comprobante del registro prendario. Ten\xE9 en cuenta que, una vez cargado el comprobante, no podr\xE1s realizar modificaciones.",
  "cropPledge.creditor.lotsAmountAlert.description": "El monto estimado de los lotes a prendar es de {{currency}} {{amount}}.",
  // CROP PLEDGE BACKOFFICE
  "backoffice.cropPledge.alert.title": "La edici\xF3n de datos no est\xE1 disponible en esta secci\xF3n.",
  "backoffice.cropPledge.alert.subtitle": 'Para realizar cambios, dirigete a la secci\xF3n "Legajo Digital", realiz\xE1 la modificaci\xF3n correspondiente y aprobala. Si realizas cambios, el solicitante deber\xE1 crear una nueva prenda para que se apliquen las actualizaciones, ya que la prenda iniciada conservar\xE1 los datos antiguos.',
  // SUCCESS TOASTS
  "explorer.digitalDossier.taxInfo.update.success.toast": "Tu solicitud de aprobaci\xF3n de datos impositivos se envi\xF3 exitosamente",
  "explorer.digitalDossier.legalRepsInfo.update.success.toast": "Tu solicitud de aprobaci\xF3n de representantes legales se envi\xF3 exitosamente",
  "explorer.digitalDossier.formsAndDocsInfo.update.success.toast": "Tu solicitud de aprobaci\xF3n de documentaci\xF3n y formularios se envi\xF3 exitosamente",
  // CROP PLEDGE FARM INFO LEASE CONTRACT TYPES
  "common.LEASE_CONTRACT_TYPES.LEASE.title": "Arrendamiento",
  "common.LEASE_CONTRACT_TYPES.ACCIDENTAL_LEASE.title": "Arrendamiento accidental",
  "common.LEASE_CONTRACT_TYPES.SHARECROPPING.title": "Aparcer\xEDa",
  "common.LEASE_CONTRACT_TYPES.ACCIDENTAL_SHARECROPPING.title": "Aparcer\xEDa accidental",
  "common.LEASE_CONTRACT_TYPES.PERCENTAGE_BASED_FARMING.title": "Agricultura a porcentaje",
  "common.LEASE_CONTRACT_TYPES.ASSOCIATIVE.title": "Asociativo",
  "common.LEASE_CONTRACT_TYPES.FREE_TRANSFER_WITH_USUFRUCT_RIGHTS.title": "Cesi\xF3n gratuita con derecho a usufructo (*)",
  "common.LEASE_CONTRACT_TYPES.PAID_TRANSFER_WITH_USUFRUCT_RIGHTS.title": "Cesi\xF3n onerosa con derecho a usufructo",
  "common.LEASE_CONTRACT_TYPES.JOINT_EXPLOITATION_CONTRACT.title": "Contrato de explotaci\xF3n conjunta",
  "common.LEASE_CONTRACT_TYPES.OTHER.title": "Otro",
  // CROP PLEDGE FARM INFO DETAIL
  // FARM INFO
  "cropPledge.farmInfo.form.identifier.label": "Identificaci\xF3n del campo",
  "cropPledge.farmInfo.form.identifier.placeholder": "Ingresar identificaci\xF3n",
  "cropPledge.farmInfo.form.cadastralNomenclature.label": "Nomenclatura catastral",
  "cropPledge.farmInfo.form.cadastralNomenclature.placeholder": "Ingresar nomenclatura",
  "cropPledge.farmInfo.form.totalHectares.label": "Has totales",
  "cropPledge.farmInfo.form.totalHectares.placeholder": "Ingresar hect\xE1reas",
  "cropPledge.farmInfo.form.province.label": "Provincia",
  "cropPledge.farmInfo.form.province.placeholder": "Ingresar provincia",
  "cropPledge.farmInfo.form.locality.label": "Localidad",
  "cropPledge.farmInfo.form.locality.placeholder": "Ingresar localidad",
  "cropPledge.farmInfo.form.address.label": "Domicilio",
  "cropPledge.farmInfo.form.address.placeholder": "Ingresar calle",
  "cropPledge.farmInfo.form.postalCode.label": "C\xF3digo postal",
  "cropPledge.farmInfo.form.postalCode.placeholder": "Ingresar c\xF3digo postal",
  "cropPledge.farmInfo.form.productionEstimateOfLots.label": "Estimaci\xF3n producci\xF3n lotes a prendar (USD)",
  "cropPledge.farmInfo.form.productionEstimateOfLots.toBeCompletedByBolsa": "Se completar\xE1 cuando Bolsa asigne montos a los lotes",
  "cropPledge.farmInfo.form.geolocation.label": "Geolocalizaci\xF3n",
  "cropPledge.farmInfo.form.geolocation.supportedFileTypes": "KMZ o GeoJSON",
  "cropPledge.farmInfo.form.latitudeOfBarycenter.label": "Latitud del baricentro",
  "cropPledge.farmInfo.form.latitudeOfBarycenter.placeholder": "Ingresar latitud",
  "cropPledge.farmInfo.form.longitudeOfBarycenter.label": "Longitud del baricentro",
  "cropPledge.farmInfo.form.longitudeOfBarycenter.placeholder": "Ingresar longitud",
  // FARM PROPIETARY INFO
  "cropPledge.farmPropietaryData.form.isPropietary.label": "Propietario",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.label": "Documentaci\xF3n adicional",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.helperText": "Esta documentaci\xF3n puede incluir informaci\xF3n sobre propiedad del campo, escritura, arrendamiento, etc., seg\xFAn el tipo de propietario.",
  "cropPledge.farmPropietaryData.form.aditionalDocumentation.add": "Agregar documentaci\xF3n adicional",
  "cropPledge.farmPropietaryData.form.contractType.label": "Tipo de contrato",
  "cropPledge.farmPropietaryData.form.contractType.placeholder": "Seleccionar contrato",
  "cropPledge.farmPropietaryData.form.ownerFiscalId.label": "Titular establecimiento",
  "cropPledge.farmPropietaryData.form.ownerFiscalId.placeholder": "Ingresar CUIT/CUIL",
  "cropPledge.farmPropietaryData.form.activityStartDate.label": "Fecha de inicio",
  "cropPledge.farmPropietaryData.form.activityStartDate.placeholder": "Ingresar fecha",
  "cropPledge.farmPropietaryData.form.activityEndDate.label": "Fecha de fin",
  "cropPledge.farmPropietaryData.form.activityEndDate.placeholder": "Ingresar fecha",
  // LOT AFFIDAVITS INFO
  "cropPledge.lotAffidavitsData.title": "Declaraciones juradas de lotes",
  "cropPledge.lotAffidavitsData.addAffidavit": "Agregar declaraci\xF3n",
  "cropPledge.lotAffidavitsData.lotNumber": "Lote #{{lotNumber}}",
  "cropPledge.lotAffidavitsData.form.lotIdentifier.label": "Identificaci\xF3n del lote",
  "cropPledge.lotAffidavitsData.form.lotIdentifier.placeholder": "Ingresar indentificaci\xF3n",
  "cropPledge.lotAffidavitsData.form.areaPercentage.label": "% del lote sobre la superficie del campo",
  "cropPledge.lotAffidavitsData.form.areaPercentage.placeholder": "Ingrese el porcentaje",
  "cropPledge.lotAffidavitsData.form.geolocation.label": "Geolocalizaci\xF3n",
  "cropPledge.lotAffidavitsData.form.geolocation.supportedFileTypes": "KMZ o GeoJSON",
  "cropPledge.lotAffidavitsData.form.latitudeOfBarycenter.label": "Latitud del baricentro",
  "cropPledge.lotAffidavitsData.form.latitudeOfBarycenter.placeholder": "Ingrese la latitud",
  "cropPledge.lotAffidavitsData.form.longitudeOfBarycenter.label": "Longitud del baricentro",
  "cropPledge.lotAffidavitsData.form.longitudeOfBarycenter.placeholder": "Ingrese la longitud",
  "cropPledge.lotAffidavitsData.form.crop.label": "Cultivo",
  "cropPledge.lotAffidavitsData.form.crop.placeholder": "Seleccionar cultivo",
  "cropPledge.lotAffidavitsData.form.startDate.label": "Fecha de inicio",
  "cropPledge.lotAffidavitsData.form.startDate.placeholder": "Ingresar fecha",
  "cropPledge.lotAffidavitsData.form.endDate.label": "Fecha de fin",
  "cropPledge.lotAffidavitsData.form.endDate.placeholder": "Ingresar fecha",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason.label": "Rinde promedio campa\xF1a anterior",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason.placeholder": "Ingresar promedio",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason1.label": "Rinde promedio campa\xF1a anterior +1",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason1.placeholder": "Ingresar promedio",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason2.label": "Rinde promedio campa\xF1a anterior +2",
  "cropPledge.lotAffidavitsData.form.averageYieldPreviousSeason2.placeholder": "Ingresar promedio",
  "cropPledge.lotAffidavitsData.form.estimatedLotProductionAmount.label": "Monto estimado producci\xF3n lote (USD)",
  "cropPledge.lotAffidavitsData.form.estimatedLotProductionAmount.placeholder": "Ingresar monto",
  // DOCUMENTATION SECTION
  "cropPledge.documentationSection.form.loanContractFile.label": "Contrato de pr\xE9stamo",
  "cropPledge.documentationSection.form.loanContractFile.expirationDateHelperText": "Este vencimiento es del \xFAltimo lote y establece la fecha de caducidad de la prenda.",
  "cropPledge.documentationSection.form.carbonAnalysisFile.label": "An\xE1lisis de carbono",
  "cropPledge.documentationSection.form.domainReportFile.label": "Informe de dominio",
  "cropPledge.documentationSection.form.modificationFormFile.label": "Formulario 6 (Endoso/Modificaci\xF3n)",
  "cropPledge.documentationSection.form.additionalDocumentFiles.label": "Documentaci\xF3n adicional",
  "cropPledge.documentationSection.form.additionalDocumentFiles.add": "Agregar documentaci\xF3n adicional",
  "cropPledge.farmInfo.form.registeredPledgeFile.label": "Prenda registrada",
  "cropPledge.farmInfo.form.deregistrationOfPledgeFile.label": "Baja prenda",
  // PLEDGE INFORMATION SECTION
  "cropPledge.pledgeInformation.form.celebrationProvince.label": "Lugar",
  "cropPledge.pledgeInformation.form.celebrationProvince.placeholder": "Seleccionar lugar",
  "cropPledge.pledgeInformation.form.celebratedAt.label": "Fecha de celebraci\xF3n",
  "cropPledge.pledgeInformation.form.celebratedAt.placeholder": "Ingresar fecha",
  "cropPledge.pledgeInformation.form.pledgeClass.label": "Clase",
  "cropPledge.pledgeInformation.form.pledgeClass.placeholder": "Seleccionar clase",
  "cropPledge.pledgeInformation.form.degree.label": "Grado",
  "cropPledge.pledgeInformation.form.degree.placeholder": "Seleccionar grado",
  "cropPledge.pledgeInformation.form.currency.label": "Tipo de moneda",
  "cropPledge.pledgeInformation.form.currency.placeholder": "Seleccionar moneda",
  "cropPledge.pledgeInformation.form.contractAmount.label": "Monto del contrato",
  "cropPledge.pledgeInformation.form.contractAmount.placeholder": "Ingresar monto",
  "cropPledge.pledgeInformation.form.contractAmountInText.label": "Monto del contrato en texto",
  "cropPledge.pledgeInformation.form.contractAmountInText.placeholder": "Ingresar monto en texto",
  "cropPledge.pledgeInformation.form.exchangeRate.label": "Tipo de cambio",
  "cropPledge.pledgeInformation.form.exchangeRate.placeholder": "Ingresar tipo de cambio",
  "cropPledge.pledgeInformation.form.amountInPesos.label": "Equivalencia en moneda nacional",
  "cropPledge.pledgeInformation.form.amountInPesos.helperText": "La equivalencia se calcula autom\xE1ticamente como monto \xD7 tipo de cambio.",
  "cropPledge.pledgeInformation.form.obligationConcept.label": "Concepto de la obligaci\xF3n",
  "cropPledge.pledgeInformation.form.obligationConcept.placeholder": "Ingresar concepto",
  "cropPledge.pledgeInformation.form.documentation.label": "Documentaci\xF3n",
  "cropPledge.pledgeInformation.form.documentation.placeholder": "Ingresar documentaci\xF3n",
  "cropPledge.pledgeInformation.form.paymentMethodsAndTerms.label": "Forma y plazo de pago",
  "cropPledge.pledgeInformation.form.paymentMethodsAndTerms.placeholder": "Ingresar forma y plazo de pago",
  "cropPledge.pledgeInformation.form.annualInterestRate.label": "Tasa de inter\xE9s anual",
  "cropPledge.pledgeInformation.form.annualInterestRate.placeholder": "Ingresar tasa de inter\xE9s",
  "cropPledge.pledgeInformation.form.paymentProvince.label": "Lugar de pago",
  "cropPledge.pledgeInformation.form.paymentProvince.placeholder": "Seleccionar lugar",
  "cropPledge.pledgeInformation.form.creditorInspectionRights.label": "Derechos de inspecci\xF3n del acreedor",
  "cropPledge.pledgeInformation.form.creditorInspectionRights.placeholder": "Seleccionar derechos",
  "cropPledge.pledgeInformation.form.liens.label": "Grav\xE1menes",
  "cropPledge.pledgeInformation.form.liens.placeholder": "Ingresar grav\xE1menes",
  // PLEDGE INSURANCE INFO SECTION
  "cropPledge.pledgeInsuranceInformation.form.hasInsurance.label": "\xBFLa prenda tiene seguro?",
  "cropPledge.pledgeInsuranceInformation.form.insuranceType.label": "Tipo de seguro",
  "cropPledge.pledgeInsuranceInformation.form.insuranceType.placeholder": "Ingresar tipo de seguro",
  "cropPledge.pledgeInsuranceInformation.form.currency.label": "Tipo de moneda",
  "cropPledge.pledgeInsuranceInformation.form.currency.placeholder": "Seleccionar moneda",
  "cropPledge.pledgeInsuranceInformation.form.amount.label": "Suma",
  "cropPledge.pledgeInsuranceInformation.form.amount.placeholder": "Ingresar suma",
  "cropPledge.pledgeInsuranceInformation.form.insuranceCompany.label": "Compa\xF1\xEDa",
  "cropPledge.pledgeInsuranceInformation.form.insuranceCompany.placeholder": "Ingresar compa\xF1\xEDa",
  "cropPledge.pledgeInsuranceInformation.form.streetName.label": "Calle",
  "cropPledge.pledgeInsuranceInformation.form.streetName.placeholder": "Ingresar calle",
  "cropPledge.pledgeInsuranceInformation.form.streetNumber.label": "N\xFAmero",
  "cropPledge.pledgeInsuranceInformation.form.streetNumber.placeholder": "Ingresar n\xFAmero",
  "cropPledge.pledgeInsuranceInformation.form.province.label": "Provincia",
  "cropPledge.pledgeInsuranceInformation.form.province.placeholder": "Seleccionar provincia",
  "cropPledge.pledgeInsuranceInformation.form.locality.label": "Localidad",
  "cropPledge.pledgeInsuranceInformation.form.locality.placeholder": "Buscar localidad",
  "cropPledge.pledgeInsuranceInformation.form.postalCode.label": "C\xF3digo postal",
  "cropPledge.pledgeInsuranceInformation.form.postalCode.placeholder": "Ingresar c\xF3digo postal",
  "cropPledge.pledgeInsuranceInformation.form.policyNumber.label": "P\xF3liza Nro",
  "cropPledge.pledgeInsuranceInformation.form.policyNumber.placeholder": "Ingresar nro de p\xF3liza"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  locales_EN,
  locales_ES
});
